(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.1/optimize for better performance and smaller assets.');


var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**_UNUSED/
	var node = args['node'];
	//*/
	/**/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle.setProperty(key, styles[key]);
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var view = impl.view;
			/**_UNUSED/
			var domNode = args['node'];
			//*/
			/**/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.setup && impl.setup(sendToApp)
			var view = impl.view;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.onUrlChange;
	var onUrlRequest = impl.onUrlRequest;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), key);
		},
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.querySelector(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.expect.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
		$elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);

		try {
			xhr.open(request.method, request.url, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.url));
		}

		_Http_configureRequest(xhr, request);

		request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
		xhr.send(request.body.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.timeout.a || 0;
	xhr.responseType = request.expect.d;
	xhr.withCredentials = request.allowCookiesFromOtherDomains;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		url: xhr.responseURL,
		statusCode: xhr.status,
		statusText: xhr.statusText,
		headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			sent: event.loaded,
			size: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			received: event.loaded,
			size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $author$project$Main$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Main$OnUrlRequest = function (a) {
	return {$: 'OnUrlRequest', a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0, tail: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 'Normal':
			return 0;
		case 'MayStopPropagation':
			return 1;
		case 'MayPreventDefault':
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 'External', a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 'Internal', a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $elm$url$Url$Http = {$: 'Http'};
var $elm$url$Url$Https = {$: 'Https'};
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Http,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Https,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0.a;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$Here = function (a) {
	return {$: 'Here', a: a};
};
var $author$project$Main$Now = function (a) {
	return {$: 'Now', a: a};
};
var $author$project$Main$SetNickPlaceholder = function (a) {
	return {$: 'SetNickPlaceholder', a: a};
};
var $author$project$Main$Welcome = {$: 'Welcome'};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$Measure$empty = {active: $elm$core$Dict$empty, known: $elm$core$Dict$empty};
var $elm$random$Random$Generate = function (a) {
	return {$: 'Generate', a: a};
};
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 'Seed', a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$time$Time$Name = function (a) {
	return {$: 'Name', a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 'Offset', a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 'Zone', a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = function (a) {
	return {$: 'Posix', a: a};
};
var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0.a;
	return millis;
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0.a;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$Generator = function (a) {
	return {$: 'Generator', a: a};
};
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0.a;
		return $elm$random$Random$Generator(
			function (seed0) {
				var _v1 = genA(seed0);
				var a = _v1.a;
				var seed1 = _v1.b;
				return _Utils_Tuple2(
					func(a),
					seed1);
			});
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0.a;
		return $elm$random$Random$Generate(
			A2($elm$random$Random$map, func, generator));
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			$elm$random$Random$Generate(
				A2($elm$random$Random$map, tagger, generator)));
	});
var $elm$random$Random$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var genA = _v0.a;
		var genB = _v1.a;
		var genC = _v2.a;
		return $elm$random$Random$Generator(
			function (seed0) {
				var _v3 = genA(seed0);
				var a = _v3.a;
				var seed1 = _v3.b;
				var _v4 = genB(seed1);
				var b = _v4.a;
				var seed2 = _v4.b;
				var _v5 = genC(seed2);
				var c = _v5.a;
				var seed3 = _v5.b;
				return _Utils_Tuple2(
					A3(func, a, b, c),
					seed3);
			});
	});
var $author$project$Nicknames$name = 'Lily';
var $author$project$Nicknames$names = _List_fromArray(
	['Ace', 'Alpha', 'Angel', 'Anthony', 'Aqua', 'Arya', 'Ash', 'Asteroid', 'Baby', 'Barbwire', 'Batman', 'Bear', 'Bee', 'Bender', 'Bennet', 'Biff', 'Big', 'Bitsy', 'Black', 'Blaze', 'Bling', 'Bliss', 'Blood', 'Bloom', 'Blueberry', 'Bluff', 'Bond', 'Bonny Lass', 'Boo', 'Bop', 'Boomer', 'Boots', 'Bootsie', 'Bossman', 'Brainiac', 'Brick', 'Bristol', 'Bruise', 'Bug', 'Bunny', 'Business', 'Buster', 'Buttercup', 'Butterfly', 'Cadillac', 'Calamity', 'Captain', 'Carlotta', 'Cascade', 'Catastrophe', 'Caveman', 'Celeste', 'Champ', 'Chaos', 'Chapstick', 'Charms', 'Chemical', 'Chief', 'Chip', 'Chipmunk', 'Chuckles', 'Cobra', 'Cocktail', 'Coco', 'Cold', 'Congeniality', 'Corny', 'Cosma', 'Crashosaurus', 'Creeper', 'Cutie Pie', 'Cutie', 'Cutlass', 'Daddy', 'Danger', 'Danica', 'Dimples', 'Dixie', 'Dizzy', 'Dolly', 'Doofus', 'Doomsday', 'Dottie', 'Dragon', 'Dream', 'Drogo', 'Eagle', 'Eerie', 'Elsa', 'Embargo', 'Empress', 'Enigma', 'Evie', 'Fantastic', 'Fiasco', 'Firecracker', 'Firefly', 'Flash', 'Flower', 'Fluffy', 'Fly', 'Foxy', 'Frostbite', 'Frosty', 'Gamma Ray', 'Gandalf', 'Gargamel', 'Gemma', 'Ghost', 'Giggles', 'Gizmo', 'Glass', 'Glider', 'Glow', 'Goofball', 'Goon', 'Gorgeous', 'Graduate', 'Grandpa', 'Guapo', 'Gummy', 'Gump', 'Guy', 'Hassan', 'Hercules', 'Hero', 'Hiccup', 'Honey', 'Hoops', 'Hotshot', 'Hottie', 'Hulk', 'Iceman', 'Industry', 'Integral', 'Interest', 'Iris', 'Jester', 'Jet', 'Jinx', 'Joker', 'Josie', 'Jules', 'Kabuki', 'Kane', 'Katana', 'Kickflip', 'Kiddo', 'King', 'Kitsune', 'Kitten', 'Kitty', 'Kneecaps', 'Kraken', 'Lady', 'Laser', 'Lemon', 'Lioness', 'Love', 'Lovey', 'Lux', 'Macho', 'Maeve', 'Magenta', 'Maisie', 'Majesty', 'Medusa', 'Melody', 'Meteor', 'Mighty', 'Mimi', 'Mister', 'Misty', 'Mittens', 'Monkey', 'Morgana', 'Mouse', 'Muffin', 'Munchkin', 'Nibbler', 'Nibbles', 'Nikita', 'Ninja', 'Nova', 'Nugget', 'Nuggie', 'Oldie', 'Onyx', 'Oppenheimer', 'Panda', 'Pandora', 'Panther', 'Papa', 'Patootie', 'Peaches', 'Pebbles', 'Pepsi', 'Petra', 'Phoenix', 'Pickle', 'Piggy', 'Pillbox', 'Pirate', 'Pixie', 'Pizza', 'Pokey', 'Pookie', 'Pop', 'Potato Chip', 'Precious', 'Pumpkin', 'Pumps', 'Punk', 'Quinn', 'Quizzical', 'Raccoon', 'Rambo', 'Ranger', 'Rapunzel', 'Razor', 'Reaction', 'Reaper', 'Rebel', 'Renegade', 'River', 'Robot', 'Rock', 'Rocket', 'Rowan', 'Roxanas', 'Roxy', 'Sandstorm', 'Sapphire', 'Satellite', 'Scarface', 'Scorch', 'Scotch', 'Scout', 'Shade', 'Shadow', 'Shady', 'Shark', 'Sharpies', 'Sherlock', 'Shockwave', 'Shortie', 'Sicko', 'Skills', 'Slasher', 'Slayer', 'Slim', 'Smarty', 'Smiley', 'Smoke', 'Smooth', 'Smoothie', 'Snack', 'Snookums', 'Snuggy', 'Socks', 'Sofa', 'Soldier', 'Sourdough', 'Spanky', 'Sparky', 'Specialty', 'Speedy', 'Spelbot', 'Spell', 'Spike', 'Spin', 'Spud', 'Squints', 'Squirt', 'Starch', 'Starry', 'Steel', 'Stone', 'Storm', 'Strange', 'Strawberry', 'Sublimation', 'Sugar', 'Sunshine', 'Sweepstakes', 'Sweetness', 'Sweetums', 'Syncopation', 'Tangerine', 'Tarzan', 'Teacup', 'Technology', 'Teeny', 'Terminator', 'Terror', 'Tessie', 'Thunder', 'Tiger', 'Tiny', 'Toxin', 'Trinity', 'Trixie', 'Tsunami', 'Twinkle', 'Undertaker', 'Venom', 'Venus', 'Vertigo', 'Vex', 'Viking', 'Viper', 'Vivi', 'Voodoo', 'Vulture', 'Waldorf', 'Warhead', 'Whiskers', 'Wholesome', 'Wild', 'Wilderness', 'Windstorm', 'Windy', 'Winky', 'Winner', 'Winter', 'Wisdom', 'Woody', 'Wraith', 'Wrinkles', 'Yankee', 'Yoda', 'Zadie', 'Ziva']);
var $author$project$Nicknames$prefix = _Utils_Tuple2(10, 'Dr ');
var $author$project$Nicknames$prefixes = _List_fromArray(
	[
		_Utils_Tuple2(300, ''),
		_Utils_Tuple2(10, 'Ancient '),
		_Utils_Tuple2(10, 'Big '),
		_Utils_Tuple2(10, 'Captain '),
		_Utils_Tuple2(10, 'Chief '),
		_Utils_Tuple2(10, 'Coach '),
		_Utils_Tuple2(10, 'Fast '),
		_Utils_Tuple2(10, 'Fort '),
		_Utils_Tuple2(10, 'Fresh '),
		_Utils_Tuple2(10, 'Lil '),
		_Utils_Tuple2(10, 'Mayor '),
		_Utils_Tuple2(10, 'Old '),
		_Utils_Tuple2(10, 'Pope '),
		_Utils_Tuple2(10, 'Professor '),
		_Utils_Tuple2(10, 'Sharp '),
		_Utils_Tuple2(10, 'Sick '),
		_Utils_Tuple2(10, 'Silly '),
		_Utils_Tuple2(10, 'Slick '),
		_Utils_Tuple2(10, 'The '),
		_Utils_Tuple2(10, 'Top '),
		_Utils_Tuple2(5, 'Admiral '),
		_Utils_Tuple2(5, 'Calamity '),
		_Utils_Tuple2(5, 'Chef '),
		_Utils_Tuple2(5, 'Chill '),
		_Utils_Tuple2(5, 'Cosmic '),
		_Utils_Tuple2(5, 'Cowboy '),
		_Utils_Tuple2(5, 'Cowgirl '),
		_Utils_Tuple2(5, 'DJ '),
		_Utils_Tuple2(5, 'Famous '),
		_Utils_Tuple2(5, 'Hurricane '),
		_Utils_Tuple2(5, 'Iron '),
		_Utils_Tuple2(5, 'King '),
		_Utils_Tuple2(5, 'MC '),
		_Utils_Tuple2(5, 'Ol\' '),
		_Utils_Tuple2(5, 'Ramblin\' '),
		_Utils_Tuple2(5, 'Reverend '),
		_Utils_Tuple2(5, 'Silent '),
		_Utils_Tuple2(5, 'Silver '),
		_Utils_Tuple2(5, 'Swingin\' '),
		_Utils_Tuple2(5, 'The Real '),
		_Utils_Tuple2(5, 'The Right Honourable '),
		_Utils_Tuple2(5, 'Tricky '),
		_Utils_Tuple2(5, 'Wild '),
		_Utils_Tuple2(5, 'Yung '),
		_Utils_Tuple2(2, 'Grandmaster '),
		_Utils_Tuple2(2, 'Immortal '),
		_Utils_Tuple2(2, 'Saint '),
		_Utils_Tuple2(1, 'Venerable ')
	]);
var $author$project$Nicknames$suffix = _Utils_Tuple2(5, ' Esq');
var $author$project$Nicknames$suffixes = _List_fromArray(
	[
		_Utils_Tuple2(1000, ''),
		_Utils_Tuple2(400, ' II'),
		_Utils_Tuple2(400, ' Jr'),
		_Utils_Tuple2(400, ' PhD'),
		_Utils_Tuple2(100, ' III'),
		_Utils_Tuple2(100, ' Rex'),
		_Utils_Tuple2(50, ' 1989'),
		_Utils_Tuple2(50, ' XII'),
		_Utils_Tuple2(20, ' & Co.'),
		_Utils_Tuple2(20, '.com'),
		_Utils_Tuple2(20, ' et al.'),
		_Utils_Tuple2(20, ' Inc.'),
		_Utils_Tuple2(20, ' of Legend'),
		_Utils_Tuple2(20, ' on Ice'),
		_Utils_Tuple2(20, ' the Elder'),
		_Utils_Tuple2(20, ' the Younger'),
		_Utils_Tuple2(10, ' in Space'),
		_Utils_Tuple2(10, ' of the North'),
		_Utils_Tuple2(10, ' the Ironclad'),
		_Utils_Tuple2(10, ' the Silent'),
		_Utils_Tuple2(1, ' under Cloak of Darkness')
	]);
var $elm$random$Random$addOne = function (value) {
	return _Utils_Tuple2(1, value);
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$float = F2(
	function (a, b) {
		return $elm$random$Random$Generator(
			function (seed0) {
				var seed1 = $elm$random$Random$next(seed0);
				var range = $elm$core$Basics$abs(b - a);
				var n1 = $elm$random$Random$peel(seed1);
				var n0 = $elm$random$Random$peel(seed0);
				var lo = (134217727 & n1) * 1.0;
				var hi = (67108863 & n0) * 1.0;
				var val = ((hi * 134217728.0) + lo) / 9007199254740992.0;
				var scaled = (val * range) + a;
				return _Utils_Tuple2(
					scaled,
					$elm$random$Random$next(seed1));
			});
	});
var $elm$random$Random$getByWeight = F3(
	function (_v0, others, countdown) {
		getByWeight:
		while (true) {
			var weight = _v0.a;
			var value = _v0.b;
			if (!others.b) {
				return value;
			} else {
				var second = others.a;
				var otherOthers = others.b;
				if (_Utils_cmp(
					countdown,
					$elm$core$Basics$abs(weight)) < 1) {
					return value;
				} else {
					var $temp$_v0 = second,
						$temp$others = otherOthers,
						$temp$countdown = countdown - $elm$core$Basics$abs(weight);
					_v0 = $temp$_v0;
					others = $temp$others;
					countdown = $temp$countdown;
					continue getByWeight;
				}
			}
		}
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$random$Random$weighted = F2(
	function (first, others) {
		var normalize = function (_v0) {
			var weight = _v0.a;
			return $elm$core$Basics$abs(weight);
		};
		var total = normalize(first) + $elm$core$List$sum(
			A2($elm$core$List$map, normalize, others));
		return A2(
			$elm$random$Random$map,
			A2($elm$random$Random$getByWeight, first, others),
			A2($elm$random$Random$float, 0, total));
	});
var $elm$random$Random$uniform = F2(
	function (value, valueList) {
		return A2(
			$elm$random$Random$weighted,
			$elm$random$Random$addOne(value),
			A2($elm$core$List$map, $elm$random$Random$addOne, valueList));
	});
var $author$project$Nicknames$generator = A4(
	$elm$random$Random$map3,
	F3(
		function (a, b, c) {
			return _Utils_ap(
				a,
				_Utils_ap(b, c));
		}),
	A2($elm$random$Random$weighted, $author$project$Nicknames$prefix, $author$project$Nicknames$prefixes),
	A2($elm$random$Random$uniform, $author$project$Nicknames$name, $author$project$Nicknames$names),
	A2($elm$random$Random$weighted, $author$project$Nicknames$suffix, $author$project$Nicknames$suffixes));
var $author$project$Main$Announcement = function (a) {
	return {$: 'Announcement', a: a};
};
var $author$project$Announcement$Announcement = F3(
	function (id, message, time) {
		return {id: id, message: message, time: time};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Announcement$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Announcement$Announcement,
	A2($elm$json$Json$Decode$field, 'ID', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'Message', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'Time',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)));
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 'BadStatus_', a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 'BadUrl_', a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 'GoodStatus_', a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
var $elm$http$Http$Receiving = function (a) {
	return {$: 'Receiving', a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 'Sending', a: a};
};
var $elm$http$Http$Timeout_ = {$: 'Timeout_'};
var $elm$core$Maybe$isJust = function (maybe) {
	if (maybe.$ === 'Just') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
					if (right.d.$ === 'RBNode_elm_builtin') {
						if (right.d.a.$ === 'Black') {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor.$ === 'Black') {
			if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === 'RBNode_elm_builtin') {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === 'RBNode_elm_builtin') {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBNode_elm_builtin') {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === 'RBNode_elm_builtin') {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 'BadBody', a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 'BadStatus', a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $elm$http$Http$NetworkError = {$: 'NetworkError'};
var $elm$http$Http$Timeout = {$: 'Timeout'};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.statusCode));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 'Request', a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {reqs: reqs, subs: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (cmd.$ === 'Cancel') {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 'Nothing') {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.tracker;
							if (_v4.$ === 'Nothing') {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.reqs));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.subs)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 'Cancel', a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (cmd.$ === 'Cancel') {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
					body: r.body,
					expect: A2(_Http_mapExpect, func, r.expect),
					headers: r.headers,
					method: r.method,
					timeout: r.timeout,
					tracker: r.tracker,
					url: r.url
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 'MySub', a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{allowCookiesFromOtherDomains: false, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{body: $elm$http$Http$emptyBody, expect: r.expect, headers: _List_Nil, method: 'GET', timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $author$project$Main$getAnnouncement = function (seen) {
	return $elm$http$Http$get(
		{
			expect: A2($elm$http$Http$expectJson, $author$project$Main$Announcement, $author$project$Announcement$decoder),
			url: '/announcement?seen=' + $elm$core$String$fromInt(seen)
		});
};
var $author$project$Main$Cards = function (a) {
	return {$: 'Cards', a: a};
};
var $author$project$Score$Doc = function (a) {
	return {$: 'Doc', a: a};
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Score$words = function (s) {
	return A2(
		$elm$core$List$filter,
		$elm$core$Basics$neq(''),
		A2(
			$elm$core$String$split,
			' ',
			$elm$core$String$toLower(s)));
};
var $author$project$Score$doc = function (s) {
	return $author$project$Score$Doc(
		$author$project$Score$words(s));
};
var $elm$core$Set$Set_elm_builtin = function (a) {
	return {$: 'Set_elm_builtin', a: a};
};
var $elm$core$Set$empty = $elm$core$Set$Set_elm_builtin($elm$core$Dict$empty);
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A3($elm$core$Dict$insert, key, _Utils_Tuple0, dict));
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$HtmlDecoder$allowedBlockTags = $elm$core$Set$fromList(
	_List_fromArray(
		['aside', 'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'ol', 'p', 'pre', 'table', 'ul']));
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (_v0.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$HtmlDecoder$string = function (n) {
	if (n.$ === 'Text') {
		var s = n.a;
		return s;
	} else {
		if (n.a === 'br') {
			return ' ';
		} else {
			var children = n.c;
			return $author$project$HtmlDecoder$stringFragment(children);
		}
	}
};
var $author$project$HtmlDecoder$stringFragment = function (nodes) {
	if (!nodes.b) {
		return '';
	} else {
		if (!nodes.b.b) {
			var node = nodes.a;
			return $author$project$HtmlDecoder$string(node);
		} else {
			var node = nodes.a;
			var rest = nodes.b;
			var space = function () {
				if (node.$ === 'Text') {
					return '';
				} else {
					var tag = node.a;
					return A2($elm$core$Set$member, tag, $author$project$HtmlDecoder$allowedBlockTags) ? ' ' : '';
				}
			}();
			return _Utils_ap(
				$author$project$HtmlDecoder$string(node),
				_Utils_ap(
					space,
					$author$project$HtmlDecoder$stringFragment(rest)));
		}
	}
};
var $author$project$SearchResult$cardFromData = F2(
	function (id, data) {
		var typeText = $author$project$HtmlDecoder$stringFragment(data.cardType);
		var titleText = $author$project$HtmlDecoder$stringFragment(data.title);
		var flavorText = $author$project$HtmlDecoder$stringFragment(data.flavor);
		var creatorText = $author$project$HtmlDecoder$stringFragment(data.creator);
		var cornerText = $author$project$HtmlDecoder$stringFragment(data.corner);
		var bodyText = $author$project$HtmlDecoder$stringFragment(data.body);
		return {
			body: bodyText,
			bodyDoc: $author$project$Score$doc(bodyText),
			cornerDoc: $author$project$Score$doc(cornerText),
			creatorDoc: $author$project$Score$doc(creatorText),
			flavorDoc: $author$project$Score$doc(flavorText),
			id: id,
			title: titleText,
			titleDoc: $author$project$Score$doc(titleText),
			typeDoc: $author$project$Score$doc(typeText),
			wikiId: data.wikiId
		};
	});
var $author$project$Face$Data = function (id) {
	return function (title) {
		return function (cardType) {
			return function (corner) {
				return function (color) {
					return function (imageUrl) {
						return function (body) {
							return function (flavor) {
								return function (creator) {
									return function (bgImageUrl) {
										return function (wikiId) {
											return function (hint) {
												return {bgImageUrl: bgImageUrl, body: body, cardType: cardType, color: color, corner: corner, creator: creator, flavor: flavor, hint: hint, id: id, imageUrl: imageUrl, title: title, wikiId: wikiId};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$HtmlDecoder$Elem = F3(
	function (a, b, c) {
		return {$: 'Elem', a: a, b: b, c: c};
	});
var $author$project$HtmlDecoder$Text = function (a) {
	return {$: 'Text', a: a};
};
var $author$project$HtmlDecoder$common = _List_fromArray(
	['style', 'class', 'style', 'lang', 'dir', 'title', 'tabindex', 'aria-describedby', 'aria-flowto', 'aria-hidden', 'aria-label', 'aria-labelledby', 'aria-owns', 'role', 'about', 'property', 'resource', 'datatype', 'typeof', 'itemid', 'itemprop', 'itemref', 'itemscope', 'itemtype']);
var $author$project$HtmlDecoder$commonSet = $elm$core$Set$fromList($author$project$HtmlDecoder$common);
var $author$project$HtmlDecoder$Attr = F2(
	function (k, v) {
		return {k: k, v: v};
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$HtmlDecoder$decodeAttrNamed = F2(
	function (ok, attr) {
		return A2($elm$core$Set$member, attr, ok) ? A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$Just,
				$author$project$HtmlDecoder$Attr(attr)),
			A2($elm$json$Json$Decode$field, 'Val', $elm$json$Json$Decode$string)) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
	});
var $author$project$HtmlDecoder$decodeAttr = function (ok) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$HtmlDecoder$decodeAttrNamed(ok),
		A2($elm$json$Json$Decode$field, 'Key', $elm$json$Json$Decode$string));
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Extras$Decode$nullableList = function (d) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$nullable(
			$elm$json$Json$Decode$list(d)));
};
var $author$project$HtmlDecoder$block = _Utils_ap(
	$author$project$HtmlDecoder$common,
	_List_fromArray(
		['align']));
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$HtmlDecoder$tableAlign = _List_fromArray(
	['align', 'valign']);
var $author$project$HtmlDecoder$tableCell = _List_fromArray(
	['abbr', 'axis', 'headers', 'scope', 'rowspan', 'colspan', 'nowrap', 'width', 'height', 'bgcolor']);
var $author$project$HtmlDecoder$okTags = A2(
	$elm$core$Dict$map,
	function (_v0) {
		return $elm$core$Set$fromList;
	},
	$elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2('div', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('center', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('span', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('h1', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('h2', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('h3', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('h4', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('h5', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('h6', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('bdo', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('em', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('strong', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('cite', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('dfn', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('code', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('samp', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('kbd', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('var', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('abbr', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'blockquote',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['cite']))),
				_Utils_Tuple2(
				'q',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['cite']))),
				_Utils_Tuple2('sub', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('sup', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('p', $author$project$HtmlDecoder$block),
				_Utils_Tuple2(
				'br',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['clear']))),
				_Utils_Tuple2('wbr', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'pre',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['width']))),
				_Utils_Tuple2(
				'ins',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['cite', 'datetime']))),
				_Utils_Tuple2(
				'del',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['cite', 'datetime']))),
				_Utils_Tuple2(
				'ul',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['type']))),
				_Utils_Tuple2(
				'ol',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['type', 'start', 'reversed']))),
				_Utils_Tuple2(
				'li',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['type', 'value']))),
				_Utils_Tuple2('dl', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('dd', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('dt', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'table',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['summary', 'width', 'border', 'frame', 'rules', 'cellspacing', 'cellpadding', 'align', 'bgcolor']))),
				_Utils_Tuple2('caption', $author$project$HtmlDecoder$block),
				_Utils_Tuple2('thead', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('tfoot', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('tbody', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'colgroup',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['span']))),
				_Utils_Tuple2(
				'col',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['span']))),
				_Utils_Tuple2(
				'tr',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_Utils_ap(
						$author$project$HtmlDecoder$tableAlign,
						_List_fromArray(
							['bgcolor'])))),
				_Utils_Tuple2(
				'td',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_Utils_ap($author$project$HtmlDecoder$tableAlign, $author$project$HtmlDecoder$tableCell))),
				_Utils_Tuple2(
				'th',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_Utils_ap($author$project$HtmlDecoder$tableAlign, $author$project$HtmlDecoder$tableCell))),
				_Utils_Tuple2(
				'img',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['alt', 'src', 'width', 'height', 'srcset']))),
				_Utils_Tuple2(
				'audio',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['controls', 'preload', 'width', 'height']))),
				_Utils_Tuple2(
				'video',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['poster', 'controls', 'preload', 'width', 'height']))),
				_Utils_Tuple2(
				'source',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['type', 'src']))),
				_Utils_Tuple2(
				'track',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['type', 'src', 'srclang', 'kind', 'label']))),
				_Utils_Tuple2('tt', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('b', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('i', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('big', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('small', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('strike', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('s', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('u', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'font',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['size', 'color', 'face']))),
				_Utils_Tuple2(
				'hr',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['width']))),
				_Utils_Tuple2('ruby', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('rb', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('rp', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('rt', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('rtc', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'math',
				_List_fromArray(
					['class', 'style', 'id', 'title'])),
				_Utils_Tuple2('figure', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('figcaption', $author$project$HtmlDecoder$common),
				_Utils_Tuple2('bdi', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'data',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['value']))),
				_Utils_Tuple2(
				'time',
				_Utils_ap(
					$author$project$HtmlDecoder$common,
					_List_fromArray(
						['datetime']))),
				_Utils_Tuple2('mark', $author$project$HtmlDecoder$common),
				_Utils_Tuple2(
				'meta',
				_List_fromArray(
					['itemprop', 'content'])),
				_Utils_Tuple2('aside', $author$project$HtmlDecoder$common)
			])));
var $author$project$HtmlDecoder$decodeNodeHelp = F2(
	function (tag, okAttrs) {
		return A3(
			$elm$json$Json$Decode$map2,
			$author$project$HtmlDecoder$Elem(tag),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$filterMap($elm$core$Basics$identity),
				A2(
					$elm$json$Json$Decode$field,
					'Attrs',
					$author$project$Extras$Decode$nullableList(
						$author$project$HtmlDecoder$decodeAttr(okAttrs)))),
			A2(
				$elm$json$Json$Decode$field,
				'Children',
				$author$project$Extras$Decode$nullableList(
					$author$project$HtmlDecoder$cyclic$decode())));
	});
var $author$project$HtmlDecoder$decodeNodeNamed = function (tag) {
	var _v0 = A2($elm$core$Dict$get, tag, $author$project$HtmlDecoder$okTags);
	if (_v0.$ === 'Just') {
		var okAttrs = _v0.a;
		return A2($author$project$HtmlDecoder$decodeNodeHelp, tag, okAttrs);
	} else {
		return A2($author$project$HtmlDecoder$decodeNodeHelp, 'span', $author$project$HtmlDecoder$commonSet);
	}
};
function $author$project$HtmlDecoder$cyclic$decode() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$HtmlDecoder$cyclic$decodeNode(),
				A2($elm$json$Json$Decode$map, $author$project$HtmlDecoder$Text, $elm$json$Json$Decode$string)
			]));
}
function $author$project$HtmlDecoder$cyclic$decodeNode() {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$HtmlDecoder$decodeNodeNamed,
		A2($elm$json$Json$Decode$field, 'Tag', $elm$json$Json$Decode$string));
}
try {
	var $author$project$HtmlDecoder$decode = $author$project$HtmlDecoder$cyclic$decode();
	$author$project$HtmlDecoder$cyclic$decode = function () {
		return $author$project$HtmlDecoder$decode;
	};
	var $author$project$HtmlDecoder$decodeNode = $author$project$HtmlDecoder$cyclic$decodeNode();
	$author$project$HtmlDecoder$cyclic$decodeNode = function () {
		return $author$project$HtmlDecoder$decodeNode;
	};
} catch ($) {
	throw 'Some top-level definitions from `HtmlDecoder` are causing infinite recursion:\n\n  ┌─────┐\n  │    decode\n  │     ↓\n  │    decodeNode\n  │     ↓\n  │    decodeNodeHelp\n  │     ↓\n  │    decodeNodeNamed\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $author$project$Face$Fit = F3(
	function (sizeTitle, sizeBody, padFlavor) {
		return {padFlavor: padFlavor, sizeBody: sizeBody, sizeTitle: sizeTitle};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Face$decodeFit = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'PadFlavor',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'SizeBody',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'SizeTitle',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Face$Fit))));
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 'RgbaSpace', a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$Char$toUpper = _Char_toUpper;
var $author$project$ColorExtras$unhexdigit = function (c) {
	return ((_Utils_cmp(
		_Utils_chr('0'),
		c) < 1) && (_Utils_cmp(
		c,
		_Utils_chr('9')) < 1)) ? ($elm$core$Char$toCode(c) - $elm$core$Char$toCode(
		_Utils_chr('0'))) : (($elm$core$Char$toCode(
		$elm$core$Char$toUpper(c)) - $elm$core$Char$toCode(
		_Utils_chr('A'))) + 10);
};
var $author$project$ColorExtras$unhex = F2(
	function (hi, lo) {
		return ($author$project$ColorExtras$unhexdigit(hi) * 16) + $author$project$ColorExtras$unhexdigit(lo);
	});
var $author$project$ColorExtras$fromCss = function (s) {
	var _v0 = $elm$core$String$toList(s);
	_v0$2:
	while (true) {
		if ((((_v0.b && ('#' === _v0.a.valueOf())) && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) {
			if (!_v0.b.b.b.b.b) {
				var _v1 = _v0.b;
				var r = _v1.a;
				var _v2 = _v1.b;
				var g = _v2.a;
				var _v3 = _v2.b;
				var b = _v3.a;
				return A3(
					$avh4$elm_color$Color$rgb255,
					A2($author$project$ColorExtras$unhex, r, r),
					A2($author$project$ColorExtras$unhex, g, g),
					A2($author$project$ColorExtras$unhex, b, b));
			} else {
				if ((_v0.b.b.b.b.b.b && _v0.b.b.b.b.b.b.b) && (!_v0.b.b.b.b.b.b.b.b)) {
					var _v4 = _v0.b;
					var rhi = _v4.a;
					var _v5 = _v4.b;
					var rlo = _v5.a;
					var _v6 = _v5.b;
					var ghi = _v6.a;
					var _v7 = _v6.b;
					var glo = _v7.a;
					var _v8 = _v7.b;
					var bhi = _v8.a;
					var _v9 = _v8.b;
					var blo = _v9.a;
					return A3(
						$avh4$elm_color$Color$rgb255,
						A2($author$project$ColorExtras$unhex, rhi, rlo),
						A2($author$project$ColorExtras$unhex, ghi, glo),
						A2($author$project$ColorExtras$unhex, bhi, blo));
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $avh4$elm_color$Color$black;
};
var $author$project$ColorExtras$decoder = A2($elm$json$Json$Decode$map, $author$project$ColorExtras$fromCss, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Extras$Decode$nonempty = function (d) {
	return A2(
		$elm$json$Json$Decode$map,
		function (m) {
			return _Utils_eq(
				m,
				$elm$core$Maybe$Just('')) ? $elm$core$Maybe$Nothing : m;
		},
		$elm$json$Json$Decode$maybe(d));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (_v0.$ === 'Ok') {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (_v1.$ === 'Ok') {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, path, valDecoder, fallback),
			decoder);
	});
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $author$project$ColorExtras$transparent = A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0);
var $author$project$Face$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'Hint',
	$author$project$Face$decodeFit,
	{padFlavor: 0, sizeBody: 0, sizeTitle: 0},
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['WikiID']),
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['Data', 'BackgroundImage']),
			$author$project$Extras$Decode$nonempty($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['Data', 'Creator']),
				$elm$json$Json$Decode$list($author$project$HtmlDecoder$decode),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['Data', 'Flavor']),
					$elm$json$Json$Decode$list($author$project$HtmlDecoder$decode),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['Data', 'Body']),
						$elm$json$Json$Decode$list($author$project$HtmlDecoder$decode),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['Data', 'Image']),
							$author$project$Extras$Decode$nonempty($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['Data', 'Color']),
								$author$project$ColorExtras$decoder,
								$author$project$ColorExtras$transparent,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['Data', 'Corner']),
									$elm$json$Json$Decode$list($author$project$HtmlDecoder$decode),
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
										_List_fromArray(
											['Data', 'Type']),
										$elm$json$Json$Decode$list($author$project$HtmlDecoder$decode),
										_List_Nil,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
											_List_fromArray(
												['Data', 'Title']),
											$elm$json$Json$Decode$list($author$project$HtmlDecoder$decode),
											_List_Nil,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'ID',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$Face$Data)))))))))))));
var $author$project$SearchResult$decodeCard = A3(
	$elm$json$Json$Decode$map2,
	$author$project$SearchResult$cardFromData,
	A2($elm$json$Json$Decode$field, 'ID', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'Front', $author$project$Face$decodeData));
var $author$project$Main$getCards = $elm$http$Http$get(
	{
		expect: A2(
			$elm$http$Http$expectJson,
			$author$project$Main$Cards,
			$elm$json$Json$Decode$list($author$project$SearchResult$decodeCard)),
		url: '/cards'
	});
var $author$project$Main$Decks = function (a) {
	return {$: 'Decks', a: a};
};
var $author$project$Deck$Deck = F4(
	function (id, name, backSample, frontSample) {
		return {backSample: backSample, frontSample: frontSample, id: id, name: name};
	});
var $author$project$Face$FromServer = function (a) {
	return {$: 'FromServer', a: a};
};
var $author$project$Face$decoder = A2($elm$json$Json$Decode$map, $author$project$Face$FromServer, $author$project$Face$decodeData);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Deck$decoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Deck$Deck,
	A2($elm$json$Json$Decode$field, 'ID', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'Name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['Card', 'Back']),
		$author$project$Face$decoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['Card', 'Front']),
		$author$project$Face$decoder));
var $author$project$Main$getDecks = $elm$http$Http$get(
	{
		expect: A2(
			$elm$http$Http$expectJson,
			$author$project$Main$Decks,
			$elm$json$Json$Decode$list($author$project$Deck$decoder)),
		url: '/decks'
	});
var $elm$time$Time$here = _Time_here(_Utils_Tuple0);
var $author$project$Nicknames$initial = $author$project$Nicknames$name;
var $author$project$Main$GotShell = function (a) {
	return {$: 'GotShell', a: a};
};
var $author$project$Main$LoadingGame = {$: 'LoadingGame'};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Point$Point = F2(
	function (a, b) {
		return {$: 'Point', a: a, b: b};
	});
var $author$project$Point$at = F2(
	function (x, y) {
		return A2($author$project$Point$Point, x, y);
	});
var $author$project$Animation$Set = function (a) {
	return {$: 'Set', a: a};
};
var $author$project$Animation$emptySet = $author$project$Animation$Set(
	{immediate: $elm$core$Dict$empty, sequential: _List_Nil});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$Stack$faces = function (_v0) {
	var front = _v0.front;
	var back = _v0.back;
	return _List_fromArray(
		[front, back]);
};
var $author$project$Air$faces = function (air) {
	if (air.$ === 'Stack') {
		var stack = air.a;
		return $author$project$Stack$faces(stack);
	} else {
		var name = air.a;
		return _List_Nil;
	}
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Event$faces = function (ev) {
	var f = function (u) {
		switch (u.$) {
			case 'PlayerAdd':
				return _List_Nil;
			case 'PileUpdate':
				var stack = u.a.stack;
				return $author$project$Stack$faces(stack);
			case 'PileDelete':
				return _List_Nil;
			case 'SelfHandAdd':
				var hand = u.b;
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.face;
					},
					hand);
			case 'SelfHandRemove':
				return _List_Nil;
			case 'SelfAirUpdate':
				var air = u.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Air$faces, air));
			case 'OpponentHandUpdate':
				return _List_Nil;
			case 'OpponentAirUpdate':
				var air = u.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Air$faces, air));
			case 'TokenAdd':
				return _List_Nil;
			case 'TokenRemove':
				return _List_Nil;
			case 'DieUpdate':
				return _List_Nil;
			case 'SelfAirFlip':
				return _List_Nil;
			default:
				return _List_Nil;
		}
	};
	return $elm$core$List$concat(
		A2($elm$core$List$map, f, ev.updates));
};
var $author$project$Shell$eventFaces = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeL, $elm$core$Basics$append, $author$project$Event$faces),
	_List_Nil);
var $author$project$Tid$fromId = function (id) {
	return _Utils_Tuple2(0, id);
};
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Action$DrawCards = function (a) {
	return {$: 'DrawCards', a: a};
};
var $author$project$Selection$Hand = function (a) {
	return {$: 'Hand', a: a};
};
var $author$project$Action$LiftFromPile = F3(
	function (a, b, c) {
		return {$: 'LiftFromPile', a: a, b: b, c: c};
	});
var $author$project$Selection$OpponentAir = function (a) {
	return {$: 'OpponentAir', a: a};
};
var $author$project$Selection$Pile = function (a) {
	return {$: 'Pile', a: a};
};
var $author$project$Event$PileDelete = function (a) {
	return {$: 'PileDelete', a: a};
};
var $author$project$Selection$SelfAir = {$: 'SelfAir'};
var $author$project$Selection$Token = function (a) {
	return {$: 'Token', a: a};
};
var $author$project$Event$TokenRemove = function (a) {
	return {$: 'TokenRemove', a: a};
};
var $author$project$Tid$fromSeq = F2(
	function (seq, index) {
		return _Utils_Tuple2(seq, index);
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Selection$updateOne = F3(
	function (_v0, u, sel) {
		var action = _v0.action;
		var clientSeq = _v0.clientSeq;
		var isSelf = _v0.isSelf;
		var _v1 = _Utils_Tuple2(sel, u);
		_v1$11:
		while (true) {
			_v1$16:
			while (true) {
				if (_v1.a.$ === 'Nothing') {
					switch (_v1.b.$) {
						case 'PileUpdate':
							var _v10 = _v1.a;
							var pile = _v1.b.a;
							return $elm$core$Maybe$Just(
								$author$project$Selection$Pile(pile.tid));
						case 'TokenAdd':
							var _v11 = _v1.a;
							var tid = _v1.b.a.tid;
							return $elm$core$Maybe$Just(
								$author$project$Selection$Token(tid));
						case 'SelfHandAdd':
							if (_v1.b.b.b) {
								var _v12 = _v1.a;
								var _v13 = _v1.b;
								var _v14 = _v13.b;
								var card = _v14.a;
								var cards = _v14.b;
								return $elm$core$Maybe$Just(
									$author$project$Selection$Hand(card.tid));
							} else {
								break _v1$16;
							}
						case 'SelfAirUpdate':
							if (_v1.b.a.$ === 'Just') {
								var _v15 = _v1.a;
								var stack = _v1.b.a.a;
								return $elm$core$Maybe$Just($author$project$Selection$SelfAir);
							} else {
								break _v1$16;
							}
						case 'OpponentAirUpdate':
							if (_v1.b.b.$ === 'Just') {
								var _v16 = _v1.a;
								var _v17 = _v1.b;
								var id = _v17.a;
								return $elm$core$Maybe$Just(
									$author$project$Selection$OpponentAir(id));
							} else {
								break _v1$16;
							}
						default:
							break _v1$16;
					}
				} else {
					switch (_v1.a.a.$) {
						case 'Pile':
							switch (_v1.b.$) {
								case 'SelfHandAdd':
									if (((!_v1.a.a.a.a) && _v1.b.b.b) && (!_v1.b.b.b.b)) {
										var _v2 = _v1.a.a.a;
										var id = _v2.b;
										var _v3 = _v1.b;
										var _v4 = _v3.b;
										var tid = _v4.a.tid;
										return _Utils_eq(
											action,
											$author$project$Action$DrawCards(id)) ? $elm$core$Maybe$Just(
											$author$project$Selection$Hand(tid)) : sel;
									} else {
										break _v1$11;
									}
								case 'SelfAirUpdate':
									if (((!_v1.a.a.a.a) && (_v1.b.a.$ === 'Just')) && (_v1.b.a.a.$ === 'Stack')) {
										var _v5 = _v1.a.a.a;
										var id = _v5.b;
										var _v6 = _v1.b.a.a;
										var n = _v6.a.n;
										var off = _v6.b;
										return _Utils_eq(
											action,
											A3($author$project$Action$LiftFromPile, id, n, off)) ? $elm$core$Maybe$Just($author$project$Selection$SelfAir) : sel;
									} else {
										break _v1$11;
									}
								case 'OpponentAirUpdate':
									if (((!_v1.a.a.a.a) && (_v1.b.b.$ === 'Just')) && (_v1.b.b.a.$ === 'Stack')) {
										var _v7 = _v1.a.a.a;
										var id = _v7.b;
										var _v8 = _v1.b;
										var oppoId = _v8.a;
										var _v9 = _v8.b.a;
										var n = _v9.a.n;
										var off = _v9.b;
										return _Utils_eq(
											action,
											A3($author$project$Action$LiftFromPile, id, n, off)) ? $elm$core$Maybe$Just(
											$author$project$Selection$OpponentAir(oppoId)) : sel;
									} else {
										break _v1$11;
									}
								case 'PileUpdate':
									var tid = _v1.a.a.a;
									var pile = _v1.b.a;
									return (isSelf && _Utils_eq(
										tid,
										A2($author$project$Tid$fromSeq, clientSeq, 0))) ? $elm$core$Maybe$Just(
										$author$project$Selection$Pile(pile.tid)) : sel;
								default:
									break _v1$11;
							}
						case 'Token':
							if (_v1.b.$ === 'TokenAdd') {
								var tid = _v1.a.a.a;
								var token = _v1.b.a;
								return (isSelf && _Utils_eq(
									tid,
									A2($author$project$Tid$fromSeq, clientSeq, 0))) ? $elm$core$Maybe$Just(
									$author$project$Selection$Token(token.tid)) : sel;
							} else {
								var tid = _v1.a.a.a;
								return _Utils_eq(
									u,
									$author$project$Event$TokenRemove(tid)) ? $elm$core$Maybe$Nothing : sel;
							}
						case 'Hand':
							if ((_v1.b.$ === 'SelfHandAdd') && _v1.b.b.b) {
								var tid = _v1.a.a.a;
								var _v18 = _v1.b;
								var _v19 = _v18.b;
								var card = _v19.a;
								return (isSelf && _Utils_eq(
									tid,
									A2($author$project$Tid$fromSeq, clientSeq, 0))) ? $elm$core$Maybe$Just(
									$author$project$Selection$Hand(card.tid)) : sel;
							} else {
								var tid = _v1.a.a.a;
								if (u.$ === 'SelfHandRemove') {
									var tids = u.a;
									return A2($elm$core$List$member, tid, tids) ? $elm$core$Maybe$Nothing : sel;
								} else {
									return sel;
								}
							}
						case 'SelfAir':
							if ((_v1.b.$ === 'SelfAirUpdate') && (_v1.b.a.$ === 'Nothing')) {
								var _v21 = _v1.a.a;
								var _v22 = _v1.b.a;
								return $elm$core$Maybe$Nothing;
							} else {
								break _v1$16;
							}
						case 'OpponentAir':
							if ((_v1.b.$ === 'OpponentAirUpdate') && (_v1.b.b.$ === 'Nothing')) {
								var _v23 = _v1.b;
								var _v24 = _v23.b;
								return $elm$core$Maybe$Nothing;
							} else {
								break _v1$16;
							}
						default:
							break _v1$16;
					}
				}
			}
			return sel;
		}
		var tid = _v1.a.a.a;
		return _Utils_eq(
			u,
			$author$project$Event$PileDelete(tid)) ? $elm$core$Maybe$Nothing : sel;
	});
var $author$project$Selection$updateAll = F2(
	function (ev, sel) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Selection$updateOne(ev),
			sel,
			ev.updates);
	});
var $author$project$Selection$update = F2(
	function (ev, maybeSel) {
		if (maybeSel.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var sel = maybeSel.a;
			return A2(
				$author$project$Selection$updateAll,
				ev,
				A2(
					$author$project$Selection$updateAll,
					ev,
					$elm$core$Maybe$Just(sel)));
		}
	});
var $author$project$Animation$Batch = function (a) {
	return {$: 'Batch', a: a};
};
var $author$project$Animation$batch = function (anims) {
	return $author$project$Animation$Batch(anims);
};
var $author$project$Animation$none = $author$project$Animation$Batch(_List_Nil);
var $author$project$Air$Stack = F3(
	function (a, b, c) {
		return {$: 'Stack', a: a, b: b, c: c};
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Animation$DiceResult = F3(
	function (a, b, c) {
		return {$: 'DiceResult', a: a, b: b, c: c};
	});
var $author$project$Animation$Sequential = F2(
	function (a, b) {
		return {$: 'Sequential', a: a, b: b};
	});
var $author$project$Animation$diceResult = F4(
	function (s, roll, seat, name) {
		return A2(
			$author$project$Animation$Sequential,
			'diceResult.' + s,
			A3($author$project$Animation$DiceResult, roll, seat, name));
	});
var $author$project$Animation$DrawCard = F3(
	function (a, b, c) {
		return {$: 'DrawCard', a: a, b: b, c: c};
	});
var $author$project$Animation$Immediate = F2(
	function (a, b) {
		return {$: 'Immediate', a: a, b: b};
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Stack$draw = F2(
	function (n, stack) {
		return _Utils_update(
			stack,
			{
				n: A2($elm$core$Basics$min, n, stack.n)
			});
	});
var $author$project$Stack$drawnFrom = $author$project$Stack$draw(1);
var $author$project$Animation$drawCard = F3(
	function (s, _v0, dest) {
		var stack = _v0.stack;
		var pos = _v0.pos;
		return A2(
			$author$project$Animation$Immediate,
			'drawCard.' + s,
			A3(
				$author$project$Animation$DrawCard,
				$author$project$Stack$drawnFrom(stack),
				pos,
				dest));
	});
var $author$project$Animation$FlipAwayOppo = F2(
	function (a, b) {
		return {$: 'FlipAwayOppo', a: a, b: b};
	});
var $author$project$Animation$flipAwayOppo = F3(
	function (s, oppoId, air) {
		return A2(
			$author$project$Animation$Immediate,
			'flipAwayOppo.' + s,
			A2($author$project$Animation$FlipAwayOppo, oppoId, air));
	});
var $author$project$Animation$FlipAwaySelf = function (a) {
	return {$: 'FlipAwaySelf', a: a};
};
var $author$project$Animation$flipAwaySelf = F2(
	function (s, air) {
		return A2(
			$author$project$Animation$Immediate,
			'flipAwaySelf.' + s,
			$author$project$Animation$FlipAwaySelf(air));
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Animation$Shuffle = F2(
	function (a, b) {
		return {$: 'Shuffle', a: a, b: b};
	});
var $author$project$Animation$shuffle = F3(
	function (s, p0, p1) {
		return A2(
			$author$project$Animation$Immediate,
			'shuffle.' + s,
			A2($author$project$Animation$Shuffle, p0, p1));
	});
var $author$project$Game$animation = F3(
	function (ev, oldGame, newGame) {
		var id = $elm$core$String$fromInt(ev.serverSeq) + ('.' + $elm$core$String$fromInt(ev.clientSeq));
		var nonpredictable = function () {
			var _v4 = ev.action;
			if (_v4.$ === 'ShufflePile') {
				var idPile = _v4.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Animation$none,
					A3(
						$elm$core$Maybe$map2,
						$author$project$Animation$shuffle(id),
						A2(
							$elm$core$Dict$get,
							$author$project$Tid$fromId(idPile),
							oldGame.piles),
						A2(
							$elm$core$Dict$get,
							$author$project$Tid$fromId(idPile),
							newGame.piles)));
			} else {
				return $author$project$Animation$none;
			}
		}();
		var agentSeat = ev.isSelf ? $elm$core$Maybe$Just(newGame.seat) : A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.seat;
			},
			A2($elm$core$Dict$get, ev.agent, newGame.opponents));
		var predictable = function () {
			var _v1 = ev.action;
			switch (_v1.$) {
				case 'DrawCards':
					var idPile = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Animation$none,
						A3(
							$elm$core$Maybe$map2,
							$author$project$Animation$drawCard(id),
							A2(
								$elm$core$Dict$get,
								$author$project$Tid$fromId(idPile),
								oldGame.piles),
							agentSeat));
				case 'FlipAir':
					var faceUp = _v1.a;
					var f = F2(
						function (anim, air) {
							if ((air.$ === 'Just') && (air.a.$ === 'Stack')) {
								var _v3 = air.a;
								var stack = _v3.a;
								var p = _v3.b;
								var b = _v3.c;
								return (!_Utils_eq(faceUp, stack.faceUp)) ? anim(
									A3($author$project$Air$Stack, stack, p, b)) : $author$project$Animation$none;
							} else {
								return $author$project$Animation$none;
							}
						});
					return ev.isSelf ? A2(
						f,
						$author$project$Animation$flipAwaySelf(id),
						oldGame.air) : A2(
						f,
						A2($author$project$Animation$flipAwayOppo, id, ev.agent),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.air;
							},
							A2($elm$core$Dict$get, ev.agent, oldGame.opponents)));
				default:
					return $author$project$Animation$none;
			}
		}();
		var agentName = ev.isSelf ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.nickname;
			},
			newGame.self) : A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.name;
			},
			A2($elm$core$Dict$get, ev.agent, newGame.opponents));
		var nonpredictableUpdate = function (u) {
			if (u.$ === 'DieUpdate') {
				var roll = u.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Animation$none,
					A3(
						$elm$core$Maybe$map2,
						A2($author$project$Animation$diceResult, id, roll),
						agentSeat,
						agentName));
			} else {
				return $author$project$Animation$none;
			}
		};
		return $author$project$Animation$batch(
			_List_fromArray(
				[
					((ev.serverSeq > 0) && ev.isSelf) ? $author$project$Animation$none : predictable,
					(ev.serverSeq > 0) ? $author$project$Animation$batch(
					_Utils_ap(
						_List_fromArray(
							[nonpredictable]),
						A2($elm$core$List$map, nonpredictableUpdate, ev.updates))) : $author$project$Animation$none
				]));
	});
var $author$project$Game$updatePost = F2(
	function (_v0, g) {
		var serverSeq = _v0.serverSeq;
		return _Utils_update(
			g,
			{nextEvent: serverSeq + 1});
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Stack$flipTo = F2(
	function (faceUp, s) {
		return _Utils_update(
			s,
			{faceUp: faceUp});
	});
var $author$project$Air$flipTo = F2(
	function (faceUp, v) {
		var _v0 = v.air;
		if ((_v0.$ === 'Just') && (_v0.a.$ === 'Stack')) {
			var _v1 = _v0.a;
			var stack = _v1.a;
			var offset = _v1.b;
			return _Utils_update(
				v,
				{
					air: $elm$core$Maybe$Just(
						A3(
							$author$project$Air$Stack,
							A2($author$project$Stack$flipTo, faceUp, stack),
							offset,
							!_Utils_eq(faceUp, stack.faceUp)))
				});
		} else {
			return v;
		}
	});
var $author$project$Opponent$Opponent = F4(
	function (name, seat, ncards, air) {
		return {air: air, name: name, ncards: ncards, seat: seat};
	});
var $author$project$Opponent$new = F2(
	function (name, s) {
		return A4($author$project$Opponent$Opponent, name, s, 0, $elm$core$Maybe$Nothing);
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Hand$remove = F2(
	function (tids, hand) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var tid = _v0.tid;
				return !A2($elm$core$List$member, tid, tids);
			},
			hand);
	});
var $author$project$Opponent$setAir = F2(
	function (air, o) {
		return _Utils_update(
			o,
			{air: air});
	});
var $author$project$Opponent$setNumCards = F2(
	function (n, o) {
		return _Utils_update(
			o,
			{ncards: n});
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Roll$Left = {$: 'Left'};
var $author$project$Roll$Right = {$: 'Right'};
var $author$project$Roll$update = F2(
	function (roll, model) {
		return _Utils_eq(roll.sides, model.left.sides) ? _Utils_update(
			model,
			{last: $author$project$Roll$Left, left: roll}) : ((_Utils_eq(roll.sides, model.right.sides) || _Utils_eq(model.last, $author$project$Roll$Left)) ? _Utils_update(
			model,
			{last: $author$project$Roll$Right, right: roll}) : _Utils_update(
			model,
			{last: $author$project$Roll$Left, left: roll}));
	});
var $author$project$Game$updateState = F3(
	function (isSelf, u, g) {
		switch (u.$) {
			case 'PlayerAdd':
				var id = u.a;
				var name = u.b;
				var seat = u.c;
				if (isSelf) {
					return _Utils_update(
						g,
						{
							seat: seat,
							self: $elm$core$Maybe$Just(
								{id: id, nickname: name})
						});
				} else {
					var o = A2($author$project$Opponent$new, name, seat);
					return _Utils_update(
						g,
						{
							opponents: A3($elm$core$Dict$insert, id, o, g.opponents)
						});
				}
			case 'PileUpdate':
				var p = u.a;
				return _Utils_update(
					g,
					{
						piles: A3($elm$core$Dict$insert, p.tid, p, g.piles)
					});
			case 'PileDelete':
				var tid = u.a;
				return _Utils_update(
					g,
					{
						piles: A2($elm$core$Dict$remove, tid, g.piles)
					});
			case 'SelfHandAdd':
				var pos = u.a;
				var cards = u.b;
				return _Utils_update(
					g,
					{
						hand: function () {
							if (pos.$ === 'Nothing') {
								return _Utils_ap(g.hand, cards);
							} else {
								var i = pos.a;
								return _Utils_ap(
									A2($elm$core$List$take, i, g.hand),
									_Utils_ap(
										cards,
										A2($elm$core$List$drop, i, g.hand)));
							}
						}()
					});
			case 'SelfHandRemove':
				var tids = u.a;
				return _Utils_update(
					g,
					{
						hand: A2($author$project$Hand$remove, tids, g.hand)
					});
			case 'SelfAirUpdate':
				var air = u.a;
				return _Utils_update(
					g,
					{air: air});
			case 'OpponentHandUpdate':
				var id = u.a;
				var n = u.b;
				return _Utils_update(
					g,
					{
						opponents: A3(
							$elm$core$Dict$update,
							id,
							$elm$core$Maybe$map(
								$author$project$Opponent$setNumCards(n)),
							g.opponents)
					});
			case 'OpponentAirUpdate':
				var id = u.a;
				var air = u.b;
				return _Utils_update(
					g,
					{
						opponents: A3(
							$elm$core$Dict$update,
							id,
							$elm$core$Maybe$map(
								$author$project$Opponent$setAir(air)),
							g.opponents)
					});
			case 'TokenAdd':
				var token = u.a;
				var tid = token.tid;
				var name = token.name;
				return _Utils_update(
					g,
					{
						tokens: A3($elm$core$Dict$insert, tid, token, g.tokens)
					});
			case 'TokenRemove':
				var tid = u.a;
				return _Utils_update(
					g,
					{
						tokens: A2($elm$core$Dict$remove, tid, g.tokens)
					});
			case 'DieUpdate':
				var roll = u.a;
				return _Utils_update(
					g,
					{
						dice: A2($author$project$Roll$update, roll, g.dice)
					});
			case 'SelfAirFlip':
				var faceUp = u.a;
				return A2($author$project$Air$flipTo, faceUp, g);
			default:
				var id = u.a;
				var faceUp = u.b;
				return _Utils_update(
					g,
					{
						opponents: A3(
							$elm$core$Dict$update,
							id,
							$elm$core$Maybe$map(
								$author$project$Air$flipTo(faceUp)),
							g.opponents)
					});
		}
	});
var $author$project$Game$update = F2(
	function (ev, g) {
		return function (ng) {
			return _Utils_Tuple2(
				ng,
				A3($author$project$Game$animation, ev, g, ng));
		}(
			A2(
				$author$project$Game$updatePost,
				ev,
				A3(
					$elm$core$List$foldl,
					$author$project$Game$updateState(ev.isSelf),
					g,
					ev.updates)));
	});
var $author$project$Prediction$updateGame = F2(
	function (events, g) {
		var updateOne = F2(
			function (ev, _v1) {
				var g0 = _v1.a;
				var a0 = _v1.b;
				var _v0 = A2($author$project$Game$update, ev, g0);
				var g1 = _v0.a;
				var a1 = _v0.b;
				return _Utils_Tuple2(
					g1,
					$author$project$Animation$batch(
						_List_fromArray(
							[a0, a1])));
			});
		return A3(
			$elm$core$List$foldl,
			updateOne,
			_Utils_Tuple2(g, $author$project$Animation$none),
			events);
	});
var $author$project$Prediction$deriveAnim = function (base) {
	var _v0 = A2($author$project$Prediction$updateGame, base.predictedEvents, base.realGame);
	var g = _v0.a;
	var anim = _v0.b;
	return _Utils_Tuple2(
		{
			base: base,
			game: g,
			selection: A3(
				$elm$core$List$foldl,
				$author$project$Selection$update,
				base.realSelection,
				A2(
					$elm$core$List$filter,
					function (_v1) {
						var clientSeq = _v1.clientSeq;
						return _Utils_cmp(clientSeq, base.realSelectionSeq) > -1;
					},
					base.predictedEvents))
		},
		anim);
};
var $author$project$Prediction$derive = function (base) {
	return $author$project$Prediction$deriveAnim(base).a;
};
var $author$project$Roll$Roll = F2(
	function (sides, value) {
		return {sides: sides, value: value};
	});
var $author$project$Roll$init = {
	last: $author$project$Roll$Right,
	left: A2(
		$author$project$Roll$Roll,
		2,
		$elm$core$Maybe$Just(1)),
	right: A2(
		$author$project$Roll$Roll,
		6,
		$elm$core$Maybe$Just(6))
};
var $author$project$Seat$A = {$: 'A'};
var $author$project$Seat$spectator = $author$project$Seat$A;
var $author$project$Game$init = {air: $elm$core$Maybe$Nothing, dice: $author$project$Roll$init, hand: _List_Nil, nextEvent: 0, opponents: $elm$core$Dict$empty, piles: $elm$core$Dict$empty, seat: $author$project$Seat$spectator, self: $elm$core$Maybe$Nothing, tokens: $elm$core$Dict$empty};
var $author$project$Prediction$init = $author$project$Prediction$derive(
	{predictedEvents: _List_Nil, realGame: $author$project$Game$init, realSelection: $elm$core$Maybe$Nothing, realSelectionSeq: 0});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 'Normal', a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm_community$typed_svg$TypedSvg$Events$on = $elm$virtual_dom$VirtualDom$on;
var $elm_community$typed_svg$TypedSvg$Events$simpleOn = function (name) {
	return function (msg) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Events$on,
			name,
			$elm$virtual_dom$VirtualDom$Normal(
				$elm$json$Json$Decode$succeed(msg)));
	};
};
var $elm_community$typed_svg$TypedSvg$Events$onClick = $elm_community$typed_svg$TypedSvg$Events$simpleOn('click');
var $elm_community$typed_svg$TypedSvg$Events$onMouseDown = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mousedown');
var $author$project$Shell$Events = function (a) {
	return {$: 'Events', a: a};
};
var $author$project$Prediction$bump = function (_v0) {
	var base = _v0.base;
	var inc = function (g) {
		return _Utils_update(
			g,
			{nextEvent: g.nextEvent + 1});
	};
	return $author$project$Prediction$derive(
		_Utils_update(
			base,
			{
				realGame: inc(base.realGame)
			}));
};
var $author$project$Event$Event = F6(
	function (serverSeq, action, clientSeq, agent, isSelf, updates) {
		return {action: action, agent: agent, clientSeq: clientSeq, isSelf: isSelf, serverSeq: serverSeq, updates: updates};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Event$decodeList = function (d) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null(_List_Nil),
				$elm$json$Json$Decode$list(d)
			]));
};
var $author$project$Event$DieUpdate = function (a) {
	return {$: 'DieUpdate', a: a};
};
var $author$project$Event$OpponentAirFlip = F2(
	function (a, b) {
		return {$: 'OpponentAirFlip', a: a, b: b};
	});
var $author$project$Event$OpponentAirUpdate = F2(
	function (a, b) {
		return {$: 'OpponentAirUpdate', a: a, b: b};
	});
var $author$project$Event$OpponentHandUpdate = F2(
	function (a, b) {
		return {$: 'OpponentHandUpdate', a: a, b: b};
	});
var $author$project$Event$PileUpdate = function (a) {
	return {$: 'PileUpdate', a: a};
};
var $author$project$Event$PlayerAdd = F3(
	function (a, b, c) {
		return {$: 'PlayerAdd', a: a, b: b, c: c};
	});
var $author$project$Event$SelfAirFlip = function (a) {
	return {$: 'SelfAirFlip', a: a};
};
var $author$project$Event$SelfAirUpdate = function (a) {
	return {$: 'SelfAirUpdate', a: a};
};
var $author$project$Event$SelfHandAdd = F2(
	function (a, b) {
		return {$: 'SelfHandAdd', a: a, b: b};
	});
var $author$project$Event$SelfHandRemove = function (a) {
	return {$: 'SelfHandRemove', a: a};
};
var $author$project$Event$TokenAdd = function (a) {
	return {$: 'TokenAdd', a: a};
};
var $author$project$Hand$Item = F2(
	function (tid, face) {
		return {face: face, tid: tid};
	});
var $author$project$Tid$decoder = A2($elm$json$Json$Decode$map, $author$project$Tid$fromId, $elm$json$Json$Decode$int);
var $author$project$Hand$decodeItem = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Hand$Item,
	A2($elm$json$Json$Decode$field, 'CardID', $author$project$Tid$decoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['Card', 'Front']),
		$author$project$Face$decoder));
var $author$project$Air$Token = F2(
	function (a, b) {
		return {$: 'Token', a: a, b: b};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Point$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Point$Point,
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$float));
var $author$project$Stack$Stack = F5(
	function (n, front, back, faceUp, rot) {
		return {back: back, faceUp: faceUp, front: front, n: n, rot: rot};
	});
var $author$project$Face$WaitingForPlayer = {$: 'WaitingForPlayer'};
var $author$project$Face$waitingForPlayer = $author$project$Face$WaitingForPlayer;
var $author$project$Stack$decodeFront = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault($author$project$Face$waitingForPlayer),
	$elm$json$Json$Decode$nullable($author$project$Face$decoder));
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Stack$decoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Stack$Stack,
	A2($elm$json$Json$Decode$field, 'NumCards', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'Front', $author$project$Stack$decodeFront),
	A2($elm$json$Json$Decode$field, 'Back', $author$project$Face$decoder),
	A2($elm$json$Json$Decode$field, 'FaceUp', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'Rotation', $elm$json$Json$Decode$int));
var $author$project$Air$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'AirEmpty',
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Air$Stack,
				A2($elm$json$Json$Decode$field, 'AirStack', $author$project$Stack$decoder),
				A2($elm$json$Json$Decode$field, 'AirOffset', $author$project$Point$decoder),
				$elm$json$Json$Decode$succeed(false))),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Air$Token,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['AirToken', 'Name']),
					$elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'AirOffset', $author$project$Point$decoder)))
		]));
var $author$project$Pile$Pile = F4(
	function (tid, stack, pos, lockedBy) {
		return {lockedBy: lockedBy, pos: pos, stack: stack, tid: tid};
	});
var $author$project$Pile$decoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pile$Pile,
	A2($elm$json$Json$Decode$field, 'PileID', $author$project$Tid$decoder),
	A2($elm$json$Json$Decode$field, 'PileStack', $author$project$Stack$decoder),
	A2($elm$json$Json$Decode$field, 'PileXY', $author$project$Point$decoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'PileLockedBy', $elm$json$Json$Decode$int)));
var $author$project$Roll$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Roll$Roll,
	A2($elm$json$Json$Decode$field, 'DieSides', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'DieValue',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int)));
var $author$project$Seat$B = {$: 'B'};
var $author$project$Seat$C = {$: 'C'};
var $author$project$Seat$D = {$: 'D'};
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Seat$fromString = function (s) {
	switch (s) {
		case 'A':
			return $elm$json$Json$Decode$succeed($author$project$Seat$A);
		case 'B':
			return $elm$json$Json$Decode$succeed($author$project$Seat$B);
		case 'C':
			return $elm$json$Json$Decode$succeed($author$project$Seat$C);
		case 'D':
			return $elm$json$Json$Decode$succeed($author$project$Seat$D);
		default:
			return $elm$json$Json$Decode$fail('unknown seat: ' + s);
	}
};
var $author$project$Seat$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Seat$fromString, $elm$json$Json$Decode$string);
var $author$project$Token$Token = F3(
	function (tid, name, pos) {
		return {name: name, pos: pos, tid: tid};
	});
var $author$project$Token$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Token$Token,
	A2($elm$json$Json$Decode$field, 'TokenID', $author$project$Tid$decoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['Token', 'Name']),
		$elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'TokenXY', $author$project$Point$decoder));
var $elm$core$Debug$log = _Debug_log;
var $author$project$Event$decodeUpdateType = function (typ) {
	switch (typ) {
		case 'PlayerAdd':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Event$PlayerAdd,
					A2($elm$json$Json$Decode$field, 'PlayerID', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'PlayerName', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'PlayerSeat', $author$project$Seat$decoder)));
		case 'PileUpdate':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2($elm$json$Json$Decode$map, $author$project$Event$PileUpdate, $author$project$Pile$decoder));
		case 'PileDelete':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Event$PileDelete,
					A2($elm$json$Json$Decode$field, 'PileID', $author$project$Tid$decoder)));
		case 'SelfHandAdd':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Event$SelfHandAdd,
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'HandPos', $elm$json$Json$Decode$int)),
					A2(
						$elm$json$Json$Decode$field,
						'HandCards',
						$author$project$Event$decodeList($author$project$Hand$decodeItem))));
		case 'SelfHandRemove':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Event$SelfHandRemove,
					A2(
						$elm$json$Json$Decode$field,
						'HandCardIDs',
						$elm$json$Json$Decode$list($author$project$Tid$decoder))));
		case 'SelfAirUpdate':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2($elm$json$Json$Decode$map, $author$project$Event$SelfAirUpdate, $author$project$Air$decoder));
		case 'OpponentHandUpdate':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Event$OpponentHandUpdate,
					A2($elm$json$Json$Decode$field, 'PlayerID', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'NumCards', $elm$json$Json$Decode$int)));
		case 'OpponentAirUpdate':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Event$OpponentAirUpdate,
					A2($elm$json$Json$Decode$field, 'PlayerID', $elm$json$Json$Decode$int),
					$author$project$Air$decoder));
		case 'TokenAdd':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2($elm$json$Json$Decode$map, $author$project$Event$TokenAdd, $author$project$Token$decoder));
		case 'TokenRemove':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Event$TokenRemove,
					A2($elm$json$Json$Decode$field, 'TokenID', $author$project$Tid$decoder)));
		case 'DieUpdate':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2($elm$json$Json$Decode$map, $author$project$Event$DieUpdate, $author$project$Roll$decoder));
		case 'SelfAirFlip':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Event$SelfAirFlip,
					A2($elm$json$Json$Decode$field, 'AirFaceUp', $elm$json$Json$Decode$bool)));
		case 'OpponentAirFlip':
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Event$OpponentAirFlip,
					A2($elm$json$Json$Decode$field, 'PlayerID', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'AirFaceUp', $elm$json$Json$Decode$bool)));
		default:
			var _v1 = A2($elm$core$Debug$log, 'unknown update type', typ);
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
	}
};
var $author$project$Event$decodeUpdate = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Event$decodeUpdateType,
	A2($elm$json$Json$Decode$field, 'Type', $elm$json$Json$Decode$string));
var $author$project$Action$ChooseDeck = function (a) {
	return {$: 'ChooseDeck', a: a};
};
var $author$project$Action$CreateToken = function (a) {
	return {$: 'CreateToken', a: a};
};
var $author$project$Action$DuplicatePile = function (a) {
	return {$: 'DuplicatePile', a: a};
};
var $author$project$Action$EditPileBegin = function (a) {
	return {$: 'EditPileBegin', a: a};
};
var $author$project$Action$FlipAir = function (a) {
	return {$: 'FlipAir', a: a};
};
var $author$project$Action$FlipPile = function (a) {
	return {$: 'FlipPile', a: a};
};
var $author$project$Action$JoinGame = {$: 'JoinGame'};
var $author$project$Action$PickUpFromHand = F2(
	function (a, b) {
		return {$: 'PickUpFromHand', a: a, b: b};
	});
var $author$project$Action$PickUpFromTable = F2(
	function (a, b) {
		return {$: 'PickUpFromTable', a: a, b: b};
	});
var $author$project$Action$PickUpToken = F2(
	function (a, b) {
		return {$: 'PickUpToken', a: a, b: b};
	});
var $author$project$Action$PutInHand = function (a) {
	return {$: 'PutInHand', a: a};
};
var $author$project$Action$PutOnPile = function (a) {
	return {$: 'PutOnPile', a: a};
};
var $author$project$Action$PutOnTable = F2(
	function (a, b) {
		return {$: 'PutOnTable', a: a, b: b};
	});
var $author$project$Action$RemovePile = function (a) {
	return {$: 'RemovePile', a: a};
};
var $author$project$Action$RemoveToken = function (a) {
	return {$: 'RemoveToken', a: a};
};
var $author$project$Action$RollDie = function (a) {
	return {$: 'RollDie', a: a};
};
var $author$project$Action$RotatePile = function (a) {
	return {$: 'RotatePile', a: a};
};
var $author$project$Action$ShufflePile = function (a) {
	return {$: 'ShufflePile', a: a};
};
var $author$project$Action$SummonCard = function (a) {
	return {$: 'SummonCard', a: a};
};
var $author$project$Action$decodeHelp = function (typ) {
	switch (typ) {
		case 'join game':
			return $elm$json$Json$Decode$succeed($author$project$Action$JoinGame);
		case 'draw':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$DrawCards,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		case 'lift from pile':
			return A4(
				$elm$json$Json$Decode$map3,
				$author$project$Action$LiftFromPile,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'LiftNum', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'AirOffset', $author$project$Point$decoder));
		case 'pick up from table':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Action$PickUpFromTable,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'AirOffset', $author$project$Point$decoder));
		case 'pick up from hand':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Action$PickUpFromHand,
				A2(
					$elm$json$Json$Decode$field,
					'HandCardIDs',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
				A2($elm$json$Json$Decode$field, 'AirOffset', $author$project$Point$decoder));
		case 'pick up token':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Action$PickUpToken,
				A2($elm$json$Json$Decode$field, 'TokenID', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'AirOffset', $author$project$Point$decoder));
		case 'put on table':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Action$PutOnTable,
				A2($elm$json$Json$Decode$field, 'XY', $author$project$Point$decoder),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'FaceUp', $elm$json$Json$Decode$bool))));
		case 'put on pile':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$PutOnPile,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		case 'put in hand':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$PutInHand,
				A2($elm$json$Json$Decode$field, 'HandPos', $elm$json$Json$Decode$int));
		case 'shuffle':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$ShufflePile,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		case 'flip pile':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$FlipPile,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		case 'flip air':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$FlipAir,
				A2($elm$json$Json$Decode$field, 'FaceUp', $elm$json$Json$Decode$bool));
		case 'rotate pile':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$RotatePile,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		case 'duplicate pile':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$DuplicatePile,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		case 'remove pile':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$RemovePile,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		case 'create token':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$CreateToken,
				A2($elm$json$Json$Decode$field, 'TokenName', $elm$json$Json$Decode$string));
		case 'remove token':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$RemoveToken,
				A2($elm$json$Json$Decode$field, 'TokenID', $elm$json$Json$Decode$int));
		case 'roll die':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$RollDie,
				A2($elm$json$Json$Decode$field, 'DieSides', $elm$json$Json$Decode$int));
		case 'summon card':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$SummonCard,
				A2($elm$json$Json$Decode$field, 'CardID', $elm$json$Json$Decode$int));
		case 'choose deck':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$ChooseDeck,
				A2($elm$json$Json$Decode$field, 'DeckID', $elm$json$Json$Decode$int));
		case 'edit pile begin':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Action$EditPileBegin,
				A2($elm$json$Json$Decode$field, 'PileID', $elm$json$Json$Decode$int));
		default:
			return $elm$json$Json$Decode$fail('unknown action type: ' + typ);
	}
};
var $author$project$Action$decoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Action$decodeHelp,
	A2($elm$json$Json$Decode$field, 'Action', $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Event$decoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Event$Event,
	A2($elm$json$Json$Decode$field, 'ServerSeq', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'Action', $author$project$Action$decoder),
	A2($elm$json$Json$Decode$field, 'ClientSeq', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'Agent', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'IsSelf', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'Updates',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$author$project$Event$decodeList($author$project$Event$decodeUpdate))));
var $author$project$Shell$getEvents = F2(
	function (gameId, n) {
		return $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					$elm$core$Basics$identity,
					$elm$json$Json$Decode$list($author$project$Event$decoder)),
				url: '/gameapi/events?g=' + (gameId + ('&n=' + $elm$core$String$fromInt(n)))
			});
	});
var $author$project$Animation$insert = F2(
	function (anim, _v0) {
		var a = _v0.a;
		switch (anim.$) {
			case 'Batch':
				var list = anim.a;
				return A3(
					$elm$core$List$foldl,
					$author$project$Animation$insert,
					$author$project$Animation$Set(a),
					list);
			case 'Immediate':
				var id = anim.a;
				var info = anim.b;
				return $author$project$Animation$Set(
					_Utils_update(
						a,
						{
							immediate: A3($elm$core$Dict$insert, id, info, a.immediate)
						}));
			default:
				var id = anim.a;
				var info = anim.b;
				return $author$project$Animation$Set(
					_Utils_update(
						a,
						{
							sequential: _Utils_ap(
								a.sequential,
								_List_fromArray(
									[
										_Utils_Tuple2(id, info)
									]))
						}));
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Shell$GotIceConfig = F2(
	function (a, b) {
		return {$: 'GotIceConfig', a: a, b: b};
	});
var $author$project$Shell$startWebRtcOnJoin = F3(
	function (gameId, was, now) {
		var _v0 = _Utils_Tuple2(was.self, now.self);
		if ((_v0.a.$ === 'Nothing') && (_v0.b.$ === 'Just')) {
			var _v1 = _v0.a;
			var id = _v0.b.a.id;
			return $elm$http$Http$get(
				{
					expect: A2(
						$elm$http$Http$expectJson,
						$author$project$Shell$GotIceConfig(id),
						$elm$json$Json$Decode$value),
					url: '/gameapi/ice-config?g=' + gameId
				});
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Prediction$eventsSeqs = function (events) {
	return $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.clientSeq;
			},
			events));
};
var $author$project$Prediction$filter = F2(
	function (seqs, base) {
		var resolved = function (_v0) {
			var clientSeq = _v0.clientSeq;
			return A2($elm$core$Set$member, clientSeq, seqs);
		};
		return _Utils_update(
			base,
			{
				predictedEvents: A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, resolved),
					base.predictedEvents)
			});
	});
var $author$project$Prediction$update = F2(
	function (events, _v0) {
		var base = _v0.base;
		var _v1 = A2($author$project$Prediction$updateGame, events, base.realGame);
		var g = _v1.a;
		var anim = _v1.b;
		return _Utils_Tuple2(
			$author$project$Prediction$derive(
				A2(
					$author$project$Prediction$filter,
					$author$project$Prediction$eventsSeqs(events),
					_Utils_update(
						base,
						{
							realGame: g,
							realSelection: A3($elm$core$List$foldl, $author$project$Selection$update, base.realSelection, events)
						}))),
			anim);
	});
var $author$project$Shell$updateEvents = F3(
	function (_v0, h, events) {
		var animate = _v0.animate;
		var _v1 = _Utils_eq(events, _List_Nil) ? _Utils_Tuple2(
			$author$project$Prediction$bump(h.state),
			$author$project$Animation$none) : A2($author$project$Prediction$update, events, h.state);
		var st = _v1.a;
		var anim = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				h,
				{
					animations: animate ? A2($author$project$Animation$insert, anim, h.animations) : h.animations,
					state: st
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Shell$Events,
						A2($author$project$Shell$getEvents, h.id, st.base.realGame.nextEvent)),
						A3($author$project$Shell$startWebRtcOnJoin, h.id, h.state.game, st.game)
					])));
	});
var $author$project$Shell$fromEvents = F2(
	function (_v0, events) {
		var id = _v0.id;
		var clientId = _v0.clientId;
		var nick = _v0.nick;
		var selectOnPointerDown = _v0.selectOnPointerDown;
		var _v1 = A3(
			$author$project$Shell$updateEvents,
			{animate: false},
			{
				animations: $author$project$Animation$emptySet,
				clientId: clientId,
				drag: $elm$core$Maybe$Nothing,
				formSearch: '',
				id: id,
				indexCards: $elm$core$Maybe$Nothing,
				indexDecks: $elm$core$Maybe$Nothing,
				liftHover: false,
				liftNum: 1,
				liftPile: $author$project$Tid$fromId(0),
				nextSeq: 1,
				nick: nick,
				nickPlaceholder: '',
				onSelect: selectOnPointerDown ? $elm_community$typed_svg$TypedSvg$Events$onMouseDown : $elm_community$typed_svg$TypedSvg$Events$onClick,
				peerLifts: $elm$core$Dict$empty,
				pointerCapture: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
				pointerDownPos: A2($author$project$Point$at, 0, 0),
				pointerNoteSentAt: $elm$time$Time$millisToPosix(0),
				pointers: $elm$core$Dict$empty,
				recentlySummoned: _List_Nil,
				rollCustomInput: '',
				rollMore: false,
				searchResults: _List_Nil,
				state: $author$project$Prediction$init
			},
			events);
		var h = _v1.a;
		var c = _v1.b;
		return {
			cmd: c,
			faces: $author$project$Shell$eventFaces(events),
			shell: h
		};
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (ra.$ === 'Ok') {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Shell$init = F2(
	function (tag, config) {
		return A2(
			$elm$core$Platform$Cmd$map,
			tag,
			A2(
				$elm$core$Platform$Cmd$map,
				$elm$core$Result$map(
					$author$project$Shell$fromEvents(config)),
				A2($author$project$Shell$getEvents, config.id, 0)));
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Main$updateUrl = F2(
	function (url, m) {
		var path = url.path;
		var _v0 = A2($elm$core$String$split, '/', path);
		_v0$2:
		while (true) {
			if ((_v0.b && (_v0.a === '')) && _v0.b.b) {
				if (!_v0.b.b.b) {
					if (_v0.b.a === '') {
						var _v1 = _v0.b;
						return _Utils_Tuple2(
							_Utils_update(
								m,
								{state: $author$project$Main$Welcome}),
							$elm$core$Platform$Cmd$none);
					} else {
						break _v0$2;
					}
				} else {
					if ((_v0.b.a === 'game') && (!_v0.b.b.b.b)) {
						var _v2 = _v0.b;
						var _v3 = _v2.b;
						var id = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								m,
								{state: $author$project$Main$LoadingGame}),
							A2(
								$author$project$Shell$init,
								$author$project$Main$GotShell,
								{
									clientId: m.flags.clientId,
									id: id,
									nick: m.nick,
									selectOnPointerDown: A2($elm$core$String$contains, 'Windows', m.flags.userAgent)
								}));
					} else {
						break _v0$2;
					}
				}
			} else {
				break _v0$2;
			}
		}
		return _Utils_Tuple2(
			m,
			A2($elm$browser$Browser$Navigation$replaceUrl, m.key, '/'));
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var _v0 = A2(
			$author$project$Main$updateUrl,
			url,
			{
				announcement: $elm$core$Maybe$Nothing,
				availableCards: $elm$core$Maybe$Nothing,
				availableDecks: $elm$core$Maybe$Nothing,
				flags: flags,
				key: key,
				measures: $author$project$Measure$empty,
				nick: flags.nickname,
				nickPlaceholder: $author$project$Nicknames$initial,
				now: $elm$time$Time$millisToPosix(0),
				state: $author$project$Main$Welcome,
				tz: $elm$time$Time$utc
			});
		var m = _v0.a;
		var c = _v0.b;
		return _Utils_Tuple2(
			m,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						c,
						$author$project$Main$getDecks,
						$author$project$Main$getCards,
						$author$project$Main$getAnnouncement(0),
						A2($elm$core$Task$perform, $author$project$Main$Now, $elm$time$Time$now),
						A2($elm$core$Task$perform, $author$project$Main$Here, $elm$time$Time$here),
						A2($elm$random$Random$generate, $author$project$Main$SetNickPlaceholder, $author$project$Nicknames$generator)
					])));
	});
var $author$project$Main$Shell = function (a) {
	return {$: 'Shell', a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 'Every', a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {processes: processes, taggers: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 'Nothing') {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.processes;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(_Utils_Tuple0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.taggers);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Main$noteToPeer = _Platform_incomingPort(
	'noteToPeer',
	A2(
		$elm$json$Json$Decode$andThen,
		function (to) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (body) {
					return $elm$json$Json$Decode$succeed(
						{body: body, to: to});
				},
				A2($elm$json$Json$Decode$field, 'body', $elm$json$Json$Decode$value));
		},
		A2($elm$json$Json$Decode$field, 'to', $elm$json$Json$Decode$int)));
var $author$project$Main$peerPointerPos = _Platform_incomingPort('peerPointerPos', $elm$json$Json$Decode$value);
var $author$project$Shell$KeyDown = function (a) {
	return {$: 'KeyDown', a: a};
};
var $author$project$Shell$ModKeyDown = function (a) {
	return {$: 'ModKeyDown', a: a};
};
var $author$project$Shell$ModKeyUp = function (a) {
	return {$: 'ModKeyUp', a: a};
};
var $author$project$Shell$NoteToPost = function (a) {
	return {$: 'NoteToPost', a: a};
};
var $author$project$Shell$NumKeyDown = function (a) {
	return {$: 'NumKeyDown', a: a};
};
var $author$project$Shell$NumKeyUp = function (a) {
	return {$: 'NumKeyUp', a: a};
};
var $author$project$Shell$PeerPointer = function (a) {
	return {$: 'PeerPointer', a: a};
};
var $author$project$Peer$Pointer = F2(
	function (peer, pos) {
		return {peer: peer, pos: pos};
	});
var $author$project$Peer$decodePointer = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Peer$Pointer,
	A2($elm$json$Json$Decode$field, 'from', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'pos',
		$elm$json$Json$Decode$maybe($author$project$Point$decoder)));
var $author$project$Keyboard$code = A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string);
var $elm$browser$Browser$Events$Document = {$: 'Document'};
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 'MySub', a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {pids: pids, subs: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (node.$ === 'Document') {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {event: event, key: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (node.$ === 'Document') {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.pids,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.key;
		var event = _v0.event;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.subs);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'keydown');
var $author$project$Keyboard$onKeyDown = function (tag) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2($elm$json$Json$Decode$map, tag, $author$project$Keyboard$code));
};
var $author$project$Keyboard$Alt = {$: 'Alt'};
var $author$project$Keyboard$Control = {$: 'Control'};
var $author$project$Keyboard$Meta = {$: 'Meta'};
var $author$project$Keyboard$Shift = {$: 'Shift'};
var $author$project$Keyboard$decodeMod = function (s) {
	switch (s) {
		case 'AltLeft':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Alt);
		case 'AltRight':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Alt);
		case 'ControlLeft':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Control);
		case 'ControlRight':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Control);
		case 'MetaLeft':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Meta);
		case 'MetaRight':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Meta);
		case 'ShiftLeft':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Shift);
		case 'ShiftRight':
			return $elm$json$Json$Decode$succeed($author$project$Keyboard$Shift);
		default:
			return $elm$json$Json$Decode$fail('not a modifier key');
	}
};
var $author$project$Keyboard$onModKeyDown = function (tag) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2(
			$elm$json$Json$Decode$map,
			tag,
			A2($elm$json$Json$Decode$andThen, $author$project$Keyboard$decodeMod, $author$project$Keyboard$code)));
};
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'keyup');
var $author$project$Keyboard$onModKeyUp = function (tag) {
	return $elm$browser$Browser$Events$onKeyUp(
		A2(
			$elm$json$Json$Decode$map,
			tag,
			A2($elm$json$Json$Decode$andThen, $author$project$Keyboard$decodeMod, $author$project$Keyboard$code)));
};
var $author$project$Keyboard$decodeNum = function (s) {
	var _v0 = $elm$core$String$toList(s);
	if (((((((((((_v0.b && ('D' === _v0.a.valueOf())) && _v0.b.b) && ('i' === _v0.b.a.valueOf())) && _v0.b.b.b) && ('g' === _v0.b.b.a.valueOf())) && _v0.b.b.b.b) && ('i' === _v0.b.b.b.a.valueOf())) && _v0.b.b.b.b.b) && ('t' === _v0.b.b.b.b.a.valueOf())) && _v0.b.b.b.b.b.b) && (!_v0.b.b.b.b.b.b.b)) {
		var _v1 = _v0.b;
		var _v2 = _v1.b;
		var _v3 = _v2.b;
		var _v4 = _v3.b;
		var _v5 = _v4.b;
		var c = _v5.a;
		return ((_Utils_cmp(
			_Utils_chr('0'),
			c) < 1) && (_Utils_cmp(
			c,
			_Utils_chr('9')) < 1)) ? $elm$json$Json$Decode$succeed(
			$elm$core$Char$toCode(c) - $elm$core$Char$toCode(
				_Utils_chr('0'))) : $elm$json$Json$Decode$fail('not a digit');
	} else {
		return $elm$json$Json$Decode$fail('not a digit');
	}
};
var $author$project$Keyboard$noRepeat = function (v) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (rep) {
			return rep ? $elm$json$Json$Decode$fail('repeated') : $elm$json$Json$Decode$succeed(v);
		},
		A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool));
};
var $author$project$Keyboard$onNumKeyDown = function (tag) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2(
			$elm$json$Json$Decode$map,
			tag,
			A2(
				$elm$json$Json$Decode$andThen,
				$author$project$Keyboard$noRepeat,
				A2($elm$json$Json$Decode$andThen, $author$project$Keyboard$decodeNum, $author$project$Keyboard$code))));
};
var $author$project$Keyboard$onNumKeyUp = function (tag) {
	return $elm$browser$Browser$Events$onKeyUp(
		A2(
			$elm$json$Json$Decode$map,
			tag,
			A2($elm$json$Json$Decode$andThen, $author$project$Keyboard$decodeNum, $author$project$Keyboard$code)));
};
var $author$project$Shell$subscriptions = F2(
	function (ports, h) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Keyboard$onKeyDown($author$project$Shell$KeyDown),
					$author$project$Keyboard$onModKeyDown($author$project$Shell$ModKeyDown),
					$author$project$Keyboard$onModKeyUp($author$project$Shell$ModKeyUp),
					$author$project$Keyboard$onNumKeyDown($author$project$Shell$NumKeyDown),
					$author$project$Keyboard$onNumKeyUp($author$project$Shell$NumKeyUp),
					ports.noteToPeer($author$project$Shell$NoteToPost),
					ports.peerPointerPos(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Shell$PeerPointer,
						$elm$json$Json$Decode$decodeValue($author$project$Peer$decodePointer)))
				]));
	});
var $author$project$Main$subscriptions = function (_v0) {
	var state = _v0.state;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Main$Now),
				function () {
				switch (state.$) {
					case 'Welcome':
						return $elm$core$Platform$Sub$none;
					case 'StartingGame':
						return $elm$core$Platform$Sub$none;
					case 'LoadingGame':
						return $elm$core$Platform$Sub$none;
					default:
						var shell = state.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Main$Shell,
							A2(
								$author$project$Shell$subscriptions,
								{noteToPeer: $author$project$Main$noteToPeer, peerPointerPos: $author$project$Main$peerPointerPos},
								shell));
				}
			}()
			]));
};
var $author$project$Main$Measured = function (a) {
	return {$: 'Measured', a: a};
};
var $author$project$Main$Playing = function (a) {
	return {$: 'Playing', a: a};
};
var $author$project$Main$StartingGame = {$: 'StartingGame'};
var $author$project$Measure$Header = function (a) {
	return {$: 'Header', a: a};
};
var $author$project$Face$serverData = function (face) {
	if (face.$ === 'FromServer') {
		var data = face.a;
		return $elm$core$Maybe$Just(data);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Measure$Done = function (a) {
	return {$: 'Done', a: a};
};
var $author$project$Measure$Save = function (a) {
	return {$: 'Save', a: a};
};
var $author$project$Measure$Body = function (a) {
	return {$: 'Body', a: a};
};
var $author$project$Measure$FlavorInit = function (a) {
	return {$: 'FlavorInit', a: a};
};
var $author$project$Measure$bodyNext = F2(
	function (spec, height) {
		var fit = spec.fit;
		return ((height > 336) && (fit.sizeBody < 3)) ? $author$project$Measure$Body(
			_Utils_update(
				spec,
				{
					fit: _Utils_update(
						fit,
						{sizeBody: fit.sizeBody + 1})
				})) : $author$project$Measure$FlavorInit(spec);
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $author$project$Face$encodeFit = function (fit) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'SizeTitle',
				$elm$json$Json$Encode$int(fit.sizeTitle)),
				_Utils_Tuple2(
				'SizeBody',
				$elm$json$Json$Encode$int(fit.sizeBody)),
				_Utils_Tuple2(
				'PadFlavor',
				$elm$json$Json$Encode$int(fit.padFlavor))
			]));
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(_Utils_Tuple0);
			}));
};
var $author$project$Measure$FlavorTest = F4(
	function (a, b, c, d) {
		return {$: 'FlavorTest', a: a, b: b, c: c, d: d};
	});
var $author$project$Face$mainMargin = 16;
var $author$project$Face$size = {height: 336, width: 240};
var $author$project$Face$maxFlavorPadding = (($author$project$Face$size.width - (2 * $author$project$Face$mainMargin)) / 4) | 0;
var $author$project$Measure$flavorInitNext = F2(
	function (spec, height) {
		return A4($author$project$Measure$FlavorTest, height, spec, 0, $author$project$Face$maxFlavorPadding);
	});
var $author$project$Measure$flavorTestNext = F5(
	function (ref, spec, lo, hi, height) {
		return (_Utils_cmp(height, ref) > 0) ? A4($author$project$Measure$FlavorTest, ref, spec, lo, spec.fit.padFlavor) : A4($author$project$Measure$FlavorTest, ref, spec, spec.fit.padFlavor + 1, hi);
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Measure$key = function (_v0) {
	var data = _v0.data;
	var fit = _v0.fit;
	return A2(
		$elm$core$String$join,
		'_',
		_List_fromArray(
			[
				'm' + $elm$core$String$fromInt(data.id),
				'L' + $elm$core$String$fromInt(fit.sizeTitle),
				'L' + $elm$core$String$fromInt(fit.sizeBody)
			]));
};
var $elm$core$Task$onError = _Scheduler_onError;
var $author$project$Measure$getHeight = F2(
	function (spec, part) {
		return A2(
			$elm$core$Task$onError,
			$elm$core$Basics$always(
				$elm$core$Task$succeed(0)),
			A2(
				$elm$core$Task$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.element;
					},
					function ($) {
						return $.height;
					}),
				$elm$browser$Browser$Dom$getElement(
					'#' + ($author$project$Measure$key(spec) + (' .' + part)))));
	});
var $author$project$Measure$headerNext = F2(
	function (spec, height) {
		var fit = spec.fit;
		return ((height > 105) && (fit.sizeTitle < 3)) ? $author$project$Measure$Header(
			_Utils_update(
				spec,
				{
					fit: _Utils_update(
						fit,
						{sizeTitle: fit.sizeTitle + 1})
				})) : $author$project$Measure$Body(spec);
	});
var $author$project$Measure$insert = F2(
	function (spec, set) {
		return _Utils_update(
			set,
			{
				active: A3($elm$core$Dict$insert, spec.data.id, spec, set.active)
			});
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Measure$needsSave = function (_v0) {
	var data = _v0.data;
	var fit = _v0.fit;
	return !_Utils_eq(fit, data.hint);
};
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{body: r.body, expect: r.expect, headers: _List_Nil, method: 'POST', timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $author$project$Measure$saveNext = F2(
	function (spec, _v0) {
		return $author$project$Measure$Done(spec);
	});
var $author$project$Measure$update = F2(
	function (msg, st) {
		switch (msg.$) {
			case 'Done':
				var data = msg.a.data;
				var fit = msg.a.fit;
				return _Utils_Tuple2(
					_Utils_update(
						st,
						{
							active: A2($elm$core$Dict$remove, data.id, st.active),
							known: A3($elm$core$Dict$insert, data.id, fit, st.known)
						}),
					$elm$core$Platform$Cmd$none);
			case 'Save':
				var spec = msg.a;
				return _Utils_Tuple2(
					st,
					$elm$http$Http$post(
						{
							body: $elm$http$Http$jsonBody(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'FaceID',
											$elm$json$Json$Encode$int(spec.data.id)),
											_Utils_Tuple2(
											'Hint',
											$author$project$Face$encodeFit(spec.fit))
										]))),
							expect: $elm$http$Http$expectWhatever(
								$author$project$Measure$saveNext(spec)),
							url: '/set-face-hint'
						}));
			case 'Header':
				var spec = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Measure$insert, spec, st),
					A2(
						$elm$core$Task$perform,
						$author$project$Measure$headerNext(spec),
						A2($author$project$Measure$getHeight, spec, 'header')));
			case 'Body':
				var spec = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Measure$insert, spec, st),
					A2(
						$elm$core$Task$perform,
						$author$project$Measure$bodyNext(spec),
						A2($author$project$Measure$getHeight, spec, 'face')));
			case 'FlavorInit':
				var spec = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Measure$insert, spec, st),
					A2(
						$elm$core$Task$perform,
						$author$project$Measure$flavorInitNext(spec),
						A2($author$project$Measure$getHeight, spec, 'flavor')));
			default:
				var ref = msg.a;
				var prev = msg.b;
				var fit = prev.fit;
				var lo = msg.c;
				var hi = msg.d;
				if (_Utils_eq(lo, hi)) {
					var fin = _Utils_update(
						prev,
						{
							fit: _Utils_update(
								fit,
								{padFlavor: hi - 1})
						});
					return _Utils_Tuple2(
						A2($author$project$Measure$insert, fin, st),
						$author$project$Measure$needsSave(fin) ? A2(
							$elm$core$Task$perform,
							$author$project$Measure$Save,
							$elm$core$Task$succeed(fin)) : A2(
							$elm$core$Task$perform,
							$author$project$Measure$Done,
							$elm$core$Task$succeed(fin)));
				} else {
					var mid = _Utils_update(
						prev,
						{
							fit: _Utils_update(
								fit,
								{padFlavor: ((lo + hi) / 2) | 0})
						});
					return _Utils_Tuple2(
						A2($author$project$Measure$insert, mid, st),
						A2(
							$elm$core$Task$perform,
							A4($author$project$Measure$flavorTestNext, ref, mid, lo, hi),
							A2($author$project$Measure$getHeight, mid, 'flavor')));
				}
		}
	});
var $author$project$Measure$add = F2(
	function (faces, st0) {
		var addData = F2(
			function (data, _v1) {
				var st = _v1.a;
				var c0 = _v1.b;
				if (A2($elm$core$Dict$member, data.id, st.known)) {
					return _Utils_Tuple2(st, c0);
				} else {
					var init = {data: data, fit: data.hint};
					var _v0 = A2(
						$author$project$Measure$update,
						$author$project$Measure$Header(init),
						_Utils_update(
							st,
							{
								known: A3($elm$core$Dict$insert, data.id, data.hint, st.known)
							}));
					var st1 = _v0.a;
					var c1 = _v0.b;
					return _Utils_Tuple2(
						st1,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[c0, c1])));
				}
			});
		var addFace = function (face) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Maybe$map,
					addData,
					$author$project$Face$serverData(face)));
		};
		return A3(
			$elm$core$List$foldl,
			addFace,
			_Utils_Tuple2(st0, $elm$core$Platform$Cmd$none),
			faces);
	});
var $author$project$Main$broadcastPointerPos = _Platform_outgoingPort('broadcastPointerPos', $elm$core$Basics$identity);
var $author$project$Shell$faces = function (msg) {
	if ((msg.$ === 'Events') && (msg.a.$ === 'Ok')) {
		var events = msg.a.a;
		return $author$project$Shell$eventFaces(events);
	} else {
		return _List_Nil;
	}
};
var $author$project$DebugHttp$logger = F2(
	function (prefix, err) {
		switch (err.$) {
			case 'BadUrl':
				var s = err.a;
				return $elm$core$Debug$log(prefix + (':\nBadUrl:\n' + s));
			case 'Timeout':
				return $elm$core$Debug$log(prefix + ':\nTimeout');
			case 'NetworkError':
				return $elm$core$Debug$log(prefix + ':\nNetworkError');
			case 'BadStatus':
				var n = err.a;
				var _v1 = A2($elm$core$Debug$log, prefix, n);
				return $elm$core$Basics$always(_Utils_Tuple0);
			default:
				var s = err.a;
				return $elm$core$Debug$log(prefix + (':\nBadBody:\n' + s));
		}
	});
var $author$project$DebugHttp$log = F2(
	function (prefix, err) {
		return A3($author$project$DebugHttp$logger, prefix, err, _Utils_Tuple0);
	});
var $author$project$Main$noteFromPeer = _Platform_outgoingPort(
	'noteFromPeer',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'body',
					$elm$core$Basics$identity($.body)),
					_Utils_Tuple2(
					'from',
					$elm$json$Json$Encode$int($.from)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int($.id))
				]));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $author$project$Main$pointerCapture = _Platform_outgoingPort(
	'pointerCapture',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$int(a),
					$elm$json$Json$Encode$bool(b)
				]));
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Main$saveNickname = _Platform_outgoingPort('saveNickname', $elm$json$Json$Encode$string);
var $author$project$Main$setIceConfig = _Platform_outgoingPort(
	'setIceConfig',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$int(a),
					$elm$core$Basics$identity(b)
				]));
	});
var $author$project$Main$SentStart = function (a) {
	return {$: 'SentStart', a: a};
};
var $author$project$Main$startGame = F2(
	function (deckId, nick) {
		return $elm$http$Http$post(
			{
				body: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'DeckID',
								$elm$json$Json$Encode$int(deckId)),
								_Utils_Tuple2(
								'PlayerName',
								$elm$json$Json$Encode$string(nick))
							]))),
				expect: A2($elm$http$Http$expectJson, $author$project$Main$SentStart, $elm$json$Json$Decode$string),
				url: '/start'
			});
	});
var $author$project$Shell$ScrollResults = function (a) {
	return {$: 'ScrollResults', a: a};
};
var $author$project$Selection$SearchResult = function (a) {
	return {$: 'SearchResult', a: a};
};
var $author$project$Extras$List$after = F2(
	function (v, list) {
		after:
		while (true) {
			if (list.b && list.b.b) {
				var x = list.a;
				var _v1 = list.b;
				var y = _v1.a;
				var zs = _v1.b;
				if (_Utils_eq(x, v)) {
					return y;
				} else {
					var $temp$v = v,
						$temp$list = A2($elm$core$List$cons, y, zs);
					v = $temp$v;
					list = $temp$list;
					continue after;
				}
			} else {
				return v;
			}
		}
	});
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2(
					$elm$core$Task$onError,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Err),
					A2(
						$elm$core$Task$andThen,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
							$elm$core$Result$Ok),
						task))));
	});
var $author$project$Extras$List$before = F2(
	function (v, list) {
		return A2(
			$author$project$Extras$List$after,
			v,
			$elm$core$List$reverse(list));
	});
var $author$project$Prediction$select = F3(
	function (sel, seq, _v0) {
		var base = _v0.base;
		return $author$project$Prediction$derive(
			_Utils_update(
				base,
				{realSelection: sel, realSelectionSeq: seq}));
	});
var $author$project$Shell$select = F2(
	function (sel, h) {
		return _Utils_update(
			h,
			{
				state: A3($author$project$Prediction$select, sel, h.nextSeq, h.state)
			});
	});
var $author$project$Shell$clearSummonSelect = function (h) {
	var _v0 = h.state.selection;
	if ((_v0.$ === 'Just') && (_v0.a.$ === 'SearchResult')) {
		return A2($author$project$Shell$select, $elm$core$Maybe$Nothing, h);
	} else {
		return h;
	}
};
var $author$project$Peer$Lift = F4(
	function (peer, pile, n, on) {
		return {n: n, on: on, peer: peer, pile: pile};
	});
var $elm$core$Result$toMaybe = function (result) {
	if (result.$ === 'Ok') {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Shell$decodeLiftNote = function (_v0) {
	var from = _v0.from;
	var body = _v0.body;
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Peer$Lift(from),
				A2($elm$json$Json$Decode$field, 'LiftPile', $author$project$Tid$decoder),
				A2($elm$json$Json$Decode$field, 'LiftNum', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'Lifting', $elm$json$Json$Decode$bool)),
			body));
};
var $author$project$Pointer$decodeNote = function (_v0) {
	var from = _v0.from;
	var body = _v0.body;
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Peer$Pointer(from),
				A2(
					$elm$json$Json$Decode$field,
					'pointer',
					$elm$json$Json$Decode$nullable($author$project$Point$decoder))),
			body));
};
var $author$project$Shell$SentAction = F2(
	function (a, b) {
		return {$: 'SentAction', a: a, b: b};
	});
var $elm$core$Basics$round = _Basics_round;
var $author$project$Point$encodeInt = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$int,
		_List_fromArray(
			[
				$elm$core$Basics$round(x),
				$elm$core$Basics$round(y)
			]));
};
var $author$project$Action$encode = function (action) {
	return $elm$json$Json$Encode$object(
		function () {
			switch (action.$) {
				case 'JoinGame':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('join game'))
						]);
				case 'DrawCards':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('draw')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'PickUpFromTable':
					var id = action.a;
					var offset = action.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('pick up from table')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id)),
							_Utils_Tuple2(
							'AirOffset',
							$author$project$Point$encodeInt(offset))
						]);
				case 'PickUpFromHand':
					var ids = action.a;
					var offset = action.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('pick up from hand')),
							_Utils_Tuple2(
							'HandCardIDs',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, ids)),
							_Utils_Tuple2(
							'AirOffset',
							$author$project$Point$encodeInt(offset))
						]);
				case 'PickUpToken':
					var id = action.a;
					var offset = action.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('pick up token')),
							_Utils_Tuple2(
							'TokenID',
							$elm$json$Json$Encode$int(id)),
							_Utils_Tuple2(
							'AirOffset',
							$author$project$Point$encodeInt(offset))
						]);
				case 'PutOnTable':
					var p = action.a;
					var faceUp = action.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('put on table')),
							_Utils_Tuple2(
							'XY',
							$author$project$Point$encodeInt(p)),
							_Utils_Tuple2(
							'FaceUp',
							$elm$json$Json$Encode$bool(faceUp))
						]);
				case 'PutOnPile':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('put on pile')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'PutInHand':
					var i = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('put in hand')),
							_Utils_Tuple2(
							'HandPos',
							$elm$json$Json$Encode$int(i))
						]);
				case 'ShufflePile':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('shuffle')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'FlipPile':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('flip pile')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'FlipAir':
					var faceUp = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('flip air')),
							_Utils_Tuple2(
							'FaceUp',
							$elm$json$Json$Encode$bool(faceUp))
						]);
				case 'RotatePile':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('rotate pile')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'DuplicatePile':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('duplicate pile')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'RemovePile':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('remove pile')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'CreateToken':
					var name = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('create token')),
							_Utils_Tuple2(
							'TokenName',
							$elm$json$Json$Encode$string(name))
						]);
				case 'RemoveToken':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('remove token')),
							_Utils_Tuple2(
							'TokenID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'RollDie':
					var n = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('roll die')),
							_Utils_Tuple2(
							'DieSides',
							$elm$json$Json$Encode$int(n))
						]);
				case 'LiftFromPile':
					var id = action.a;
					var n = action.b;
					var offset = action.c;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('lift from pile')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id)),
							_Utils_Tuple2(
							'LiftNum',
							$elm$json$Json$Encode$int(n)),
							_Utils_Tuple2(
							'AirOffset',
							$author$project$Point$encodeInt(offset))
						]);
				case 'EditPileBegin':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('edit pile begin')),
							_Utils_Tuple2(
							'PileID',
							$elm$json$Json$Encode$int(id))
						]);
				case 'ChooseDeck':
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('choose deck')),
							_Utils_Tuple2(
							'DeckID',
							$elm$json$Json$Encode$int(id))
						]);
				default:
					var id = action.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'Action',
							$elm$json$Json$Encode$string('summon card')),
							_Utils_Tuple2(
							'CardID',
							$elm$json$Json$Encode$int(id))
						]);
			}
		}());
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Seat$qturns = function (seat) {
	switch (seat.$) {
		case 'A':
			return 0;
		case 'B':
			return 2;
		case 'C':
			return 3;
		default:
			return 1;
	}
};
var $author$project$Seat$facing = function (seat) {
	return A2(
		$elm$core$Basics$modBy,
		4,
		-$author$project$Seat$qturns(seat));
};
var $author$project$Stack$flip = function (stack) {
	return A2($author$project$Stack$flipTo, !stack.faceUp, stack);
};
var $author$project$Face$Blank = {$: 'Blank'};
var $author$project$Face$blank = $author$project$Face$Blank;
var $author$project$Stack$from = F3(
	function (face, n, rot) {
		return {back: $author$project$Face$blank, faceUp: true, front: face, n: n, rot: rot};
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Hand$get1 = F2(
	function (tid, hand) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tid;
					},
					$elm$core$Basics$eq(tid)),
				hand));
	});
var $author$project$Hand$get = F2(
	function (tids, hand) {
		return A2(
			$elm$core$List$filterMap,
			function (tid) {
				return A2($author$project$Hand$get1, tid, hand);
			},
			tids);
	});
var $author$project$Face$WaitingForServer = {$: 'WaitingForServer'};
var $author$project$Face$waitingForServer = $author$project$Face$WaitingForServer;
var $author$project$Stack$predictDraw = function (_v0) {
	var n = _v0.n;
	var front = _v0.front;
	var back = _v0.back;
	var faceUp = _v0.faceUp;
	var rot = _v0.rot;
	return {
		back: back,
		faceUp: faceUp,
		front: faceUp ? $author$project$Face$waitingForServer : front,
		n: n - 1,
		rot: rot
	};
};
var $author$project$Stack$putOnTop = F2(
	function (_new, old) {
		return old.faceUp ? _Utils_update(
			old,
			{front: _new.front, n: old.n + _new.n}) : _Utils_update(
			old,
			{back: _new.back, n: old.n + _new.n});
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Stack$rotate = function (stack) {
	return _Utils_update(
		stack,
		{rot: stack.rot + 1});
};
var $author$project$Prediction$predictUpdates = function (_v0) {
	var action = _v0.action;
	var seq = _v0.seq;
	var game = _v0.game;
	switch (action.$) {
		case 'JoinGame':
			return _List_Nil;
		case 'SummonCard':
			var id = action.a;
			return _List_Nil;
		case 'ChooseDeck':
			var deckId = action.a;
			return _List_Nil;
		case 'DrawCards':
			var id = action.a;
			var _v2 = A2(
				$elm$core$Dict$get,
				$author$project$Tid$fromId(id),
				game.piles);
			if (_v2.$ === 'Nothing') {
				return _List_Nil;
			} else {
				var pile = _v2.a;
				var tid = pile.tid;
				var stack = pile.stack;
				return _List_fromArray(
					[
						(stack.n > 1) ? $author$project$Event$PileUpdate(
						_Utils_update(
							pile,
							{
								stack: $author$project$Stack$predictDraw(stack)
							})) : $author$project$Event$PileDelete(tid),
						A2(
						$author$project$Event$SelfHandAdd,
						$elm$core$Maybe$Nothing,
						_List_fromArray(
							[
								{
								face: stack.front,
								tid: A2($author$project$Tid$fromSeq, seq, 0)
							}
							]))
					]);
			}
		case 'PickUpFromTable':
			var id = action.a;
			var p = action.b;
			var _v3 = A2(
				$elm$core$Dict$get,
				$author$project$Tid$fromId(id),
				game.piles);
			if (_v3.$ === 'Nothing') {
				return _List_Nil;
			} else {
				var tid = _v3.a.tid;
				var stack = _v3.a.stack;
				return _List_fromArray(
					[
						$author$project$Event$SelfAirUpdate(
						$elm$core$Maybe$Just(
							A3($author$project$Air$Stack, stack, p, false))),
						$author$project$Event$PileDelete(tid)
					]);
			}
		case 'PickUpFromHand':
			var ids = action.a;
			var p = action.b;
			var _v4 = $elm$core$List$reverse(
				A2(
					$author$project$Hand$get,
					A2($elm$core$List$map, $author$project$Tid$fromId, ids),
					game.hand));
			if (!_v4.b) {
				return _List_Nil;
			} else {
				var tid = _v4.a.tid;
				var face = _v4.a.face;
				var xs = _v4.b;
				return _List_fromArray(
					[
						$author$project$Event$SelfAirUpdate(
						$elm$core$Maybe$Just(
							A3(
								$author$project$Air$Stack,
								A3(
									$author$project$Stack$from,
									face,
									$elm$core$List$length(xs) + 1,
									$author$project$Seat$facing(game.seat)),
								p,
								false))),
						$author$project$Event$SelfHandRemove(
						_Utils_ap(
							_List_fromArray(
								[tid]),
							A2(
								$elm$core$List$map,
								function ($) {
									return $.tid;
								},
								xs)))
					]);
			}
		case 'PutOnTable':
			var p = action.a;
			var _v5 = game.air;
			if (_v5.$ === 'Nothing') {
				return _List_Nil;
			} else {
				if (_v5.a.$ === 'Stack') {
					var _v6 = _v5.a;
					var stack = _v6.a;
					return _List_fromArray(
						[
							$author$project$Event$SelfAirUpdate($elm$core$Maybe$Nothing),
							$author$project$Event$PileUpdate(
							{
								lockedBy: $elm$core$Maybe$Nothing,
								pos: p,
								stack: stack,
								tid: A2($author$project$Tid$fromSeq, seq, 0)
							})
						]);
				} else {
					var _v7 = _v5.a;
					var name = _v7.a;
					return _List_fromArray(
						[
							$author$project$Event$SelfAirUpdate($elm$core$Maybe$Nothing),
							$author$project$Event$TokenAdd(
							{
								name: name,
								pos: p,
								tid: A2($author$project$Tid$fromSeq, seq, 0)
							})
						]);
				}
			}
		case 'PutOnPile':
			var id = action.a;
			var _v8 = _Utils_Tuple2(
				game.air,
				A2(
					$elm$core$Dict$get,
					$author$project$Tid$fromId(id),
					game.piles));
			if (((_v8.a.$ === 'Just') && (_v8.a.a.$ === 'Stack')) && (_v8.b.$ === 'Just')) {
				var _v9 = _v8.a.a;
				var airStack = _v9.a;
				var pile = _v8.b.a;
				return _List_fromArray(
					[
						$author$project$Event$SelfAirUpdate($elm$core$Maybe$Nothing),
						$author$project$Event$PileUpdate(
						_Utils_update(
							pile,
							{
								stack: A2($author$project$Stack$putOnTop, airStack, pile.stack)
							}))
					]);
			} else {
				return _List_Nil;
			}
		case 'PutInHand':
			var handPos = action.a;
			var _v10 = game.air;
			if ((_v10.$ === 'Just') && (_v10.a.$ === 'Stack')) {
				var _v11 = _v10.a;
				var stack = _v11.a;
				return _List_fromArray(
					[
						$author$project$Event$SelfAirUpdate($elm$core$Maybe$Nothing),
						A2(
						$author$project$Event$SelfHandAdd,
						$elm$core$Maybe$Just(handPos),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, face) {
									return {
										face: face,
										tid: A2($author$project$Tid$fromSeq, seq, i)
									};
								}),
							_Utils_ap(
								A2($elm$core$List$repeat, stack.n - 1, $author$project$Face$waitingForServer),
								_List_fromArray(
									[stack.front]))))
					]);
			} else {
				return _List_Nil;
			}
		case 'ShufflePile':
			var id = action.a;
			return _List_Nil;
		case 'FlipPile':
			var id = action.a;
			var _v12 = A2(
				$elm$core$Dict$get,
				$author$project$Tid$fromId(id),
				game.piles);
			if (_v12.$ === 'Nothing') {
				return _List_Nil;
			} else {
				var pile = _v12.a;
				return _List_fromArray(
					[
						$author$project$Event$PileUpdate(
						_Utils_update(
							pile,
							{
								stack: $author$project$Stack$flip(pile.stack)
							}))
					]);
			}
		case 'FlipAir':
			var faceUp = action.a;
			var _v13 = game.air;
			if ((_v13.$ === 'Just') && (_v13.a.$ === 'Stack')) {
				var _v14 = _v13.a;
				return _List_fromArray(
					[
						$author$project$Event$SelfAirFlip(faceUp)
					]);
			} else {
				return _List_Nil;
			}
		case 'RotatePile':
			var id = action.a;
			var _v15 = A2(
				$elm$core$Dict$get,
				$author$project$Tid$fromId(id),
				game.piles);
			if (_v15.$ === 'Nothing') {
				return _List_Nil;
			} else {
				var pile = _v15.a;
				return _List_fromArray(
					[
						$author$project$Event$PileUpdate(
						_Utils_update(
							pile,
							{
								stack: $author$project$Stack$rotate(pile.stack)
							}))
					]);
			}
		case 'DuplicatePile':
			var id = action.a;
			return _List_Nil;
		case 'RemovePile':
			var id = action.a;
			return _List_fromArray(
				[
					$author$project$Event$PileDelete(
					$author$project$Tid$fromId(id))
				]);
		case 'CreateToken':
			var name = action.a;
			return _List_Nil;
		case 'RemoveToken':
			var id = action.a;
			return _List_fromArray(
				[
					$author$project$Event$TokenRemove(
					$author$project$Tid$fromId(id))
				]);
		case 'PickUpToken':
			var id = action.a;
			var p = action.b;
			var _v16 = A2(
				$elm$core$Dict$get,
				$author$project$Tid$fromId(id),
				game.tokens);
			if (_v16.$ === 'Nothing') {
				return _List_Nil;
			} else {
				var tid = _v16.a.tid;
				var name = _v16.a.name;
				return _List_fromArray(
					[
						$author$project$Event$SelfAirUpdate(
						$elm$core$Maybe$Just(
							A2($author$project$Air$Token, name, p))),
						$author$project$Event$TokenRemove(tid)
					]);
			}
		case 'RollDie':
			var dn = action.a;
			return _List_fromArray(
				[
					$author$project$Event$DieUpdate(
					{sides: dn, value: $elm$core$Maybe$Nothing})
				]);
		case 'LiftFromPile':
			var id = action.a;
			var n = action.b;
			var p = action.c;
			var _v17 = A2(
				$elm$core$Dict$get,
				$author$project$Tid$fromId(id),
				game.piles);
			if (_v17.$ === 'Just') {
				var pile = _v17.a;
				var stack = pile.stack;
				return _List_fromArray(
					[
						$author$project$Event$SelfAirUpdate(
						$elm$core$Maybe$Just(
							A3(
								$author$project$Air$Stack,
								A2($author$project$Stack$draw, n, stack),
								p,
								false))),
						$author$project$Event$PileUpdate(
						_Utils_update(
							pile,
							{
								stack: $author$project$Stack$predictDraw(stack)
							}))
					]);
			} else {
				return _List_Nil;
			}
		default:
			var id = action.a;
			return _List_Nil;
	}
};
var $author$project$Prediction$predictEvent = function (config) {
	var action = config.action;
	var seq = config.seq;
	return {
		action: action,
		agent: 0,
		clientSeq: seq,
		isSelf: true,
		serverSeq: 0,
		updates: $author$project$Prediction$predictUpdates(config)
	};
};
var $author$project$Prediction$predict = F3(
	function (a, seq, _v0) {
		var base = _v0.base;
		var game = _v0.game;
		return $author$project$Prediction$deriveAnim(
			_Utils_update(
				base,
				{
					predictedEvents: _Utils_ap(
						base.predictedEvents,
						_List_fromArray(
							[
								$author$project$Prediction$predictEvent(
								{action: a, game: game, seq: seq})
							]))
				}));
	});
var $author$project$Shell$do = F2(
	function (action, _v0) {
		var h = _v0.a;
		var c = _v0.b;
		var _v1 = A3($author$project$Prediction$predict, action, h.nextSeq, h.state);
		var st = _v1.a;
		var anim = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				h,
				{
					animations: A2($author$project$Animation$insert, anim, h.animations),
					nextSeq: h.nextSeq + 1,
					state: st
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						c,
						$elm$http$Http$post(
						{
							body: $elm$http$Http$jsonBody(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'Action',
											$author$project$Action$encode(action)),
											_Utils_Tuple2(
											'ClientID',
											$elm$json$Json$Encode$string(h.clientId)),
											_Utils_Tuple2(
											'Seq',
											$elm$json$Json$Encode$int(h.nextSeq))
										]))),
							expect: $elm$http$Http$expectWhatever(
								$author$project$Shell$SentAction(h.nextSeq)),
							url: '/gameapi/do?g=' + h.id
						})
					])));
	});
var $author$project$SearchResult$action = function (result) {
	switch (result.$) {
		case 'CardResult':
			var card = result.a;
			return $author$project$Action$SummonCard(card.id);
		case 'DeckResult':
			var id = result.a.id;
			return $author$project$Action$ChooseDeck(id);
		case 'Roll':
			var n = result.a;
			return $author$project$Action$RollDie(n);
		default:
			var s = result.a;
			return $author$project$Action$CreateToken(s);
	}
};
var $author$project$Shell$doSearchResult = F2(
	function (result, _v0) {
		var h = _v0.a;
		var cmd = _v0.b;
		return A2(
			$author$project$Shell$do,
			$author$project$SearchResult$action(result),
			_Utils_Tuple2(
				_Utils_update(
					h,
					{
						formSearch: '',
						recentlySummoned: A2($elm$core$List$member, result, h.recentlySummoned) ? h.recentlySummoned : A2(
							$elm$core$List$take,
							100,
							A2($elm$core$List$cons, result, h.recentlySummoned)),
						searchResults: _List_Nil
					}),
				cmd));
	});
var $author$project$Point$Trans = function (a) {
	return {$: 'Trans', a: a};
};
var $author$project$Point$identity = $author$project$Point$Trans($elm$core$Basics$identity);
var $author$project$Point$makeToOuter = F3(
	function (dx, dy, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return A2($author$project$Point$Point, x + dx, y + dy);
	});
var $author$project$Point$toOuter = F2(
	function (_v0, _v1) {
		var dx = _v0.a;
		var dy = _v0.b;
		var f = _v1.a;
		return $author$project$Point$Trans(
			A2(
				$elm$core$Basics$composeR,
				f,
				A2($author$project$Point$makeToOuter, dx, dy)));
	});
var $author$project$Point$transform = function (_v0) {
	var f = _v0.a;
	return f;
};
var $author$project$Pointer$absoluteFrom = function (posPointer) {
	return $author$project$Point$transform(
		A2($author$project$Point$toOuter, posPointer, $author$project$Point$identity));
};
var $author$project$Tid$toId = function (_v0) {
	var seq = _v0.a;
	var index = _v0.b;
	return (!seq) ? $elm$core$Maybe$Just(index) : $elm$core$Maybe$Nothing;
};
var $author$project$Pile$canBeDropTarget = function (_v0) {
	var tid = _v0.tid;
	var lockedBy = _v0.lockedBy;
	return (!_Utils_eq(
		$author$project$Tid$toId(tid),
		$elm$core$Maybe$Nothing)) && _Utils_eq(lockedBy, $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$Point$clamp = F2(
	function (_v0, _v3) {
		var _v1 = _v0.a;
		var ax = _v1.a;
		var ay = _v1.b;
		var _v2 = _v0.b;
		var bx = _v2.a;
		var by = _v2.b;
		var x = _v3.a;
		var y = _v3.b;
		return A2(
			$author$project$Point$Point,
			A3($elm$core$Basics$clamp, ax, bx, x),
			A3($elm$core$Basics$clamp, ay, by, y));
	});
var $author$project$Face$bounds = _Utils_Tuple2(
	A2($author$project$Point$at, -125, -175),
	A2($author$project$Point$at, 125, 175));
var $author$project$Point$isIn = F2(
	function (_v0, _v3) {
		var _v1 = _v0.a;
		var ax = _v1.a;
		var ay = _v1.b;
		var _v2 = _v0.b;
		var bx = _v2.a;
		var by = _v2.b;
		var x = _v3.a;
		var y = _v3.b;
		return ((_Utils_cmp(ax, x) < 1) && (_Utils_cmp(x, bx) < 1)) && ((_Utils_cmp(ay, y) < 1) && (_Utils_cmp(y, by) < 1));
	});
var $author$project$Point$makeQturn = F2(
	function (n, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		var _v1 = A2($elm$core$Basics$modBy, 4, n);
		switch (_v1) {
			case 0:
				return A2($author$project$Point$Point, x, y);
			case 1:
				return A2($author$project$Point$Point, -y, x);
			case 2:
				return A2($author$project$Point$Point, -x, -y);
			default:
				return A2($author$project$Point$Point, y, -x);
		}
	});
var $author$project$Point$qturn = F2(
	function (n, _v0) {
		var f = _v0.a;
		return $author$project$Point$Trans(
			A2(
				$elm$core$Basics$composeR,
				f,
				$author$project$Point$makeQturn(n)));
	});
var $author$project$Point$makeScale = F2(
	function (s, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return A2($author$project$Point$Point, s * x, s * y);
	});
var $author$project$Point$scale = F2(
	function (s, _v0) {
		var f = _v0.a;
		return $author$project$Point$Trans(
			A2(
				$elm$core$Basics$composeR,
				f,
				$author$project$Point$makeScale(s)));
	});
var $author$project$Point$makeToInner = F3(
	function (dx, dy, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return A2($author$project$Point$Point, x - dx, y - dy);
	});
var $author$project$Point$toInner = F2(
	function (_v0, _v1) {
		var dx = _v0.a;
		var dy = _v0.b;
		var f = _v1.a;
		return $author$project$Point$Trans(
			A2(
				$elm$core$Basics$composeR,
				f,
				A2($author$project$Point$makeToInner, dx, dy)));
	});
var $author$project$Pile$toFaceSpace = F2(
	function (pos, rot) {
		return $author$project$Point$transform(
			A2(
				$author$project$Point$scale,
				5,
				A2(
					$author$project$Point$qturn,
					-rot,
					A2($author$project$Point$toInner, pos, $author$project$Point$identity))));
	});
var $author$project$Pile$contains = F2(
	function (point, pile) {
		return A2(
			$author$project$Point$isIn,
			$author$project$Face$bounds,
			A3($author$project$Pile$toFaceSpace, pile.pos, pile.stack.rot, point));
	});
var $author$project$Point$getX = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Table$size = 720;
var $author$project$Card$sizeInHand = {height: 140, width: 100};
var $author$project$Hand$offset = F2(
	function (n, i) {
		return (n > 6) ? ((($author$project$Table$size - $author$project$Card$sizeInHand.width) * i) / (n - 1)) : (i * ($author$project$Card$sizeInHand.width + 24));
	});
var $author$project$Hand$dropIndex = F2(
	function (hand, hover) {
		var n = $elm$core$List$length(hand) + 1;
		var find = F2(
			function (i, items) {
				find:
				while (true) {
					if (!items.b) {
						return i;
					} else {
						var rest = items.b;
						if (_Utils_cmp(
							A2($author$project$Hand$offset, n, i) + $author$project$Card$sizeInHand.width,
							$author$project$Point$getX(hover)) > 0) {
							return i;
						} else {
							var $temp$i = i + 1,
								$temp$items = rest;
							i = $temp$i;
							items = $temp$items;
							continue find;
						}
					}
				}
			});
		return A2(find, 0, hand);
	});
var $author$project$Point$getY = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Table$center = A2($author$project$Point$at, $author$project$Table$size / 2, $author$project$Table$size / 2);
var $author$project$Seat$pointToTableFor = function (seat) {
	return $author$project$Point$transform(
		A2(
			$author$project$Point$qturn,
			-$author$project$Seat$qturns(seat),
			A2($author$project$Point$toInner, $author$project$Table$center, $author$project$Point$identity)));
};
var $author$project$Table$scale = 0.1985;
var $author$project$Card$sizeOnTable = {height: $author$project$Table$scale * $author$project$Face$size.height, width: $author$project$Table$scale * $author$project$Face$size.width};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Shell$drop = F2(
	function (game, drag) {
		var inset = $author$project$Card$sizeOnTable.height / 2;
		var bottom = function () {
			var _v3 = game.air;
			if ((_v3.$ === 'Just') && (_v3.a.$ === 'Token')) {
				var _v4 = _v3.a;
				return $author$project$Table$size - inset;
			} else {
				return (($author$project$Table$size + 24) + $author$project$Card$sizeInHand.height) - inset;
			}
		}();
		var posScreen = A2(
			$author$project$Point$clamp,
			_Utils_Tuple2(
				A2($author$project$Point$at, inset, inset),
				A2($author$project$Point$at, $author$project$Table$size - inset, bottom)),
			A2($author$project$Pointer$absoluteFrom, drag.pointerPos, drag.offset));
		var posTable = A2($author$project$Seat$pointToTableFor, game.seat, posScreen);
		return {
			action: function () {
				var _v0 = game.air;
				if (_v0.$ === 'Just') {
					if (_v0.a.$ === 'Token') {
						var _v1 = _v0.a;
						return A2($author$project$Action$PutOnTable, posTable, true);
					} else {
						var _v2 = _v0.a;
						var stack = _v2.a;
						return (_Utils_cmp(
							$author$project$Point$getY(posScreen),
							$author$project$Table$size) > 0) ? $author$project$Action$PutInHand(
							A2($author$project$Hand$dropIndex, game.hand, posScreen)) : A2(
							$elm$core$Maybe$withDefault,
							A2($author$project$Action$PutOnTable, posTable, stack.faceUp),
							A2(
								$elm$core$Maybe$map,
								$author$project$Action$PutOnPile,
								A2(
									$elm$core$Maybe$andThen,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Tid$toId,
										function ($) {
											return $.tid;
										}),
									$elm$core$List$head(
										$elm$core$List$reverse(
											A2(
												$elm$core$List$filter,
												$author$project$Pile$canBeDropTarget,
												A2(
													$elm$core$List$filter,
													$author$project$Pile$contains(posTable),
													$elm$core$Dict$values(game.piles))))))));
					}
				} else {
					return drag.revert;
				}
			}(),
			pos: posScreen
		};
	});
var $author$project$Shell$elementId = {rollCustomInput: 'roll-custom-input'};
var $author$project$Table$bounds = _Utils_Tuple2(
	A2($author$project$Point$at, -($author$project$Table$size / 2), -($author$project$Table$size / 2)),
	A2($author$project$Point$at, $author$project$Table$size / 2, $author$project$Table$size / 2));
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Pointer$encodeForPeer = function (p) {
	return A2($author$project$Point$isIn, $author$project$Table$bounds, p) ? $author$project$Point$encodeInt(p) : $elm$json$Json$Encode$null;
};
var $author$project$Pointer$encodeNote = function (p) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pointer',
				$author$project$Pointer$encodeForPeer(p))
			]));
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return $elm$core$Set$Set_elm_builtin(
		A2($elm$core$Dict$singleton, key, _Utils_Tuple0));
};
var $author$project$Prediction$failed = F2(
	function (seq, _v0) {
		var base = _v0.base;
		return $author$project$Prediction$derive(
			A2(
				$author$project$Prediction$filter,
				$elm$core$Set$singleton(seq),
				base));
	});
var $author$project$Shell$Focus = function (a) {
	return {$: 'Focus', a: a};
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Shell$focus = function (id) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$Shell$Focus,
		$elm$browser$Browser$Dom$focus(id));
};
var $author$project$Shell$Notes = function (a) {
	return {$: 'Notes', a: a};
};
var $author$project$Note$Note = F3(
	function (id, from, body) {
		return {body: body, from: from, id: id};
	});
var $author$project$Note$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Note$Note,
	A2($elm$json$Json$Decode$field, 'ID', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'From', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'Body', $elm$json$Json$Decode$value));
var $author$project$Shell$getNotes = F2(
	function (gameId, seen) {
		return $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					$author$project$Shell$Notes,
					$elm$json$Json$Decode$list($author$project$Note$decoder)),
				url: '/gameapi/notes?g=' + (gameId + ('&seen=' + $elm$core$String$fromInt(seen)))
			});
	});
var $author$project$Shell$SentJoin = function (a) {
	return {$: 'SentJoin', a: a};
};
var $author$project$Shell$join = F2(
	function (gameId, nick) {
		return $elm$http$Http$post(
			{
				body: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'PlayerName',
								$elm$json$Json$Encode$string(nick))
							]))),
				expect: $elm$http$Http$expectWhatever($author$project$Shell$SentJoin),
				url: '/gameapi/join?g=' + gameId
			});
	});
var $author$project$Shell$encodeLiftNote = F3(
	function (tid, n, on) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'LiftPile',
					$elm$json$Json$Encode$int(
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Tid$toId(tid)))),
					_Utils_Tuple2(
					'LiftNum',
					$elm$json$Json$Encode$int(n)),
					_Utils_Tuple2(
					'Lifting',
					$elm$json$Json$Encode$bool(on))
				]));
	});
var $author$project$Shell$inLift = function (drag) {
	return _Utils_eq(drag, $elm$core$Maybe$Nothing);
};
var $author$project$Shell$NotePosted = function (a) {
	return {$: 'NotePosted', a: a};
};
var $author$project$Note$encode = F2(
	function (to, body) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'To',
					$elm$json$Json$Encode$int(to)),
					_Utils_Tuple2('Body', body)
				]));
	});
var $author$project$Shell$postNote = F3(
	function (gameId, to, body) {
		return $elm$http$Http$post(
			{
				body: $elm$http$Http$jsonBody(
					A2($author$project$Note$encode, to, body)),
				expect: $elm$http$Http$expectWhatever($author$project$Shell$NotePosted),
				url: '/gameapi/note?g=' + gameId
			});
	});
var $author$project$Shell$liftCmd = F5(
	function (gameId, tid, isHover, drag, liftNum) {
		return A3(
			$author$project$Shell$postNote,
			gameId,
			-1,
			A3(
				$author$project$Shell$encodeLiftNote,
				tid,
				liftNum,
				isHover && $author$project$Shell$inLift(drag)));
	});
var $author$project$Pointer$pointerRate = 40;
var $author$project$TimeExtra$sub = F2(
	function (a, b) {
		return $elm$time$Time$posixToMillis(a) - $elm$time$Time$posixToMillis(b);
	});
var $author$project$Pointer$limited = F3(
	function (a, b, c) {
		return (_Utils_cmp(
			A2($author$project$TimeExtra$sub, a, b),
			$author$project$Pointer$pointerRate) > 0) ? _Utils_Tuple2(a, c) : _Utils_Tuple2(b, $elm$core$Platform$Cmd$none);
	});
var $author$project$Shell$showRecentlySummoned = function (h) {
	return (h.formSearch === '') && _Utils_eq(h.searchResults, _List_Nil);
};
var $author$project$Shell$moveSearchResultSelection = F2(
	function (f, h) {
		var list = $author$project$Shell$showRecentlySummoned(h) ? h.recentlySummoned : h.searchResults;
		var _v0 = h.state.selection;
		if ((_v0.$ === 'Just') && (_v0.a.$ === 'SearchResult')) {
			var res = _v0.a.a;
			return A2(
				$author$project$Shell$select,
				$elm$core$Maybe$Just(
					$author$project$Selection$SearchResult(
						A2(f, res, list))),
				h);
		} else {
			return h;
		}
	});
var $author$project$Pointer$relativeTo = F2(
	function (posPointer, scale) {
		return $author$project$Point$transform(
			A2(
				$author$project$Point$scale,
				scale,
				A2($author$project$Point$toInner, posPointer, $author$project$Point$identity)));
	});
var $author$project$Animation$remove = F2(
	function (id, _v0) {
		var a = _v0.a;
		return $author$project$Animation$Set(
			{
				immediate: A2($elm$core$Dict$remove, id, a.immediate),
				sequential: A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$neq(id)),
					a.sequential)
			});
	});
var $author$project$Shell$roll = F2(
	function (n, h) {
		return A2(
			$author$project$Shell$do,
			$author$project$Action$RollDie(n),
			_Utils_Tuple2(
				_Utils_update(
					h,
					{rollCustomInput: '', rollMore: false}),
				$elm$core$Platform$Cmd$none));
	});
var $author$project$SearchResult$Roll = function (a) {
	return {$: 'Roll', a: a};
};
var $author$project$Roll$parse = function (s) {
	return A2($elm$core$String$startsWith, 'd', s) ? $elm$core$String$toInt(
		A2($elm$core$String$dropLeft, 1, s)) : $elm$core$Maybe$Nothing;
};
var $author$project$Face$parseWikiId = function (s) {
	return A2($elm$core$String$startsWith, '#', s) ? $elm$core$String$toInt(
		A2($elm$core$String$dropLeft, 1, s)) : $elm$core$Maybe$Nothing;
};
var $author$project$Score$Query = function (a) {
	return {$: 'Query', a: a};
};
var $author$project$Score$query = function (s) {
	return $author$project$Score$Query(
		$author$project$Score$words(s));
};
var $author$project$SearchResult$CardResult = function (a) {
	return {$: 'CardResult', a: a};
};
var $author$project$Score$avg = function (l) {
	return $elm$core$List$sum(l) / $elm$core$List$length(l);
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Score$match = F2(
	function (qt, s) {
		return A2($elm$core$String$startsWith, qt, s) ? ($elm$core$String$length(qt) / $elm$core$String$length(s)) : 0;
	});
var $author$project$Score$scoreDoc = F2(
	function (qt, _v0) {
		var w = _v0.a;
		var d = _v0.b.a;
		return w * A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					$author$project$Score$match(qt),
					d)));
	});
var $author$project$Score$scoreTerm = F2(
	function (ds, qt) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					$author$project$Score$scoreDoc(qt),
					ds)));
	});
var $author$project$Score$score = F2(
	function (_v0, ds) {
		var q = _v0.a;
		var scores = A2(
			$elm$core$List$map,
			$author$project$Score$scoreTerm(ds),
			q);
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(0),
			scores) ? 0 : $author$project$Score$avg(scores);
	});
var $author$project$SearchResult$scoreCard = F2(
	function (q, card) {
		var score = A2(
			$author$project$Score$score,
			q,
			_List_fromArray(
				[
					_Utils_Tuple2(1.0, card.titleDoc),
					_Utils_Tuple2(0.5, card.typeDoc),
					_Utils_Tuple2(0.5, card.cornerDoc),
					_Utils_Tuple2(0.5, card.bodyDoc),
					_Utils_Tuple2(0.5, card.flavorDoc),
					_Utils_Tuple2(0.5, card.creatorDoc)
				]));
		return (score > 0) ? $elm$core$Maybe$Just(
			{
				result: $author$project$SearchResult$CardResult(card),
				score: score
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$SearchResult$DeckResult = function (a) {
	return {$: 'DeckResult', a: a};
};
var $author$project$SearchResult$scoreDeck = F2(
	function (q, deck) {
		var score = A2(
			$author$project$Score$score,
			q,
			_List_fromArray(
				[
					_Utils_Tuple2(1, deck.nameDoc)
				]));
		return (score > 0) ? $elm$core$Maybe$Just(
			{
				result: $author$project$SearchResult$DeckResult(deck),
				score: score
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$Token$known = _List_fromArray(
	['Money', 'Energy', 'Zombie', 'Air', 'Blood', 'Bone', 'Brick', 'Candy', 'Crate', 'Doom', 'Earth', 'Fire', 'Flame', 'Fog', 'Food', 'Ghost', 'Gold', 'Ice', 'Insanity', 'Sanity', 'Mana', 'Paper', 'Poison', 'Snow', 'Strawberry Candy', 'Toxin', 'Void', 'Water', 'Register', 'Blank']);
var $author$project$SearchResult$Token = F2(
	function (name, nameDoc) {
		return {name: name, nameDoc: nameDoc};
	});
var $author$project$SearchResult$knownTokens = A2(
	$elm$core$List$map,
	function (s) {
		return A2(
			$author$project$SearchResult$Token,
			s,
			$author$project$Score$doc(s));
	},
	$author$project$Token$known);
var $author$project$SearchResult$TokenResult = function (a) {
	return {$: 'TokenResult', a: a};
};
var $author$project$SearchResult$novelToken = F2(
	function (s, score) {
		return {
			result: $author$project$SearchResult$TokenResult(
				(s === '') ? 'Token' : s),
			score: score
		};
	});
var $author$project$SearchResult$scoreToken = F2(
	function (q, tok) {
		var score = A2(
			$author$project$Score$score,
			q,
			_List_fromArray(
				[
					_Utils_Tuple2(1, tok.nameDoc)
				]));
		return (score > 0) ? $elm$core$Maybe$Just(
			{
				result: $author$project$SearchResult$TokenResult(tok.name),
				score: score
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$SearchResult$scoreTokens = function (qs) {
	var _v0 = A2($elm$core$String$startsWith, '$', qs) ? _Utils_Tuple2(
		A2($elm$core$String$dropLeft, 1, qs),
		1) : _Utils_Tuple2(qs, 0.8);
	var s = _v0.a;
	var novelScore = _v0.b;
	var novel = A2($elm$core$List$member, s, $author$project$Token$known) ? _List_Nil : _List_fromArray(
		[
			A2($author$project$SearchResult$novelToken, s, novelScore)
		]);
	return _Utils_ap(
		novel,
		A2(
			$elm$core$List$filterMap,
			$author$project$SearchResult$scoreToken(
				$author$project$Score$query(s)),
			$author$project$SearchResult$knownTokens));
};
var $author$project$SearchResult$scoreWikiId = F2(
	function (n, card) {
		return _Utils_eq(
			card.wikiId,
			$elm$core$Maybe$Just(n)) ? $elm$core$Maybe$Just(
			{
				result: $author$project$SearchResult$CardResult(card),
				score: 1
			}) : $elm$core$Maybe$Nothing;
	});
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (result.$ === 'Ok') {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Shell$search = F3(
	function (q, maybeCards, maybeDecks) {
		var tokenResults = $author$project$SearchResult$scoreTokens(q);
		var terms = $author$project$Score$query(q);
		var rollResults = function () {
			var _v1 = $author$project$Roll$parse(q);
			if (_v1.$ === 'Just') {
				var n = _v1.a;
				return _List_fromArray(
					[
						{
						result: $author$project$SearchResult$Roll(n),
						score: 1
					}
					]);
			} else {
				return _List_Nil;
			}
		}();
		var decks = A2(
			$elm$core$Result$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Result$Ok(_List_Nil),
				maybeDecks));
		var deckResults = A2(
			$elm$core$List$filterMap,
			$author$project$SearchResult$scoreDeck(terms),
			decks);
		var cards = A2(
			$elm$core$Result$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Result$Ok(_List_Nil),
				maybeCards));
		var cardResults = A2(
			$elm$core$List$filterMap,
			$author$project$SearchResult$scoreCard(terms),
			cards);
		var cardByWikiId = function () {
			var _v0 = $author$project$Face$parseWikiId(q);
			if (_v0.$ === 'Just') {
				var n = _v0.a;
				return A2(
					$elm$core$List$filterMap,
					$author$project$SearchResult$scoreWikiId(n),
					cards);
			} else {
				return _List_Nil;
			}
		}();
		return (q === '') ? _List_Nil : A2(
			$elm$core$List$map,
			function ($) {
				return $.result;
			},
			A2(
				$elm$core$List$take,
				100,
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.score;
						},
						$elm$core$Basics$negate),
					_Utils_ap(
						cardByWikiId,
						_Utils_ap(
							tokenResults,
							_Utils_ap(
								cardResults,
								_Utils_ap(deckResults, rollResults)))))));
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Shell$updateDragRevert = function (h) {
	return function () {
		var _v0 = h.drag;
		if (_v0.$ === 'Just') {
			var drag = _v0.a;
			return $author$project$Shell$do(drag.revert);
		} else {
			return $elm$core$Basics$identity;
		}
	}()(
		_Utils_Tuple2(
			_Utils_update(
				h,
				{drag: $elm$core$Maybe$Nothing}),
			h.pointerCapture(false)));
};
var $author$project$Peer$updateLift = function (_v0) {
	var peer = _v0.peer;
	var pile = _v0.pile;
	var n = _v0.n;
	var on = _v0.on;
	return on ? A2(
		$elm$core$Dict$insert,
		peer,
		_Utils_Tuple2(pile, n)) : $elm$core$Dict$remove(peer);
};
var $author$project$Peer$updatePointer = function (_v0) {
	var peer = _v0.peer;
	var pos = _v0.pos;
	return A2(
		$elm$core$Dict$update,
		peer,
		$elm$core$Basics$always(pos));
};
var $author$project$Shell$update = F3(
	function (msg, ports, h) {
		switch (msg.$) {
			case 'Do':
				var action = msg.a;
				return A2(
					$author$project$Shell$do,
					action,
					_Utils_Tuple2(h, $elm$core$Platform$Cmd$none));
			case 'SentAction':
				if (msg.b.$ === 'Ok') {
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				} else {
					if ((msg.b.a.$ === 'BadStatus') && (msg.b.a.a === 409)) {
						var seq = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								h,
								{
									state: A2($author$project$Prediction$failed, seq, h.state)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var seq = msg.a;
						var err = msg.b.a;
						var _v1 = A2($author$project$DebugHttp$log, 'SentAction', err);
						return _Utils_Tuple2(
							_Utils_update(
								h,
								{
									state: A2($author$project$Prediction$failed, seq, h.state)
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 'SetNick':
				var nick = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{nick: nick}),
					ports.saveNickname(nick));
			case 'Join':
				var nick = (h.nick === '') ? h.nickPlaceholder : h.nick;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{nick: nick}),
					A2($author$project$Shell$join, h.id, nick));
			case 'SentJoin':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var _v2 = A2($author$project$DebugHttp$log, 'SentJoin', err);
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'Events':
				if (msg.a.$ === 'Ok') {
					var events = msg.a.a;
					return A3(
						$author$project$Shell$updateEvents,
						{animate: true},
						h,
						events);
				} else {
					var err = msg.a.a;
					var _v3 = A2($author$project$DebugHttp$log, 'Events', err);
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'Select':
				var sel = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Shell$select, sel, h),
					$elm$core$Platform$Cmd$none);
			case 'PointerDown':
				var id = msg.a;
				var pos = msg.b;
				var f = $author$project$Point$transform(
					A2(
						$author$project$Point$toInner,
						A2($author$project$Point$at, 80, 80),
						$author$project$Point$identity));
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{
							pointerCapture: function (on) {
								return ports.pointerCapture(
									_Utils_Tuple2(id, on));
							},
							pointerDownPos: f(pos)
						}),
					$elm$core$Platform$Cmd$none);
			case 'DragStart':
				var scale = msg.a;
				var pos = msg.b.pos;
				var start = msg.b.start;
				var revert = msg.b.revert;
				var posPointer = A2($author$project$Seat$pointToTableFor, h.state.game.seat, h.pointerDownPos);
				var offsetOnTable = A3(
					$author$project$Pointer$relativeTo,
					posPointer,
					scale,
					A2($author$project$Seat$pointToTableFor, h.state.game.seat, pos));
				return A2(
					$author$project$Shell$do,
					start(offsetOnTable),
					_Utils_Tuple2(
						_Utils_update(
							h,
							{
								drag: $elm$core$Maybe$Just(
									{
										offset: A3($author$project$Pointer$relativeTo, h.pointerDownPos, scale, pos),
										pointerPos: h.pointerDownPos,
										revert: revert
									})
							}),
						h.pointerCapture(true)));
			case 'PointerMove':
				var pos = msg.a;
				var t = msg.b;
				var tablePos = A2($author$project$Seat$pointToTableFor, h.state.game.seat, pos);
				var _v4 = A3(
					$author$project$Pointer$limited,
					t,
					h.pointerNoteSentAt,
					A3(
						$author$project$Shell$postNote,
						h.id,
						-1,
						$author$project$Pointer$encodeNote(tablePos)));
				var noteSentAt = _v4.a;
				var note = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{
							drag: A2(
								$elm$core$Maybe$map,
								function (d) {
									return _Utils_update(
										d,
										{pointerPos: pos});
								},
								h.drag),
							pointerNoteSentAt: noteSentAt
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								ports.broadcastPointerPos(
								$author$project$Pointer$encodeForPeer(tablePos)),
								note
							])));
			case 'PointerLeave':
				return _Utils_Tuple2(
					h,
					ports.broadcastPointerPos($elm$json$Json$Encode$null));
			case 'MouseUp':
				return function () {
					var _v5 = h.drag;
					if (_v5.$ === 'Just') {
						var drag = _v5.a;
						return $author$project$Shell$do(
							A2($author$project$Shell$drop, h.state.game, drag).action);
					} else {
						return $elm$core$Basics$identity;
					}
				}()(
					_Utils_Tuple2(
						_Utils_update(
							h,
							{drag: $elm$core$Maybe$Nothing}),
						h.pointerCapture(false)));
			case 'LostPointerCapture':
				return $author$project$Shell$updateDragRevert(h);
			case 'EnterPile':
				var tid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{liftHover: true, liftPile: tid}),
					A5($author$project$Shell$liftCmd, h.id, tid, true, h.drag, h.liftNum));
			case 'LeavePile':
				var tid = msg.a;
				return _Utils_eq(tid, h.liftPile) ? _Utils_Tuple2(
					_Utils_update(
						h,
						{liftHover: false}),
					A5($author$project$Shell$liftCmd, h.id, tid, false, h.drag, h.liftNum)) : _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
			case 'KeyDown':
				switch (msg.a) {
					case 'Escape':
						return $author$project$Shell$updateDragRevert(h);
					case 'ArrowDown':
						return _Utils_Tuple2(
							A2($author$project$Shell$moveSearchResultSelection, $author$project$Extras$List$after, h),
							$elm$core$Platform$Cmd$none);
					case 'ArrowUp':
						return _Utils_Tuple2(
							A2($author$project$Shell$moveSearchResultSelection, $author$project$Extras$List$before, h),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'ModKeyDown':
				switch (msg.a.$) {
					case 'Shift':
						var _v6 = msg.a;
						return _Utils_eq(h.drag, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(h, $elm$core$Platform$Cmd$none) : A2(
							$author$project$Shell$do,
							$author$project$Action$FlipAir(true),
							_Utils_Tuple2(h, $elm$core$Platform$Cmd$none));
					case 'Alt':
						var _v8 = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								h,
								{liftNum: 0}),
							A5($author$project$Shell$liftCmd, h.id, h.liftPile, h.liftHover, h.drag, h.liftNum));
					default:
						return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'ModKeyUp':
				switch (msg.a.$) {
					case 'Shift':
						var _v7 = msg.a;
						return _Utils_eq(h.drag, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(h, $elm$core$Platform$Cmd$none) : A2(
							$author$project$Shell$do,
							$author$project$Action$FlipAir(false),
							_Utils_Tuple2(h, $elm$core$Platform$Cmd$none));
					case 'Alt':
						var _v9 = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								h,
								{liftNum: 1}),
							A5($author$project$Shell$liftCmd, h.id, h.liftPile, h.liftHover, h.drag, h.liftNum));
					default:
						return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'NumKeyDown':
				var n = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{liftNum: n}),
					A5($author$project$Shell$liftCmd, h.id, h.liftPile, h.liftHover, h.drag, n));
			case 'NumKeyUp':
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{liftNum: 1}),
					A5($author$project$Shell$liftCmd, h.id, h.liftPile, h.liftHover, h.drag, 1));
			case 'NoteToPost':
				var to = msg.a.to;
				var body = msg.a.body;
				return _Utils_Tuple2(
					h,
					A3($author$project$Shell$postNote, h.id, to, body));
			case 'NotePosted':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var _v10 = A2($author$project$DebugHttp$log, 'NotePosted', err);
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'Notes':
				if (msg.a.$ === 'Ok') {
					var notes = msg.a.a;
					var peerPointers = A2($elm$core$List$filterMap, $author$project$Pointer$decodeNote, notes);
					var peerLiftNotes = A2($elm$core$List$filterMap, $author$project$Shell$decodeLiftNote, notes);
					return _Utils_Tuple2(
						_Utils_update(
							h,
							{
								peerLifts: A2(
									$elm$core$Debug$log,
									'updated lift notes',
									A3($elm$core$List$foldl, $author$project$Peer$updateLift, h.peerLifts, peerLiftNotes)),
								pointers: A3($elm$core$List$foldl, $author$project$Peer$updatePointer, h.pointers, peerPointers)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$author$project$Shell$getNotes,
									h.id,
									A3(
										$elm$core$List$foldl,
										$elm$core$Basics$max,
										0,
										A2(
											$elm$core$List$map,
											function ($) {
												return $.id;
											},
											notes))),
									$elm$core$Platform$Cmd$batch(
									A2($elm$core$List$map, ports.noteFromPeer, notes))
								])));
				} else {
					var err = msg.a.a;
					var _v11 = A2($author$project$DebugHttp$log, 'Notes', err);
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'GotIceConfig':
				if (msg.b.$ === 'Ok') {
					var id = msg.a;
					var c = msg.b.a;
					return _Utils_Tuple2(
						h,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									ports.setIceConfig(
									_Utils_Tuple2(id, c)),
									A2($author$project$Shell$getNotes, h.id, 0)
								])));
				} else {
					var err = msg.b.a;
					var _v12 = A2($author$project$DebugHttp$log, 'GotIceConfig', err);
					return _Utils_Tuple2(
						h,
						A2($author$project$Shell$getNotes, h.id, 0));
				}
			case 'PeerPointer':
				if (msg.a.$ === 'Ok') {
					var p = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							h,
							{
								pointers: A2($author$project$Peer$updatePointer, p, h.pointers)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var _v13 = A2($elm$core$Debug$log, 'PeerPointer', err);
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'FormSearchChanged':
				var s = msg.a;
				var res = A3($author$project$Shell$search, s, h.indexCards, h.indexDecks);
				return _Utils_Tuple2(
					A2(
						$author$project$Shell$select,
						A2(
							$elm$core$Maybe$map,
							$author$project$Selection$SearchResult,
							$elm$core$List$head(res)),
						_Utils_update(
							h,
							{formSearch: s, searchResults: res})),
					A2(
						$elm$core$Task$attempt,
						$author$project$Shell$ScrollResults,
						A3($elm$browser$Browser$Dom$setViewportOf, '#search-results', 0, 0)));
			case 'FormSearchSummon':
				var _v14 = h.state.selection;
				if ((_v14.$ === 'Just') && (_v14.a.$ === 'SearchResult')) {
					var result = _v14.a.a;
					return A2(
						$author$project$Shell$doSearchResult,
						result,
						_Utils_Tuple2(h, $elm$core$Platform$Cmd$none));
				} else {
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			case 'FormSearchBlur':
				return _Utils_Tuple2(
					$author$project$Shell$clearSummonSelect(h),
					$elm$core$Platform$Cmd$none);
			case 'DoSearchResult':
				var result = msg.a;
				return A2(
					$author$project$Shell$doSearchResult,
					result,
					_Utils_Tuple2(h, $elm$core$Platform$Cmd$none));
			case 'RemoveAnimation':
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{
							animations: A2($author$project$Animation$remove, id, h.animations)
						}),
					$elm$core$Platform$Cmd$none);
			case 'RollMore':
				var more = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{rollCustomInput: '', rollMore: more}),
					more ? $author$project$Shell$focus($author$project$Shell$elementId.rollCustomInput) : $elm$core$Platform$Cmd$none);
			case 'RollCustomInput':
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						h,
						{rollCustomInput: s}),
					$elm$core$Platform$Cmd$none);
			case 'RollBuiltIn':
				var n = msg.a;
				return A2($author$project$Shell$roll, n, h);
			case 'RollCustom':
				var _v15 = $elm$core$String$toInt(h.rollCustomInput);
				if (_v15.$ === 'Just') {
					var n = _v15.a;
					return ((n >= 2) && (n < 1000)) ? A2($author$project$Shell$roll, n, h) : _Utils_Tuple2(
						h,
						$author$project$Shell$focus($author$project$Shell$elementId.rollCustomInput));
				} else {
					return _Utils_Tuple2(
						h,
						$author$project$Shell$focus($author$project$Shell$elementId.rollCustomInput));
				}
			case 'Focus':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(h, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Shell$updateNickPlaceholder = F2(
	function (s, h) {
		return _Utils_update(
			h,
			{nickPlaceholder: s});
	});
var $author$project$Shell$updateSearchCards = F2(
	function (res, h) {
		return _Utils_update(
			h,
			{
				indexCards: res,
				searchResults: A3($author$project$Shell$search, h.formSearch, res, h.indexDecks)
			});
	});
var $author$project$SearchResult$fromDeck = function (d) {
	return {
		id: d.id,
		name: d.name,
		nameDoc: $author$project$Score$doc(d.name)
	};
};
var $author$project$Shell$updateSearchDecks = F2(
	function (res, h) {
		var decks = A2(
			$elm$core$Maybe$map,
			$elm$core$Result$map(
				$elm$core$List$map($author$project$SearchResult$fromDeck)),
			res);
		return _Utils_update(
			h,
			{
				indexDecks: decks,
				searchResults: A3($author$project$Shell$search, h.formSearch, h.indexCards, decks)
			});
	});
var $author$project$Main$update = F2(
	function (msg, m) {
		switch (msg.$) {
			case 'Shell':
				var sm = msg.a;
				var _v1 = m.state;
				if (_v1.$ === 'Playing') {
					var shell = _v1.a;
					var faces = $author$project$Shell$faces(sm);
					var _v2 = A2($author$project$Measure$add, faces, m.measures);
					var ms = _v2.a;
					var mcmds = _v2.b;
					var _v3 = A3(
						$author$project$Shell$update,
						sm,
						{broadcastPointerPos: $author$project$Main$broadcastPointerPos, noteFromPeer: $author$project$Main$noteFromPeer, pointerCapture: $author$project$Main$pointerCapture, saveNickname: $author$project$Main$saveNickname, setIceConfig: $author$project$Main$setIceConfig},
						shell);
					var h = _v3.a;
					var c = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							m,
							{
								measures: ms,
								state: $author$project$Main$Playing(h)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Shell, c),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Measured, mcmds)
								])));
				} else {
					return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
				}
			case 'GotShell':
				if (msg.a.$ === 'Ok') {
					var shell = msg.a.a.shell;
					var cmd = msg.a.a.cmd;
					var faces = msg.a.a.faces;
					var _v4 = A2($author$project$Measure$add, faces, m.measures);
					var ms = _v4.a;
					var mcmds = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							m,
							{
								measures: ms,
								state: $author$project$Main$Playing(
									A2(
										$author$project$Shell$updateSearchDecks,
										m.availableDecks,
										A2(
											$author$project$Shell$updateSearchCards,
											m.availableCards,
											A2($author$project$Shell$updateNickPlaceholder, m.nickPlaceholder, shell))))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Shell, cmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Measured, mcmds)
								])));
				} else {
					if ((msg.a.a.$ === 'BadStatus') && (msg.a.a.a === 404)) {
						return _Utils_Tuple2(
							m,
							A2($elm$browser$Browser$Navigation$replaceUrl, m.key, '/'));
					} else {
						var err = msg.a.a;
						var _v5 = A2($author$project$DebugHttp$log, 'GotShell', err);
						return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
					}
				}
			case 'Decks':
				if (msg.a.$ === 'Ok') {
					var decks = msg.a.a;
					var faces = _Utils_ap(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.backSample;
							},
							decks),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.frontSample;
							},
							decks));
					var _v6 = A2($author$project$Measure$add, faces, m.measures);
					var ms = _v6.a;
					var mcmds = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							m,
							{
								availableDecks: $elm$core$Maybe$Just(
									$elm$core$Result$Ok(decks)),
								measures: ms,
								state: function () {
									var _v7 = m.state;
									if (_v7.$ === 'Playing') {
										var shell = _v7.a;
										return $author$project$Main$Playing(
											A2(
												$author$project$Shell$updateSearchDecks,
												$elm$core$Maybe$Just(
													$elm$core$Result$Ok(decks)),
												shell));
									} else {
										return m.state;
									}
								}()
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$Measured, mcmds));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							m,
							{
								availableDecks: $elm$core$Maybe$Just(
									$elm$core$Result$Err(err)),
								state: function () {
									var _v8 = m.state;
									if (_v8.$ === 'Playing') {
										var shell = _v8.a;
										return $author$project$Main$Playing(
											A2(
												$author$project$Shell$updateSearchDecks,
												$elm$core$Maybe$Just(
													$elm$core$Result$Err(err)),
												shell));
									} else {
										return m.state;
									}
								}()
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'Cards':
				var res = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{
							availableCards: $elm$core$Maybe$Just(res),
							state: function () {
								var _v9 = m.state;
								if (_v9.$ === 'Playing') {
									var shell = _v9.a;
									return $author$project$Main$Playing(
										A2(
											$author$project$Shell$updateSearchCards,
											$elm$core$Maybe$Just(res),
											shell));
								} else {
									return m.state;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 'Announcement':
				if (msg.a.$ === 'Ok') {
					var ann = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							m,
							{
								announcement: (ann.message === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(ann)
							}),
						$author$project$Main$getAnnouncement(ann.id));
				} else {
					var err = msg.a.a;
					var _v10 = A2($elm$core$Debug$log, 'ann err', err);
					return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
				}
			case 'Now':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{now: t}),
					$elm$core$Platform$Cmd$none);
			case 'Here':
				var z = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{tz: z}),
					$elm$core$Platform$Cmd$none);
			case 'SetNickPlaceholder':
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{
							nickPlaceholder: s,
							state: function () {
								var _v11 = m.state;
								if (_v11.$ === 'Playing') {
									var shell = _v11.a;
									return $author$project$Main$Playing(
										A2($author$project$Shell$updateNickPlaceholder, s, shell));
								} else {
									return m.state;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 'SetNick':
				var nick = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{nick: nick}),
					$author$project$Main$saveNickname(nick));
			case 'StartGame':
				var deckId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{state: $author$project$Main$StartingGame}),
					A2(
						$author$project$Main$startGame,
						deckId,
						(m.nick === '') ? m.nickPlaceholder : m.nick));
			case 'SentStart':
				if (msg.a.$ === 'Ok') {
					var gameId = msg.a.a;
					return _Utils_Tuple2(
						m,
						A2($elm$browser$Browser$Navigation$pushUrl, m.key, '/game/' + gameId));
				} else {
					var err = msg.a.a;
					var _v12 = A2($author$project$DebugHttp$log, 'SentStart', err);
					return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
				}
			case 'Measured':
				var measureMsg = msg.a;
				var _v13 = A2($author$project$Measure$update, measureMsg, m.measures);
				var mst = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{measures: mst}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Measured, cmd));
			case 'OnUrlRequest':
				return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
			default:
				var url = msg.a;
				return A2($author$project$Main$updateUrl, url, m);
		}
	});
var $author$project$Main$SetNick = function (a) {
	return {$: 'SetNick', a: a};
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm_community$typed_svg$TypedSvg$Core$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString = function (length) {
	switch (length.$) {
		case 'Cm':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'cm';
		case 'Em':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'em';
		case 'Ex':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'ex';
		case 'In':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'in';
		case 'Mm':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'mm';
		case 'Num':
			var x = length.a;
			return $elm$core$String$fromFloat(x);
		case 'Pc':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pc';
		case 'Percent':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + '%';
		case 'Pt':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pt';
		case 'Px':
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'px';
		default:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'rem';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$height = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'height',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Types$Px = function (a) {
	return {$: 'Px', a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$px = $elm_community$typed_svg$TypedSvg$Types$Px;
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$height = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$height(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm_community$typed_svg$TypedSvg$Types$Paint = function (a) {
	return {$: 'Paint', a: a};
};
var $elm_community$typed_svg$TypedSvg$Attributes$d = $elm_community$typed_svg$TypedSvg$Core$attribute('d');
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString = function (paint) {
	switch (paint.$) {
		case 'Paint':
			var color = paint.a;
			return $avh4$elm_color$Color$toCssString(color);
		case 'CSSVariable':
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['var(' + (string + ')')]));
		case 'Reference':
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['url(#', string, ')']));
		case 'ContextFill':
			return 'context-fill';
		case 'ContextStroke':
			return 'context-stroke';
		default:
			return 'none';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$fill = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('fill'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm_community$typed_svg$TypedSvg$Core$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm_community$typed_svg$TypedSvg$path = $elm_community$typed_svg$TypedSvg$Core$node('path');
var $author$project$Design$logoSvg = A2(
	$elm_community$typed_svg$TypedSvg$path,
	_List_fromArray(
		[
			$elm_community$typed_svg$TypedSvg$Attributes$fill(
			$elm_community$typed_svg$TypedSvg$Types$Paint(
				A3($avh4$elm_color$Color$rgb255, 40, 40, 46))),
			$elm_community$typed_svg$TypedSvg$Attributes$d('\n            M9.472 33.256\n            C7.82933 33.256 6.272 33.0533 4.8 32.648\n            C3.328 32.2213 2.05867 31.5067 0.992 30.504\n            L1.888 28.968\n            C3.04 29.9493 4.224 30.6107 5.44 30.952\n            C6.67733 31.2933 8.064 31.464 9.6 31.464\n            C11.4347 31.464 12.9173 31.08 14.048 30.312\n            C15.1787 29.5227 15.744 28.4453 15.744 27.08\n            C15.744 26.1413 15.4133 25.3413 14.752 24.68\n            C14.0907 24.0187 12.9067 23.496 11.2 23.112\n            L7.968 22.312\n            C6.496 21.9707 5.312 21.3733 4.416 20.52\n            C3.54133 19.6667 3.104 18.408 3.104 16.744\n            C3.104 15.4213 3.46667 14.2693 4.192 13.288\n            C4.93867 12.3067 5.93067 11.5493 7.168 11.016\n            C8.42667 10.4613 9.81333 10.184 11.328 10.184\n            C12.7573 10.184 14.1547 10.4187 15.52 10.888\n            C16.9067 11.336 18.08 12.0613 19.04 13.064\n            L18.112 14.632\n            C17.152 13.672 16.0853 12.9893 14.912 12.584\n            C13.7387 12.1787 12.5227 11.976 11.264 11.976\n            C10.0907 11.976 9.04533 12.168 8.128 12.552\n            C7.21067 12.936 6.47467 13.48 5.92 14.184\n            C5.38667 14.888 5.12 15.72 5.12 16.68\n            C5.12 17.896 5.408 18.7813 5.984 19.336\n            C6.58133 19.8907 7.44533 20.3067 8.576 20.584\n            L11.84 21.352\n            C13.888 21.8213 15.3813 22.5253 16.32 23.464\n            C17.28 24.3813 17.76 25.512 17.76 26.856\n            C17.76 28.2427 17.3867 29.416 16.64 30.376\n            C15.9147 31.3147 14.9227 32.0293 13.664 32.52\n            C12.4053 33.0107 11.008 33.256 9.472 33.256\n            Z\n            M19.8535 38.76\n            L23.2455 17.48\n            H25.1655\n            L24.7495 20.136\n            C25.3468 19.2187 26.1148 18.504 27.0535 17.992\n            C27.9922 17.4587 29.0695 17.192 30.2855 17.192\n            C32.1202 17.192 33.5815 17.7893 34.6695 18.984\n            C35.7788 20.1787 36.3335 21.8107 36.3335 23.88\n            C36.3335 25.544 36.0242 27.0907 35.4055 28.52\n            C34.8082 29.9493 33.9335 31.1013 32.7815 31.976\n            C31.6295 32.8293 30.2215 33.256 28.5575 33.256\n            C27.3628 33.256 26.2855 32.9787 25.3255 32.424\n            C24.3655 31.848 23.6722 30.9627 23.2455 29.768\n            L21.8055 38.76\n            H19.8535\n            Z\n            M28.4295 31.624\n            C29.7095 31.624 30.7868 31.272 31.6615 30.568\n            C32.5362 29.864 33.1975 28.9253 33.6455 27.752\n            C34.1148 26.5787 34.3495 25.288 34.3495 23.88\n            C34.3495 22.2373 33.9442 20.9893 33.1335 20.136\n            C32.3228 19.2827 31.2028 18.856 29.7735 18.856\n            C28.5148 18.856 27.4375 19.208 26.5415 19.912\n            C25.6668 20.616 25.0055 21.5547 24.5575 22.728\n            C24.1095 23.9013 23.8855 25.192 23.8855 26.6\n            C23.8855 28.2427 24.2802 29.4907 25.0695 30.344\n            C25.8802 31.1973 27.0002 31.624 28.4295 31.624\n            Z\n            M46.3238 33.256\n            C44.1691 33.256 42.4731 32.6587 41.2358 31.464\n            C39.9984 30.2693 39.3798 28.616 39.3798 26.504\n            C39.3798 24.84 39.6998 23.304 40.3398 21.896\n            C41.0011 20.488 41.9291 19.3573 43.1238 18.504\n            C44.3398 17.6293 45.8011 17.192 47.5078 17.192\n            C49.1078 17.192 50.3664 17.576 51.2838 18.344\n            C52.2011 19.0907 52.8198 20.0613 53.1398 21.256\n            C53.4811 22.4293 53.5451 23.6773 53.3318 25\n            L53.2358 25.64\n            H41.3318\n            C41.1184 27.432 41.4598 28.8827 42.3558 29.992\n            C43.2518 31.08 44.5851 31.624 46.3558 31.624\n            C47.3584 31.624 48.2864 31.4747 49.1398 31.176\n            C49.9931 30.8773 50.7718 30.3973 51.4758 29.736\n            L52.2758 31.112\n            C51.5718 31.816 50.6758 32.3493 49.5878 32.712\n            C48.4998 33.0747 47.4118 33.256 46.3238 33.256\n            Z\n            M47.4758 18.76\n            C46.2598 18.76 45.2464 19.0267 44.4358 19.56\n            C43.6251 20.0933 42.9851 20.776 42.5158 21.608\n            C42.0464 22.44 41.7264 23.304 41.5558 24.2\n            H51.7318\n            C51.8384 23.1973 51.7638 22.2907 51.5078 21.48\n            C51.2518 20.648 50.7931 19.9867 50.1318 19.496\n            C49.4918 19.0053 48.6064 18.76 47.4758 18.76\n            Z\n            M60.574 33.256\n            C59.1447 33.256 58.0993 32.8293 57.438 31.976\n            C56.7767 31.1227 56.5847 29.8533 56.862 28.168\n            L59.646 10.44\n            H61.598\n            L58.814 28.168\n            C58.622 29.384 58.7073 30.2587 59.07 30.792\n            C59.454 31.304 60.126 31.56 61.086 31.56\n            C61.5767 31.56 62.0887 31.496 62.622 31.368\n            L62.302 33.032\n            C62.046 33.1173 61.758 33.1707 61.438 33.192\n            C61.118 33.2347 60.83 33.256 60.574 33.256\n            Z\n            M72.995 33.256\n            C71.8003 33.256 70.7123 32.968 69.731 32.392\n            C68.771 31.816 68.0777 30.9307 67.651 29.736\n            L67.171 33\n            H65.219\n            L68.803 10.44\n            H70.755\n            L69.251 20.04\n            C69.827 19.1653 70.5843 18.472 71.523 17.96\n            C72.4617 17.448 73.5283 17.192 74.723 17.192\n            C76.5363 17.192 77.9977 17.7893 79.107 18.984\n            C80.2163 20.1787 80.771 21.8 80.771 23.848\n            C80.771 25.5333 80.4723 27.0907 79.875 28.52\n            C79.2777 29.9493 78.3923 31.1013 77.219 31.976\n            C76.067 32.8293 74.659 33.256 72.995 33.256\n            Z\n            M72.867 31.624\n            C74.147 31.624 75.2243 31.272 76.099 30.568\n            C76.9737 29.864 77.635 28.9253 78.083 27.752\n            C78.5523 26.5787 78.787 25.288 78.787 23.88\n            C78.787 22.2373 78.3817 20.9893 77.571 20.136\n            C76.7603 19.2827 75.6403 18.856 74.211 18.856\n            C72.9523 18.856 71.875 19.208 70.979 19.912\n            C70.1043 20.616 69.443 21.5547 68.995 22.728\n            C68.547 23.9013 68.323 25.192 68.323 26.6\n            C68.323 28.2427 68.7177 29.4907 69.507 30.344\n            C70.3177 31.1973 71.4377 31.624 72.867 31.624\n            Z\n            M90.2812 33.256\n            C88.2759 33.256 86.6973 32.6587 85.5453 31.464\n            C84.3933 30.2693 83.8173 28.616 83.8173 26.504\n            C83.8173 24.8187 84.1266 23.272 84.7453 21.864\n            C85.3853 20.456 86.3026 19.3253 87.4973 18.472\n            C88.6919 17.6187 90.1213 17.192 91.7853 17.192\n            C93.7693 17.192 95.3373 17.8 96.4893 19.016\n            C97.6626 20.2107 98.2493 21.8533 98.2493 23.944\n            C98.2493 25.6507 97.9293 27.208 97.2893 28.616\n            C96.6493 30.024 95.7319 31.1547 94.5373 32.008\n            C93.3639 32.84 91.9453 33.256 90.2812 33.256\n            Z\n            M90.3453 31.624\n            C91.6253 31.624 92.7026 31.272 93.5773 30.568\n            C94.4519 29.864 95.1133 28.9253 95.5613 27.752\n            C96.0306 26.5787 96.2653 25.288 96.2653 23.88\n            C96.2653 22.2373 95.8599 20.9893 95.0493 20.136\n            C94.2386 19.2827 93.1186 18.856 91.6892 18.856\n            C90.4306 18.856 89.3533 19.208 88.4573 19.912\n            C87.5826 20.616 86.9213 21.5547 86.4733 22.728\n            C86.0253 23.9013 85.8013 25.192 85.8013 26.6\n            C85.8013 28.2427 86.1959 29.4907 86.9852 30.344\n            C87.7959 31.1973 88.9159 31.624 90.3453 31.624\n            Z\n            M101.125 33\n            L103.589 17.48\n            H105.509\n            L105.093 20.04\n            C105.584 19.2507 106.245 18.6 107.077 18.088\n            C107.909 17.576 108.944 17.2773 110.181 17.192\n            L111.365 17.096\n            L111.429 18.792\n            L110.021 18.92\n            C108.187 19.0907 106.864 19.6453 106.053 20.584\n            C105.243 21.5013 104.72 22.7173 104.485 24.232\n            L103.109 33\n            H101.125\n            Z\n            M118.083 33.256\n            C116.27 33.256 114.809 32.6693 113.699 31.496\n            C112.611 30.3013 112.067 28.68 112.067 26.632\n            C112.067 24.9467 112.366 23.3893 112.963 21.96\n            C113.561 20.5307 114.435 19.3787 115.587 18.504\n            C116.739 17.6293 118.147 17.192 119.811 17.192\n            C121.006 17.192 122.083 17.48 123.043 18.056\n            C124.003 18.632 124.697 19.5173 125.123 20.712\n            L126.755 10.44\n            H128.707\n            L125.123 33\n            H123.203\n            L123.619 30.376\n            C123.022 31.272 122.254 31.976 121.315 32.488\n            C120.377 33 119.299 33.256 118.083 33.256\n            Z\n            M118.595 31.624\n            C119.875 31.624 120.953 31.272 121.827 30.568\n            C122.702 29.864 123.363 28.9253 123.811 27.752\n            C124.281 26.5787 124.515 25.288 124.515 23.88\n            C124.515 22.2373 124.11 20.9893 123.299 20.136\n            C122.489 19.2827 121.369 18.856 119.939 18.856\n            C118.659 18.856 117.582 19.208 116.707 19.912\n            C115.833 20.616 115.171 21.5547 114.723 22.728\n            C114.275 23.9013 114.051 25.192 114.051 26.6\n            C114.051 28.2427 114.446 29.4907 115.235 30.344\n            C116.046 31.1973 117.166 31.624 118.595 31.624\n            Z\n            ')
		]),
	_List_Nil);
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $author$project$Style$style = $elm$virtual_dom$VirtualDom$style;
var $elm_community$typed_svg$TypedSvg$svg = $elm_community$typed_svg$TypedSvg$Core$node('svg');
var $elm_community$typed_svg$TypedSvg$Attributes$width = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'width',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$width = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$width(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Design$logoHtml = A2(
	$elm_community$typed_svg$TypedSvg$svg,
	_List_fromArray(
		[
			A2($author$project$Style$style, 'display', 'block'),
			A2($author$project$Style$style, 'margin', '19px 37px 17px 37px'),
			$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(129),
			$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(44)
		]),
	_List_fromArray(
		[$author$project$Design$logoSvg]));
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm_community$typed_svg$TypedSvg$Core$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 'MayStopPropagation', a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Measure$get = F2(
	function (_v0, _v1) {
		var id = _v0.id;
		var hint = _v0.hint;
		var known = _v1.known;
		return A2(
			$elm$core$Maybe$withDefault,
			hint,
			A2($elm$core$Dict$get, id, known));
	});
var $author$project$Main$spec = F2(
	function (m, data) {
		return A2($author$project$Measure$get, data, m);
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $elm_community$typed_svg$TypedSvg$clipPath = $elm_community$typed_svg$TypedSvg$Core$node('clipPath');
var $elm_community$typed_svg$TypedSvg$defs = $elm_community$typed_svg$TypedSvg$Core$node('defs');
var $elm_community$typed_svg$TypedSvg$filter = $elm_community$typed_svg$TypedSvg$Core$node('filter');
var $elm_community$typed_svg$TypedSvg$Attributes$href = $elm_community$typed_svg$TypedSvg$Core$attribute('href');
var $elm_community$typed_svg$TypedSvg$Attributes$id = $elm_community$typed_svg$TypedSvg$Core$attribute('id');
var $elm_community$typed_svg$TypedSvg$rect = $elm_community$typed_svg$TypedSvg$Core$node('rect');
var $elm_community$typed_svg$TypedSvg$Attributes$rx = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'rx',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$rx = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$rx(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$ry = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'ry',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$ry = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$ry(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Card$sizeOpponent = {height: 56, width: 40};
var $elm_community$typed_svg$TypedSvg$Attributes$stdDeviation = $elm_community$typed_svg$TypedSvg$Core$attribute('stdDeviation');
var $elm_community$typed_svg$TypedSvg$use = $elm_community$typed_svg$TypedSvg$Core$node('use');
var $elm_community$typed_svg$TypedSvg$Attributes$x = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Defs$view = A2(
	$elm_community$typed_svg$TypedSvg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm_community$typed_svg$TypedSvg$filter,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('selectionBlur')
				]),
			_List_fromArray(
				[
					A3(
					$elm_community$typed_svg$TypedSvg$Core$node,
					'feGaussianBlur',
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$stdDeviation('0.5 0.5')
						]),
					_List_Nil)
				])),
			A2(
			$elm_community$typed_svg$TypedSvg$rect,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardOpponentShape'),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Card$sizeOpponent.width),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Card$sizeOpponent.height),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(4),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$ry(4)
				]),
			_List_Nil),
			A2(
			$elm_community$typed_svg$TypedSvg$clipPath,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardOpponentClipPath')
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$use,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$href('#cardOpponentShape')
						]),
					_List_Nil)
				])),
			A2(
			$elm_community$typed_svg$TypedSvg$rect,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardOnTableShape'),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Card$sizeOnTable.width),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Card$sizeOnTable.height),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(4),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$ry(4)
				]),
			_List_Nil),
			A2(
			$elm_community$typed_svg$TypedSvg$clipPath,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardOnTableClipPath')
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$use,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$href('#cardOnTableShape')
						]),
					_List_Nil)
				])),
			A2(
			$elm_community$typed_svg$TypedSvg$rect,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardInHandShape'),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Card$sizeInHand.width),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Card$sizeInHand.height),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(8),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$ry(8)
				]),
			_List_Nil),
			A2(
			$elm_community$typed_svg$TypedSvg$clipPath,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardInHandClipPath')
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$use,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$href('#cardInHandShape')
						]),
					_List_Nil)
				])),
			A2(
			$elm_community$typed_svg$TypedSvg$clipPath,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardInHandShadowClipPath')
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(-16),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Card$sizeInHand.width + 16),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Card$sizeInHand.height),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(8),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$ry(8)
						]),
					_List_Nil)
				])),
			A2(
			$elm_community$typed_svg$TypedSvg$rect,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardFullShape'),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Face$size.width),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Face$size.height),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(16),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$ry(16)
				]),
			_List_Nil),
			A2(
			$elm_community$typed_svg$TypedSvg$clipPath,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$id('cardFullClipPath')
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$use,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$href('#cardFullShape')
						]),
					_List_Nil)
				]))
		]));
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Design$colorFaceBackground = A3($avh4$elm_color$Color$rgb255, 255, 255, 255);
var $author$project$Design$colorFaceForegroundCssLight = '#28282E';
var $author$project$Face$ifNonempty = F2(
	function (f, l) {
		return _Utils_eq(l, _List_Nil) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			f(l));
	});
var $author$project$ColorExtras$toCss = $avh4$elm_color$Color$toCssString;
var $author$project$Font$BarlowSemiCondensed = {$: 'BarlowSemiCondensed'};
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$HtmlDecoder$extraAttrs = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'img',
			_List_fromArray(
				[
					A2($author$project$Style$style, 'max-width', '90%'),
					A2($author$project$Style$style, 'max-height', '90%')
				]))
		]));
var $author$project$HtmlDecoder$extraAttrsFor = function (tag) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Dict$get, tag, $author$project$HtmlDecoder$extraAttrs));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$HtmlDecoder$html = function (n) {
	if (n.$ === 'Text') {
		var s = n.a;
		return $elm$html$Html$text(s);
	} else {
		var tag = n.a;
		var attrs = n.b;
		var children = n.c;
		return A3(
			$elm$html$Html$node,
			tag,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var k = _v1.k;
						var v = _v1.v;
						return A2($elm$html$Html$Attributes$attribute, k, v);
					},
					attrs),
				$author$project$HtmlDecoder$extraAttrsFor(tag)),
			A2($elm$core$List$map, $author$project$HtmlDecoder$html, children));
	}
};
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Font$attrs = function (c) {
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$class('leading-trim'),
			A2($elm$html$Html$Attributes$style, 'font-family', c.family),
			A2($elm$html$Html$Attributes$style, 'font-size', c.fontSize),
			A2($elm$html$Html$Attributes$style, 'line-height', c.lineHeight),
			A2($elm$html$Html$Attributes$style, '--leading-trim-cap-height', c.capHeightTrim),
			A2($elm$html$Html$Attributes$style, '--leading-trim-baseline', c.baselineTrim)
		]);
};
var $author$project$Font$metrics = function (font) {
	switch (font.$) {
		case 'NunitoSans':
			return {ascent: 1011, capHeight: 705, descent: -353, familyName: 'Nunito Sans', fullName: 'Nunito Sans Regular', lineGap: 0, postscriptName: 'NunitoSans-Regular', subfamilyName: 'Regular', unitsPerEm: 1000, xHeight: 487};
		case 'Barlow':
			return {ascent: 1000, capHeight: 700, descent: -200, familyName: 'Barlow', fullName: 'Barlow Regular', lineGap: 0, postscriptName: 'Barlow-Regular', subfamilyName: 'Regular', unitsPerEm: 1000, xHeight: 506};
		case 'BarlowSemiCondensed':
			return {ascent: 1000, capHeight: 700, descent: -200, familyName: 'Barlow Semi Condensed', fullName: 'Barlow Semi Condensed Regular', lineGap: 0, postscriptName: 'BarlowSemiCondensed-Regular', subfamilyName: 'Regular', unitsPerEm: 1000, xHeight: 506};
		default:
			return {ascent: 1000, capHeight: 700, descent: -200, familyName: 'Barlow Condensed', fullName: 'Barlow Condensed Regular', lineGap: 0, postscriptName: 'BarlowCondensed-Regular', subfamilyName: 'Regular', unitsPerEm: 1000, xHeight: 506};
	}
};
var $author$project$Font$compute = function (_v0) {
	var font = _v0.font;
	var capHeight = _v0.capHeight;
	var leading = _v0.leading;
	var m = $author$project$Font$metrics(font);
	var lineGapScale = m.lineGap / m.unitsPerEm;
	var capHeightScale = m.capHeight / m.unitsPerEm;
	var fontSize = capHeight / capHeightScale;
	var ascentScale = m.ascent / m.unitsPerEm;
	var absoluteDescent = $elm$core$Basics$abs(m.descent);
	var contentArea = (m.ascent + m.lineGap) + absoluteDescent;
	var lineHeightScale = contentArea / m.unitsPerEm;
	var lineHeightNormal = lineHeightScale * fontSize;
	var allowForLineHeight = function (tr) {
		var specifiedLineHeightOffset = (lineHeightNormal - leading) / 2;
		return tr - (specifiedLineHeightOffset / fontSize);
	};
	var capHeightTrim = allowForLineHeight((ascentScale - capHeightScale) + (lineGapScale / 2)) * (-1);
	var descentScale = absoluteDescent / m.unitsPerEm;
	var baselineTrim = allowForLineHeight(descentScale + (lineGapScale / 2)) * (-1);
	return {
		baselineTrim: $elm$core$String$fromFloat(baselineTrim) + 'em',
		capHeightTrim: $elm$core$String$fromFloat(capHeightTrim) + 'em',
		family: m.familyName,
		fontSize: $elm$core$String$fromFloat(fontSize) + 'px',
		lineHeight: $elm$core$String$fromFloat(leading) + 'px'
	};
};
var $author$project$Font$trimStyles = A2($elm$core$Basics$composeL, $author$project$Font$attrs, $author$project$Font$compute);
var $author$project$Font$trim = F3(
	function (f, config, a) {
		return f(
			_Utils_ap(
				$author$project$Font$trimStyles(config),
				a));
	});
var $author$project$Face$viewBody = F2(
	function (_v0, body) {
		var sizeBody = _v0.sizeBody;
		var _v1 = function () {
			switch (sizeBody) {
				case 0:
					return _Utils_Tuple2(14, 24);
				case 1:
					return _Utils_Tuple2(12, 20);
				case 2:
					return _Utils_Tuple2(10, 18);
				default:
					return _Utils_Tuple2(8, 16);
			}
		}();
		var capHeight = _v1.a;
		var leading = _v1.b;
		return A4(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: capHeight, font: $author$project$Font$BarlowSemiCondensed, leading: leading},
			_List_fromArray(
				[
					A2($author$project$Style$style, 'flex', '1'),
					A2($author$project$Style$style, 'margin', '0 16px'),
					A2($author$project$Style$style, 'font-weight', '500')
				]),
			A2($elm$core$List$map, $author$project$HtmlDecoder$html, body));
	});
var $author$project$Design$colorCreatorBackgroundCss = 'rgb(246 241 239)';
var $author$project$Design$colorCreatorForegroundCss = 'rgba(40, 40, 46, 0.75)';
var $author$project$Font$Barlow = {$: 'Barlow'};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Face$viewCreditsText = F2(
	function (flex, html) {
		return A4(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: 7, font: $author$project$Font$Barlow, leading: 13},
			_List_fromArray(
				[
					A2($author$project$Style$style, 'flex', flex),
					A2($author$project$Style$style, 'font-weight', '500'),
					A2($author$project$Style$style, 'width', '0')
				]),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'overflow', 'hidden'),
							A2($author$project$Style$style, 'white-space', 'nowrap'),
							A2($author$project$Style$style, 'text-overflow', 'ellipsis'),
							A2($author$project$Style$style, 'text-align', 'right')
						]),
					html)));
	});
var $author$project$Face$viewCredits = F2(
	function (wikiId, creator) {
		return (_Utils_eq(wikiId, $elm$core$Maybe$Nothing) && _Utils_eq(creator, _List_Nil)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'flex', '0 0 20px'),
						A2($author$project$Style$style, 'margin', '0'),
						A2($author$project$Style$style, 'padding', '5px 16px 8px'),
						A2($author$project$Style$style, 'background-color', $author$project$Design$colorCreatorBackgroundCss),
						A2($author$project$Style$style, 'color', $author$project$Design$colorCreatorForegroundCss),
						A2($author$project$Style$style, 'display', 'flex'),
						A2($author$project$Style$style, 'justify-content', 'space-between'),
						A2($author$project$Style$style, 'gap', '8px'),
						A2($author$project$Style$style, 'border-radius', '0 0 16px 16px')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Face$viewCreditsText,
						'0 0 content',
						function (s) {
							return _List_fromArray(
								[
									$elm$html$Html$text(s)
								]);
						}(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$append('#'),
										$elm$core$String$fromInt),
									wikiId)))),
						A2(
						$author$project$Face$viewCreditsText,
						'1 1 content',
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$text('Card by ')
								]),
							A2($elm$core$List$map, $author$project$HtmlDecoder$html, creator)))
					])));
	});
var $author$project$Font$BarlowCondensed = {$: 'BarlowCondensed'};
var $author$project$Face$viewFlavor = F2(
	function (_v0, html) {
		var sizeBody = _v0.sizeBody;
		var padFlavor = _v0.padFlavor;
		var _v1 = function () {
			switch (sizeBody) {
				case 0:
					return _Utils_Tuple2(12, 20);
				case 1:
					return _Utils_Tuple2(10, 16);
				case 2:
					return _Utils_Tuple2(8, 18);
				default:
					return _Utils_Tuple2(7, 12);
			}
		}();
		var capHeight = _v1.a;
		var leading = _v1.b;
		return A4(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: capHeight, font: $author$project$Font$BarlowCondensed, leading: leading},
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flavor'),
					A2($author$project$Style$style, 'flex', '0'),
					A2($author$project$Style$style, 'margin', '0 16px'),
					A2(
					$author$project$Style$style,
					'padding',
					'0 ' + ($elm$core$String$fromInt(padFlavor) + 'px')),
					A2($author$project$Style$style, 'text-align', 'center'),
					A2($author$project$Style$style, 'font-weight', '400'),
					A2($author$project$Style$style, 'font-style', 'italic')
				]),
			A2($elm$core$List$map, $author$project$HtmlDecoder$html, html));
	});
var $author$project$Design$colorFaceForegroundCssDark = '#FFFFFF';
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {alpha: a, blue: b, green: g, red: r};
};
var $author$project$ColorExtras$isDark = function (c) {
	var _v0 = $avh4$elm_color$Color$toRgba(c);
	var red = _v0.red;
	var green = _v0.green;
	var blue = _v0.blue;
	return (((red * 0.299) + (green * 0.587)) + (blue * 0.114)) < 0.5;
};
var $author$project$Design$scaleFrom255 = function (c) {
	return c / 255;
};
var $author$project$Design$rgba255 = F4(
	function (r, g, b, a) {
		return A4(
			$avh4$elm_color$Color$rgba,
			$author$project$Design$scaleFrom255(r),
			$author$project$Design$scaleFrom255(g),
			$author$project$Design$scaleFrom255(b),
			$author$project$Design$scaleFrom255(a));
	});
var $author$project$Design$colorCardBorder = A4($author$project$Design$rgba255, 152, 103, 75, 77);
var $author$project$Face$viewCorner = F2(
	function (hasTitle, value) {
		var margin = hasTitle ? '-2px' : '8px';
		return A4(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: 16, font: $author$project$Font$BarlowSemiCondensed, leading: 16},
			_List_fromArray(
				[
					A2($author$project$Style$style, 'float', 'right'),
					A2($author$project$Style$style, 'height', '28px'),
					A2($author$project$Style$style, 'max-width', '212px'),
					A2($author$project$Style$style, 'margin', '12px -4px ' + (margin + ' 4px')),
					A2($author$project$Style$style, 'padding', '4px'),
					A2(
					$author$project$Style$style,
					'border',
					'2px solid ' + $author$project$ColorExtras$toCss($author$project$Design$colorCardBorder)),
					A2($author$project$Style$style, 'border-radius', '6px'),
					A2(
					$author$project$Style$style,
					'background',
					$author$project$ColorExtras$toCss($author$project$Design$colorFaceBackground)),
					A2($author$project$Style$style, 'color', $author$project$Design$colorFaceForegroundCssLight),
					A2($author$project$Style$style, 'text-align', 'right'),
					A2($author$project$Style$style, 'font-weight', '600'),
					A2($author$project$Style$style, 'white-space', 'nowrap'),
					A2($author$project$Style$style, 'overflow', 'hidden'),
					A2($author$project$Style$style, 'text-overflow', 'ellipsis')
				]),
			A2($elm$core$List$map, $author$project$HtmlDecoder$html, value));
	});
var $author$project$Face$viewTitle = F2(
	function (_v0, html) {
		var sizeTitle = _v0.sizeTitle;
		var _v1 = function () {
			switch (sizeTitle) {
				case 0:
					return _Utils_Tuple2(
						'16px',
						_Utils_Tuple2(20, 32));
				case 1:
					return _Utils_Tuple2(
						'12px',
						_Utils_Tuple2(16, 24));
				case 2:
					return _Utils_Tuple2(
						'12px',
						_Utils_Tuple2(12, 20));
				default:
					return _Utils_Tuple2(
						'12px',
						_Utils_Tuple2(10, 20));
			}
		}();
		var margin = _v1.a;
		var _v2 = _v1.b;
		var capHeight = _v2.a;
		var leading = _v2.b;
		return A4(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: capHeight, font: $author$project$Font$BarlowSemiCondensed, leading: leading},
			_List_fromArray(
				[
					A2($author$project$Style$style, 'margin', '16px 0 ' + margin),
					A2($author$project$Style$style, 'font-weight', '600'),
					A2($author$project$Style$style, 'overflow-wrap', 'break-word'),
					A2(
					$author$project$Style$style,
					'min-height',
					$elm$core$String$fromInt(capHeight) + 'px')
				]),
			A2($elm$core$List$map, $author$project$HtmlDecoder$html, html));
	});
var $author$project$Face$viewType = F2(
	function (_v0, html) {
		var sizeTitle = _v0.sizeTitle;
		var _v1 = function () {
			switch (sizeTitle) {
				case 0:
					return _Utils_Tuple2(
						'16px',
						_Utils_Tuple2(16, 24));
				case 1:
					return _Utils_Tuple2(
						'12px',
						_Utils_Tuple2(12, 20));
				case 2:
					return _Utils_Tuple2(
						'12px',
						_Utils_Tuple2(10, 20));
				default:
					return _Utils_Tuple2(
						'12px',
						_Utils_Tuple2(8, 16));
			}
		}();
		var margin = _v1.a;
		var _v2 = _v1.b;
		var capHeight = _v2.a;
		var leading = _v2.b;
		return A4(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: capHeight, font: $author$project$Font$BarlowSemiCondensed, leading: leading},
			_List_fromArray(
				[
					A2($author$project$Style$style, 'margin', margin + ' 0'),
					A2($author$project$Style$style, 'font-weight', '500'),
					A2(
					$author$project$Style$style,
					'min-height',
					$elm$core$String$fromInt(capHeight) + 'px')
				]),
			A2($elm$core$List$map, $author$project$HtmlDecoder$html, html));
	});
var $author$project$Face$viewHeader = F2(
	function (fit, _v0) {
		var title = _v0.title;
		var cardType = _v0.cardType;
		var corner = _v0.corner;
		var color = _v0.color;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('header'),
					A2($author$project$Style$style, 'flex', '0 0'),
					A2($author$project$Style$style, 'padding', '0 16px'),
					A2(
					$author$project$Style$style,
					'background',
					$author$project$ColorExtras$toCss(color)),
					A2(
					$author$project$Style$style,
					'color',
					$author$project$ColorExtras$isDark(color) ? $author$project$Design$colorFaceForegroundCssDark : 'initial')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$author$project$Face$ifNonempty,
						$author$project$Face$viewCorner(
							!_Utils_eq(title, _List_Nil)),
						corner),
						$elm$core$Maybe$Just(
						A2($author$project$Face$viewTitle, fit, title)),
						$elm$core$Maybe$Just(
						A2($author$project$Face$viewType, fit, cardType))
					])));
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Face$viewImage = function (u) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'margin', '0 16px'),
				A2($author$project$Style$style, 'text-align', 'center'),
				A2($author$project$Style$style, 'line-height', '0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(u),
						A2($author$project$Style$style, 'max-width', '100%')
					]),
				_List_Nil)
			]));
};
var $author$project$Face$viewData = F2(
	function (fit, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('face'),
					A2($author$project$Style$style, 'display', 'flex'),
					A2($author$project$Style$style, 'flex-flow', 'column nowrap'),
					A2($author$project$Style$style, 'gap', '16px'),
					A2($author$project$Style$style, 'width', '240px'),
					A2($author$project$Style$style, 'min-height', '336px'),
					A2($author$project$Style$style, '-webkit-hyphens', 'auto'),
					A2($author$project$Style$style, '-ms-hyphens', 'auto'),
					A2($author$project$Style$style, 'hyphens', 'auto'),
					A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
					A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale'),
					A2($author$project$Style$style, 'color', $author$project$Design$colorFaceForegroundCssLight),
					A2(
					$author$project$Style$style,
					'background-color',
					$author$project$ColorExtras$toCss($author$project$Design$colorFaceBackground)),
					A2($author$project$Style$style, 'background-size', '240px 336px'),
					A2(
					$author$project$Style$style,
					'background-image',
					function () {
						var _v0 = data.bgImageUrl;
						if (_v0.$ === 'Just') {
							var u = _v0.a;
							return 'url(' + (u + ')');
						} else {
							return 'initial';
						}
					}())
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2($author$project$Face$viewHeader, fit, data)),
						A2($elm$core$Maybe$map, $author$project$Face$viewImage, data.imageUrl),
						$elm$core$Maybe$Just(
						A2($author$project$Face$viewBody, fit, data.body)),
						A2(
						$author$project$Face$ifNonempty,
						$author$project$Face$viewFlavor(fit),
						data.flavor),
						A2($author$project$Face$viewCredits, data.wikiId, data.creator)
					])));
	});
var $author$project$Measure$viewSpec = function (spec) {
	return _Utils_Tuple2(
		$author$project$Measure$key(spec),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(
					$author$project$Measure$key(spec))
				]),
			_List_fromArray(
				[
					A2($author$project$Face$viewData, spec.fit, spec.data)
				])));
};
var $author$project$Measure$view = function (st) {
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				A2($author$project$Style$style, 'content-visibility', 'hidden')
			]),
		A2(
			$elm$core$List$map,
			$author$project$Measure$viewSpec,
			$elm$core$Dict$values(st.active)));
};
var $author$project$Shell$Do = function (a) {
	return {$: 'Do', a: a};
};
var $author$project$Shell$DragStart = F2(
	function (a, b) {
		return {$: 'DragStart', a: a, b: b};
	});
var $author$project$Shell$EnterPile = function (a) {
	return {$: 'EnterPile', a: a};
};
var $author$project$Shell$LeavePile = function (a) {
	return {$: 'LeavePile', a: a};
};
var $author$project$Shell$LostPointerCapture = {$: 'LostPointerCapture'};
var $author$project$Shell$MouseUp = {$: 'MouseUp'};
var $author$project$Shell$PointerDown = F2(
	function (a, b) {
		return {$: 'PointerDown', a: a, b: b};
	});
var $author$project$Shell$PointerLeave = {$: 'PointerLeave'};
var $author$project$Shell$PointerMove = F2(
	function (a, b) {
		return {$: 'PointerMove', a: a, b: b};
	});
var $author$project$Shell$Select = function (a) {
	return {$: 'Select', a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$Translate = F2(
	function (a, b) {
		return {$: 'Translate', a: a, b: b};
	});
var $elm_community$typed_svg$TypedSvg$Attributes$class = function (names) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'class',
		A2($elm$core$String$join, ' ', names));
};
var $author$project$Design$colorPlayArea = A3($avh4$elm_color$Color$rgb255, 255, 247, 228);
var $author$project$Design$colorTable = A3($avh4$elm_color$Color$rgb255, 236, 227, 223);
var $author$project$Design$colorTableShadow = A4($author$project$Design$rgba255, 40, 40, 46, 10);
var $elm_community$typed_svg$TypedSvg$Core$foreignObject = $elm_community$typed_svg$TypedSvg$Core$node('foreignObject');
var $elm_community$typed_svg$TypedSvg$g = $elm_community$typed_svg$TypedSvg$Core$node('g');
var $author$project$Peer$invertLifts = A2(
	$elm$core$Dict$foldl,
	F2(
		function (peer, _v0) {
			var tid = _v0.a;
			var n = _v0.b;
			return A2(
				$elm$core$Dict$insert,
				tid,
				_Utils_Tuple2(peer, n));
		}),
	$elm$core$Dict$empty);
var $author$project$Pointer$id = A2($elm$json$Json$Decode$field, 'pointerId', $elm$json$Json$Decode$int);
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $author$project$Pointer$domPoint = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Point$at,
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float));
var $author$project$Pointer$positionOnCurrentTarget = A2($elm$json$Json$Decode$field, 'pos', $author$project$Pointer$domPoint);
var $author$project$Pointer$onDown = function (tag) {
	return A2(
		$elm$html$Html$Events$on,
		'pointerdown',
		A3($elm$json$Json$Decode$map2, tag, $author$project$Pointer$id, $author$project$Pointer$positionOnCurrentTarget));
};
var $author$project$Pointer$onLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'pointerleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pointer$onLostCapture = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'lostpointercapture',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm_community$typed_svg$TypedSvg$Events$onMouseUp = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mouseup');
var $author$project$Pointer$timeStamp = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $elm$core$Basics$round, $elm$time$Time$millisToPosix),
	A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float));
var $author$project$Pointer$onMove = function (tag) {
	return A2(
		$elm$html$Html$Events$on,
		'pointermove',
		A3($elm$json$Json$Decode$map2, tag, $author$project$Pointer$positionOnCurrentTarget, $author$project$Pointer$timeStamp));
};
var $author$project$Card$scaleInHand = $author$project$Card$sizeInHand.width / $author$project$Face$size.width;
var $author$project$Shell$seatClass = function (g) {
	if (_Utils_eq(g.self, $elm$core$Maybe$Nothing)) {
		return _List_Nil;
	} else {
		var _v0 = g.seat;
		switch (_v0.$) {
			case 'A':
				return _List_fromArray(
					['seat-a']);
			case 'B':
				return _List_fromArray(
					['seat-b']);
			case 'C':
				return _List_fromArray(
					['seat-c']);
			default:
				return _List_fromArray(
					['seat-d']);
		}
	}
};
var $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString = function (xform) {
	var tr = F2(
		function (name, args) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						'(',
						A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, args)),
						')'
					]));
		});
	switch (xform.$) {
		case 'Matrix':
			var a = xform.a;
			var b = xform.b;
			var c = xform.c;
			var d = xform.d;
			var e = xform.e;
			var f = xform.f;
			return A2(
				tr,
				'matrix',
				_List_fromArray(
					[a, b, c, d, e, f]));
		case 'Rotate':
			var a = xform.a;
			var x = xform.b;
			var y = xform.c;
			return A2(
				tr,
				'rotate',
				_List_fromArray(
					[a, x, y]));
		case 'Scale':
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'scale',
				_List_fromArray(
					[x, y]));
		case 'SkewX':
			var x = xform.a;
			return A2(
				tr,
				'skewX',
				_List_fromArray(
					[x]));
		case 'SkewY':
			var y = xform.a;
			return A2(
				tr,
				'skewY',
				_List_fromArray(
					[y]));
		default:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'translate',
				_List_fromArray(
					[x, y]));
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$transform = function (transforms) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'transform',
		A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString, transforms)));
};
var $elm_community$typed_svg$TypedSvg$Types$ClipPathFunc = function (a) {
	return {$: 'ClipPathFunc', a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$Opacity = function (a) {
	return {$: 'Opacity', a: a};
};
var $author$project$Hand$bounds = _Utils_Tuple2(
	A2($author$project$Point$at, 0, $author$project$Table$size + 24),
	A2($author$project$Point$at, $author$project$Table$size, (($author$project$Table$size + 24) + 140) + 24));
var $elm_community$typed_svg$TypedSvg$TypesToStrings$clipPathToString = function (clipPath) {
	switch (clipPath.$) {
		case 'ClipPathNone':
			return 'none';
		case 'ClipPathInherit':
			return 'inherit';
		default:
			var value = clipPath.a;
			return value;
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$clipPath = function (cPath) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'clip-path',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$clipPathToString(cPath));
};
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $elm_community$typed_svg$TypedSvg$TypesToStrings$opacityToString = function (opacity) {
	if (opacity.$ === 'Opacity') {
		var n = opacity.a;
		return $elm$core$String$fromFloat(n);
	} else {
		return 'inherit';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$fillOpacity = function (opa) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'fill-opacity',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$opacityToString(opa));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$svg$Svg$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNodeNS('http://www.w3.org/2000/svg');
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 'MayPreventDefault', a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$DND$onDragStart = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'dragstart',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Hand$realIds = $elm$core$List$filterMap(
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.tid;
		},
		$author$project$Tid$toId));
var $author$project$Tid$toString = function (_v0) {
	var seq = _v0.a;
	var index = _v0.b;
	return $elm$core$String$fromInt(seq) + (':' + $elm$core$String$fromInt(index));
};
var $elm_community$typed_svg$TypedSvg$Types$PaintNone = {$: 'PaintNone'};
var $elm_community$typed_svg$TypedSvg$Attributes$stroke = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('stroke'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $elm_community$typed_svg$TypedSvg$Attributes$strokeWidth = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'stroke-width',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$strokeWidth(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Card$viewBorder = function (_v0) {
	var thickness = _v0.thickness;
	var color = _v0.color;
	var shape = _v0.shape;
	return A2(
		$elm_community$typed_svg$TypedSvg$use,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$href(shape),
				$elm_community$typed_svg$TypedSvg$Attributes$fill($elm_community$typed_svg$TypedSvg$Types$PaintNone),
				$elm_community$typed_svg$TypedSvg$Attributes$stroke(
				$elm_community$typed_svg$TypedSvg$Types$Paint(color)),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(2 * thickness)
			]),
		_List_Nil);
};
var $elm_community$typed_svg$TypedSvg$Types$Scale = F2(
	function (a, b) {
		return {$: 'Scale', a: a, b: b};
	});
var $author$project$Face$viewDefaultBack = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('face'),
			A2($author$project$Style$style, 'width', '240px'),
			A2($author$project$Style$style, 'height', '336px'),
			A2(
			$author$project$Style$style,
			'background-color',
			$author$project$ColorExtras$toCss($author$project$Design$colorFaceBackground)),
			A2($author$project$Style$style, 'background-image', 'url(/back-wavy.svg)')
		]),
	_List_Nil);
var $author$project$Design$colorFacePendingForegroundCss = 'hsl(240deg, 7%, 62%)';
var $author$project$Face$viewUnknownDot = function (delay) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'width', '32px'),
				A2($author$project$Style$style, 'height', '32px'),
				A2($author$project$Style$style, 'background', $author$project$Design$colorFacePendingForegroundCss),
				A2($author$project$Style$style, 'border-radius', '16px'),
				A2($author$project$Style$style, 'animation', 'pulsingDot 3s ease-in-out ' + (delay + ' infinite'))
			]),
		_List_Nil);
};
var $author$project$Face$viewWaitingForPlayer = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($author$project$Style$style, 'display', 'grid'),
			A2($author$project$Style$style, 'width', '240px'),
			A2($author$project$Style$style, 'height', '336px'),
			A2(
			$author$project$Style$style,
			'background',
			$author$project$ColorExtras$toCss($author$project$Design$colorFaceBackground))
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'display', 'flex'),
					A2($author$project$Style$style, 'gap', '24px'),
					A2($author$project$Style$style, 'margin', 'auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'animation', 'expandingDotLeft 4s cubic-bezier(0.37, 0, 0.63, 1) infinite')
						]),
					_List_fromArray(
						[
							$author$project$Face$viewUnknownDot('0.6s')
						])),
					$author$project$Face$viewUnknownDot('0.3s'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'animation', 'expandingDotRight 4s cubic-bezier(0.37, 0, 0.63, 1) infinite')
						]),
					_List_fromArray(
						[
							$author$project$Face$viewUnknownDot('0s')
						]))
				]))
		]));
var $elm_community$typed_svg$TypedSvg$Attributes$viewBox = F4(
	function (minX, minY, vWidth, vHeight) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$attribute,
			'viewBox',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromFloat,
					_List_fromArray(
						[minX, minY, vWidth, vHeight]))));
	});
var $elm_community$typed_svg$TypedSvg$Types$Rotate = F3(
	function (a, b, c) {
		return {$: 'Rotate', a: a, b: b, c: c};
	});
var $elm_community$typed_svg$TypedSvg$Types$StrokeLinecapRound = {$: 'StrokeLinecapRound'};
var $elm_community$typed_svg$TypedSvg$line = $elm_community$typed_svg$TypedSvg$Core$node('line');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm_community$typed_svg$TypedSvg$TypesToStrings$strokeLinecapToString = function (linecap) {
	switch (linecap.$) {
		case 'StrokeLinecapButt':
			return 'butt';
		case 'StrokeLinecapRound':
			return 'round';
		case 'StrokeLinecapSquare':
			return 'square';
		default:
			return 'inherit';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$strokeLinecap = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('stroke-linecap'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$strokeLinecapToString);
var $elm_community$typed_svg$TypedSvg$Attributes$y1 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y1',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y1 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y1(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y2 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y2',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y2 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y2(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Progress$spoke = function (n) {
	return A2(
		$elm_community$typed_svg$TypedSvg$line,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A3($elm_community$typed_svg$TypedSvg$Types$Rotate, n * 45, 0, 0)
					])),
				A2(
				$author$project$Style$style,
				'animation',
				'800ms cubic-bezier(0.33, 0.33, 0.25, 1) ' + ($elm$core$String$fromInt((7 - n) * (-100)) + 'ms infinite spoke')),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(5.5),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2(10.5),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(3),
				$elm_community$typed_svg$TypedSvg$Attributes$strokeLinecap($elm_community$typed_svg$TypedSvg$Types$StrokeLinecapRound)
			]),
		_List_Nil);
};
var $author$project$Progress$viewSvg = A2(
	$elm_community$typed_svg$TypedSvg$g,
	_List_Nil,
	A2(
		$elm$core$List$map,
		$author$project$Progress$spoke,
		A2($elm$core$List$range, 0, 7)));
var $author$project$Progress$view = A2(
	$elm_community$typed_svg$TypedSvg$svg,
	_List_fromArray(
		[
			A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, -14, -14, 28, 28),
			A2($author$project$Style$style, 'width', '28px'),
			A2($author$project$Style$style, 'height', '28px')
		]),
	_List_fromArray(
		[$author$project$Progress$viewSvg]));
var $author$project$Face$viewWaitingForServer = function (contextScale) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'display', 'grid'),
				A2($author$project$Style$style, 'place-items', 'center'),
				A2($author$project$Style$style, 'width', '240px'),
				A2($author$project$Style$style, 'height', '336px'),
				A2(
				$author$project$Style$style,
				'background',
				$author$project$ColorExtras$toCss($author$project$Design$colorFaceBackground)),
				A2(
				$author$project$Style$style,
				'transform',
				'scale(' + ($elm$core$String$fromFloat(1 / contextScale) + ')'))
			]),
		_List_fromArray(
			[$author$project$Progress$view]));
};
var $author$project$Face$viewHelp = F2(
	function (_v0, face) {
		var contextScale = _v0.contextScale;
		var spec = _v0.spec;
		switch (face.$) {
			case 'Blank':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('face'),
							A2($author$project$Style$style, 'width', '240px'),
							A2($author$project$Style$style, 'height', '336px'),
							A2(
							$author$project$Style$style,
							'background',
							$author$project$ColorExtras$toCss($author$project$Design$colorFaceBackground))
						]),
					_List_Nil);
			case 'WaitingForPlayer':
				return $author$project$Face$viewWaitingForPlayer;
			case 'WaitingForServer':
				return $author$project$Face$viewWaitingForServer(contextScale);
			case 'DefaultBack':
				return $author$project$Face$viewDefaultBack;
			default:
				var data = face.a;
				return A2(
					$author$project$Face$viewData,
					spec(data),
					data);
		}
	});
var $author$project$Face$viewScaledTo = F2(
	function (_v0, face) {
		var scale = _v0.scale;
		var spec = _v0.spec;
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$foreignObject,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Scale, scale, scale)
						])),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Face$size.width),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Face$size.height)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Face$viewHelp,
					{contextScale: scale, spec: spec},
					face)
				]));
	});
var $author$project$Card$viewInHand = F3(
	function (spec, face, overlay) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
					$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardInHandClipPath)'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Face$viewScaledTo,
					{scale: $author$project$Card$scaleInHand, spec: spec},
					face),
					$author$project$Card$viewBorder(
					{color: $author$project$Design$colorCardBorder, shape: '#cardInHandShape', thickness: 2}),
					A2($elm_community$typed_svg$TypedSvg$g, _List_Nil, overlay)
				]));
	});
var $author$project$Hand$liftBoxRect = {h: $author$project$Card$sizeInHand.height + 16, w: $author$project$Table$size + 16, x: 0 - 8, y: ($author$project$Table$size + 24) - 8};
var $author$project$Hand$viewLiftBox = function (show) {
	return show ? A2(
		$elm_community$typed_svg$TypedSvg$rect,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, $author$project$Hand$liftBoxRect.x, $author$project$Hand$liftBoxRect.y)
					])),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Hand$liftBoxRect.w),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Hand$liftBoxRect.h),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(15),
				A2($elm$html$Html$Attributes$attribute, 'data-hover-visible-item', ''),
				$elm_community$typed_svg$TypedSvg$Attributes$fill(
				$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$Design$colorCardBorder)),
				$elm_community$typed_svg$TypedSvg$Attributes$fillOpacity(
				$elm_community$typed_svg$TypedSvg$Types$Opacity(0.25)),
				$elm_community$typed_svg$TypedSvg$Attributes$stroke(
				$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$Design$colorCardBorder)),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(2)
			]),
		_List_Nil) : A2($elm_community$typed_svg$TypedSvg$g, _List_Nil, _List_Nil);
};
var $elm_community$typed_svg$TypedSvg$Types$CSSVariable = function (a) {
	return {$: 'CSSVariable', a: a};
};
var $author$project$Hand$viewSelection = function (isSelected) {
	var paint = isSelected ? $elm_community$typed_svg$TypedSvg$Types$CSSVariable('--selection-color') : $elm_community$typed_svg$TypedSvg$Types$PaintNone;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'filter', 'url(#selectionBlur)')
			]),
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$use,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$href('#cardInHandShape'),
						$elm_community$typed_svg$TypedSvg$Attributes$fill(paint),
						$elm_community$typed_svg$TypedSvg$Attributes$stroke(paint),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(16)
					]),
				_List_Nil)
			]));
};
var $author$project$Hand$view = function (_v0) {
	var drag = _v0.drag;
	var liftAll = _v0.liftAll;
	var hover = _v0.hover;
	var onSelect = _v0.onSelect;
	var isSelected = _v0.isSelected;
	var spec = _v0.spec;
	var hand = _v0.hand;
	var hoverExtra = function () {
		if (hover.$ === 'Just') {
			var p = hover.a;
			return A2($author$project$Point$isIn, $author$project$Hand$bounds, p) ? 1 : 0;
		} else {
			return 0;
		}
	}();
	var n = $elm$core$List$length(hand) + hoverExtra;
	var viewCard = F2(
		function (i, _v5) {
			var tid = _v5.tid;
			var face = _v5.face;
			var _v1 = _Utils_Tuple2(
				function () {
					if (hover.$ === 'Just') {
						var p = hover.a;
						return (A2($author$project$Point$isIn, $author$project$Hand$bounds, p) && (_Utils_cmp(
							A2($author$project$Hand$dropIndex, hand, p),
							i) < 1)) ? A2($author$project$Hand$offset, n, i + 1) : A2($author$project$Hand$offset, n, i);
					} else {
						return A2($author$project$Hand$offset, n, i);
					}
				}(),
				$author$project$Table$size + 24);
			var x = _v1.a;
			var y = _v1.b;
			var _v3 = _Utils_Tuple2($author$project$Card$sizeInHand.width, $author$project$Card$sizeInHand.height);
			var w = _v3.a;
			var h = _v3.b;
			return _Utils_Tuple2(
				$author$project$Tid$toString(tid),
				A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, x, y)
								])),
							A2(
							$author$project$Style$style,
							'transition',
							(n < 20) ? 'transform 0.2s' : 'none'),
							A2($author$project$Style$style, 'will-change', 'transform')
						]),
					_List_fromArray(
						[
							$author$project$Hand$viewSelection(
							isSelected(tid)),
							A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
									$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardInHandShadowClipPath)')),
									A2(
									$author$project$Style$style,
									'filter',
									((n > 7) && ((i > 0) && (!isSelected(tid)))) ? 'drop-shadow(0 0 3px #0000001F)' : '')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Card$viewInHand,
									spec,
									face,
									_List_fromArray(
										[
											A2(
											$elm_community$typed_svg$TypedSvg$rect,
											_Utils_ap(
												_List_fromArray(
													[
														$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(w),
														$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(h),
														onSelect(tid)
													]),
												function () {
													var _v4 = $author$project$Tid$toId(tid);
													if (_v4.$ === 'Nothing') {
														return _List_fromArray(
															[
																$elm_community$typed_svg$TypedSvg$Attributes$fill(
																$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$Design$colorPlayArea)),
																$elm_community$typed_svg$TypedSvg$Attributes$fillOpacity(
																$elm_community$typed_svg$TypedSvg$Types$Opacity(0.5))
															]);
													} else {
														var realId = _v4.a;
														return _List_fromArray(
															[
																$elm$html$Html$Attributes$draggable('true'),
																$elm_community$typed_svg$TypedSvg$Attributes$fillOpacity(
																$elm_community$typed_svg$TypedSvg$Types$Opacity(0)),
																liftAll ? $author$project$DND$onDragStart(
																drag(
																	{
																		pos: A2($author$project$Point$at, x + (w / 2), y + (h / 2)),
																		revert: $author$project$Action$PutInHand(0),
																		start: $author$project$Action$PickUpFromHand(
																			$author$project$Hand$realIds(hand))
																	})) : $author$project$DND$onDragStart(
																drag(
																	{
																		pos: A2($author$project$Point$at, x + (w / 2), y + (h / 2)),
																		revert: $author$project$Action$PutInHand(i),
																		start: $author$project$Action$PickUpFromHand(
																			_List_fromArray(
																				[realId]))
																	}))
															]);
													}
												}()),
											_List_Nil)
										]))
								]))
						])));
		});
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'className', 'hand'),
				A2($elm$html$Html$Attributes$attribute, 'data-hover-visible-container', '')
			]),
		_List_fromArray(
			[
				$author$project$Hand$viewLiftBox(liftAll),
				A3(
				$elm$svg$Svg$Keyed$node,
				'g',
				_List_Nil,
				A2($elm$core$List$indexedMap, viewCard, hand))
			]));
};
var $author$project$Seat$pointToScreenFor = function (seat) {
	return $author$project$Point$transform(
		A2(
			$author$project$Point$toOuter,
			$author$project$Table$center,
			A2(
				$author$project$Point$qturn,
				$author$project$Seat$qturns(seat),
				$author$project$Point$identity)));
};
var $author$project$Geometry$translateTo = function (p) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Types$Translate,
		$author$project$Point$getX(p),
		$author$project$Point$getY(p));
};
var $author$project$Design$colorTokenEdge = A3($avh4$elm_color$Color$rgb255, 174, 160, 153);
var $author$project$Token$radiusSmall = 12;
var $author$project$Token$colors = F2(
	function (bga, bgb) {
		return _List_fromArray(
			[
				A2(
				$author$project$Style$style,
				'color',
				$author$project$ColorExtras$isDark(bgb) ? '#FFFFFF' : '#000000'),
				A2($author$project$Style$style, 'background', bga),
				A2(
				$author$project$Style$style,
				'background',
				'linear-gradient(180deg, ' + (bga + (' 0%, ' + ($author$project$ColorExtras$toCss(bgb) + ' 100%)'))))
			]);
	});
var $avh4$elm_color$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, alpha);
	});
var $avh4$elm_color$Color$fromHsla = function (_v0) {
	var hue = _v0.hue;
	var saturation = _v0.saturation;
	var lightness = _v0.lightness;
	var alpha = _v0.alpha;
	return A4($avh4$elm_color$Color$hsla, hue, saturation, lightness, alpha);
};
var $bonzaico$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
	});
var $bonzaico$murmur3$Murmur3$c1 = 3432918353;
var $bonzaico$murmur3$Murmur3$c2 = 461845907;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $bonzaico$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $bonzaico$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $bonzaico$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.hash)) ? (data.seed ^ A2(
		$bonzaico$murmur3$Murmur3$multiplyBy,
		$bonzaico$murmur3$Murmur3$c2,
		A2(
			$bonzaico$murmur3$Murmur3$rotlBy,
			15,
			A2($bonzaico$murmur3$Murmur3$multiplyBy, $bonzaico$murmur3$Murmur3$c1, data.hash)))) : data.seed;
	var h0 = acc ^ data.charsProcessed;
	var h1 = A2($bonzaico$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($bonzaico$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $bonzaico$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$bonzaico$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$bonzaico$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$bonzaico$murmur3$Murmur3$multiplyBy,
					$bonzaico$murmur3$Murmur3$c2,
					A2(
						$bonzaico$murmur3$Murmur3$rotlBy,
						15,
						A2($bonzaico$murmur3$Murmur3$multiplyBy, $bonzaico$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $bonzaico$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.hash | ((255 & $elm$core$Char$toCode(c)) << data.shift);
		var _v0 = data.shift;
		if (_v0 === 24) {
			return {
				charsProcessed: data.charsProcessed + 1,
				hash: 0,
				seed: A2($bonzaico$murmur3$Murmur3$mix, data.seed, res),
				shift: 0
			};
		} else {
			return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
		}
	});
var $bonzaico$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $bonzaico$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$bonzaico$murmur3$Murmur3$hashFold,
				A4($bonzaico$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $author$project$ColorExtras$hash = function (s) {
	var sat = A2($bonzaico$murmur3$Murmur3$hashString, 1, s);
	var normalize = function (n) {
		return A2($elm$core$Basics$modBy, 256, n) / 255;
	};
	var lig = A2($bonzaico$murmur3$Murmur3$hashString, 2, s);
	var hue = A2($bonzaico$murmur3$Murmur3$hashString, 0, s);
	return $avh4$elm_color$Color$fromHsla(
		{
			alpha: 1,
			hue: normalize(hue),
			lightness: (normalize(lig) / 2) + 0.25,
			saturation: (normalize(sat) / 2) + 0.25
		});
};
var $author$project$Token$colorsForName = function (name) {
	switch (name) {
		case 'Money':
			return A2(
				$author$project$Token$colors,
				'#69be97',
				$author$project$ColorExtras$fromCss('#3C9C70'));
		case 'Energy':
			var high = '#FEEDF8';
			var base = '#0ED4F1';
			var grad = _List_fromArray(
				[base, base, high, base, base, high, base, base, high, base]);
			return _List_fromArray(
				[
					A2($author$project$Style$style, 'color', '#000000'),
					A2($author$project$Style$style, 'background', base),
					A2(
					$author$project$Style$style,
					'background',
					A2(
						$elm$core$String$join,
						',',
						_List_fromArray(
							[
								'radial-gradient(' + (base + ('88,' + (base + '00)'))),
								'conic-gradient(' + (A2($elm$core$String$join, ',', grad) + ')')
							])))
				]);
		case 'Zombie':
			return A2(
				$author$project$Token$colors,
				'#9176B6',
				$author$project$ColorExtras$fromCss('#58486F'));
		case 'Air':
			return A2(
				$author$project$Token$colors,
				'#DBEFFE',
				$author$project$ColorExtras$fromCss('#ACC3FD'));
		case 'Blood':
			return A2(
				$author$project$Token$colors,
				'#B51713',
				$author$project$ColorExtras$fromCss('#CA2720'));
		case 'Bone':
			return A2(
				$author$project$Token$colors,
				'#E3DAC9',
				$author$project$ColorExtras$fromCss('#CDC4B3'));
		case 'Brick':
			return A2(
				$author$project$Token$colors,
				'#9C2B16',
				$author$project$ColorExtras$fromCss('#83382A'));
		case 'Candy':
			return _List_fromArray(
				[
					A2($author$project$Style$style, 'color', '#FFFFFF'),
					A2($author$project$Style$style, 'background', '#74E43F'),
					A2($author$project$Style$style, 'background', 'radial-gradient(#74E43F, #169EED, #CF56F3, #F55182, #CF56F3, #169EED, #74E43F)')
				]);
		case 'Crate':
			return A2(
				$author$project$Token$colors,
				'#C0965E',
				$author$project$ColorExtras$fromCss('#986B41'));
		case 'Doom':
			return A2(
				$author$project$Token$colors,
				'#165875',
				$author$project$ColorExtras$fromCss('#1F2026'));
		case 'Earth':
			return A2(
				$author$project$Token$colors,
				'#9B7653',
				$author$project$ColorExtras$fromCss('#56342A'));
		case 'Fire':
			return A2(
				$author$project$Token$colors,
				'#F1C30D',
				$author$project$ColorExtras$fromCss('#F54902'));
		case 'Flame':
			return A2(
				$author$project$Token$colors,
				'#FA6E20',
				$author$project$ColorExtras$fromCss('#EC5418'));
		case 'Fog':
			return A2(
				$author$project$Token$colors,
				'#CCE1E6',
				$author$project$ColorExtras$fromCss('#9D9CA7'));
		case 'Food':
			return A2(
				$author$project$Token$colors,
				'#69E370',
				$author$project$ColorExtras$fromCss('#AFD557'));
		case 'Ghost':
			return A2(
				$author$project$Token$colors,
				'#DEE2F5',
				$author$project$ColorExtras$fromCss('#C3C7DA'));
		case 'Gold':
			return A2(
				$author$project$Token$colors,
				'#FFD700',
				$author$project$ColorExtras$fromCss('#D5B017'));
		case 'Ice':
			return A2(
				$author$project$Token$colors,
				'#A5F2F3',
				$author$project$ColorExtras$fromCss('#6FCCE3'));
		case 'Insanity':
			return A2(
				$author$project$Token$colors,
				'#C871D3',
				$author$project$ColorExtras$fromCss('#15032C'));
		case 'Sanity':
			return A2(
				$author$project$Token$colors,
				'#F2C1CD',
				$author$project$ColorExtras$fromCss('#DC8E9D'));
		case 'Mana':
			return A2(
				$author$project$Token$colors,
				'#127BDD',
				$author$project$ColorExtras$fromCss('#0B5DAA'));
		case 'Paper':
			return A2(
				$author$project$Token$colors,
				'#EBE2CE',
				$author$project$ColorExtras$fromCss('#EBE2CE'));
		case 'Poison':
			return A2(
				$author$project$Token$colors,
				'#60A569',
				$author$project$ColorExtras$fromCss('#509459'));
		case 'Snow':
			return A2(
				$author$project$Token$colors,
				'#E4F3FF',
				$author$project$ColorExtras$fromCss('#DDEAFA'));
		case 'Strawberry Candy':
			return A2(
				$author$project$Token$colors,
				'#FB90A6',
				$author$project$ColorExtras$fromCss('#FB5884'));
		case 'Toxin':
			return A2(
				$author$project$Token$colors,
				'#57683D',
				$author$project$ColorExtras$fromCss('#777248'));
		case 'Void':
			return A2(
				$author$project$Token$colors,
				'#2D3361',
				$author$project$ColorExtras$fromCss('#0C0C35'));
		case 'Water':
			return A2(
				$author$project$Token$colors,
				'#1C8BBC',
				$author$project$ColorExtras$fromCss('#0272C8'));
		case 'Register':
			return A2(
				$author$project$Token$colors,
				'#302420',
				$author$project$ColorExtras$fromCss('#302420'));
		case 'Blank':
			return _List_fromArray(
				[
					A2($author$project$Style$style, 'color', '#FFFFFF'),
					A2($author$project$Style$style, 'background', '#FFFFFF')
				]);
		default:
			return _List_fromArray(
				[
					A2($author$project$Style$style, 'color', '#FFFFFF'),
					A2(
					$author$project$Style$style,
					'background',
					$author$project$ColorExtras$toCss(
						$author$project$ColorExtras$hash(name)))
				]);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {index: index, match: match, number: number, submatches: submatches};
	});
var $elm$regex$Regex$split = _Regex_splitAtMost(_Regex_infinity);
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Token$whitespace = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: true},
		'\\s+'));
var $author$project$Token$initials = function (s) {
	var _v0 = A2($elm$regex$Regex$split, $author$project$Token$whitespace, s);
	if (_v0.b && (!_v0.b.b)) {
		var word = _v0.a;
		return A2($elm$core$String$left, 2, word);
	} else {
		var words = _v0;
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				$elm$core$String$left(1),
				A2($elm$core$List$take, 2, words)));
	}
};
var $author$project$Token$viewIconBase = F2(
	function (isVirtual, name) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Style$style, 'display', 'grid'),
						A2($author$project$Style$style, 'place-items', 'center'),
						A2($author$project$Style$style, 'width', '100%'),
						A2($author$project$Style$style, 'height', '100%'),
						A2($author$project$Style$style, 'border-radius', '1000px')
					]),
				$author$project$Token$colorsForName(name)),
			_List_fromArray(
				[
					A4(
					$author$project$Font$trim,
					$elm$html$Html$div,
					{capHeight: 11, font: $author$project$Font$BarlowSemiCondensed, leading: 12},
					_List_fromArray(
						[
							A2($author$project$Style$style, 'grid-area', '1/1'),
							A2($author$project$Style$style, 'margin', 'auto'),
							A2($author$project$Style$style, 'font-weight', '600'),
							A2($author$project$Style$style, 'text-align', 'center'),
							A2($author$project$Style$style, '-webkit-hyphens', 'auto'),
							A2($author$project$Style$style, '-ms-hyphens', 'auto'),
							A2($author$project$Style$style, 'hyphens', 'auto'),
							A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
							A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale'),
							A2($author$project$Style$style, 'overflow-wrap', 'break-word'),
							A2($author$project$Style$style, 'max-width', '100%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Token$initials(name))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'grid-area', '1/1'),
							A2($author$project$Style$style, 'opacity', '50%'),
							A2(
							$author$project$Style$style,
							'background',
							isVirtual ? $author$project$ColorExtras$toCss($author$project$Design$colorTable) : 'none')
						]),
					_List_Nil)
				]));
	});
var $author$project$Token$widthSmall = 2 * $author$project$Token$radiusSmall;
var $elm_community$typed_svg$TypedSvg$Attributes$y = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Token$viewBaseSmall = function (_v0) {
	var name = _v0.name;
	var isSelected = _v0.isSelected;
	var isVirtual = _v0.isVirtual;
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$foreignObject,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(-$author$project$Token$radiusSmall),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(-$author$project$Token$radiusSmall),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Token$widthSmall),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Token$widthSmall),
				A2($author$project$Style$style, 'border-radius', '1000px'),
				A2(
				$author$project$Style$style,
				'background',
				$author$project$ColorExtras$toCss($author$project$Design$colorTokenEdge)),
				A2($author$project$Style$style, 'padding', '1px'),
				A2(
				$author$project$Style$style,
				'box-shadow',
				isSelected ? '0 0 1px 8px var(--selection-color)' : 'none')
			]),
		_List_fromArray(
			[
				A2($author$project$Token$viewIconBase, isVirtual, name)
			]));
};
var $author$project$Token$viewAir = function (_v0) {
	var name = _v0.name;
	var pos = _v0.pos;
	var isSelected = _v0.isSelected;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						$author$project$Geometry$translateTo(pos)
					])),
				A2($author$project$Style$style, 'will-change', 'transform'),
				A2($author$project$Style$style, 'opacity', '0.4'),
				A2($author$project$Style$style, 'filter', 'drop-shadow(0 8px 32px #00000060)'),
				A2($author$project$Style$style, 'pointer-events', 'none')
			]),
		_List_fromArray(
			[
				$author$project$Token$viewBaseSmall(
				{isSelected: isSelected, isVirtual: false, name: name})
			]));
};
var $author$project$Face$isStatic = function (face) {
	return (!_Utils_eq(face, $author$project$Face$WaitingForPlayer)) && (!_Utils_eq(face, $author$project$Face$WaitingForServer));
};
var $author$project$Stack$depthForView = function (n) {
	return A3($elm$core$Basics$clamp, 0, 6, ((n + 8) / 10) | 0);
};
var $author$project$Pile$selection = function (_v0) {
	var vrot = _v0.vrot;
	var ncards = _v0.ncards;
	var isSelected = _v0.isSelected;
	var w = $author$project$Card$sizeOnTable.width + 16;
	var up = A2($elm$core$Basics$modBy, 2, (vrot / 2) | 0);
	var h = $author$project$Card$sizeOnTable.height + 16;
	var extra = 2 * $author$project$Stack$depthForView(ncards);
	var hex = extra * (1 - A2($elm$core$Basics$modBy, 2, vrot));
	var wex = extra * A2($elm$core$Basics$modBy, 2, vrot);
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'transition', 'transform 0.2s'),
				A2($author$project$Style$style, 'filter', 'url(#selectionBlur)'),
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A3($elm_community$typed_svg$TypedSvg$Types$Rotate, vrot * 90, 0, 0),
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, -((w / 2) + (up * wex)), -((h / 2) + (up * hex)))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$rect,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'transition', 'width 0.2s, height 0.2s'),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(w + wex),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(h + hex),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(12),
						$elm_community$typed_svg$TypedSvg$Attributes$InPx$ry(12),
						$elm_community$typed_svg$TypedSvg$Attributes$fill(
						isSelected ? $elm_community$typed_svg$TypedSvg$Types$CSSVariable('--selection-color') : $elm_community$typed_svg$TypedSvg$Types$PaintNone)
					]),
				_List_Nil)
			]));
};
var $author$project$Stack$top = function (_v0) {
	var faceUp = _v0.faceUp;
	var front = _v0.front;
	var back = _v0.back;
	return faceUp ? front : back;
};
var $elm_community$typed_svg$TypedSvg$Events$onMouseEnter = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mouseenter');
var $elm_community$typed_svg$TypedSvg$Events$onMouseLeave = $elm_community$typed_svg$TypedSvg$Events$simpleOn('mouseleave');
var $author$project$Design$colorCardBorderTable = A4($author$project$Design$rgba255, 136, 110, 95, 153);
var $author$project$Card$viewOnTable = F3(
	function (spec, face, overlay) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, -($author$project$Card$sizeOnTable.width / 2), -($author$project$Card$sizeOnTable.height / 2))
						])),
					$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
					$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardOnTableClipPath)'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Face$viewScaledTo,
					{scale: $author$project$Table$scale, spec: spec},
					face),
					$author$project$Card$viewBorder(
					{color: $author$project$Design$colorCardBorderTable, shape: '#cardOnTableShape', thickness: 1}),
					A2($elm_community$typed_svg$TypedSvg$g, _List_Nil, overlay)
				]));
	});
var $author$project$Stack$viewRestCardOnTable = F2(
	function (vrot, i) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'transition', 'transform 0.2s'),
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, 0, 2 * i),
							A3($elm_community$typed_svg$TypedSvg$Types$Rotate, vrot * 90, 0, 0)
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Card$viewOnTable,
					function ($) {
						return $.hint;
					},
					$author$project$Face$blank,
					_List_Nil)
				]));
	});
var $author$project$Stack$viewOnTable = function (_v0) {
	var vrot = _v0.vrot;
	var enter = _v0.enter;
	var leave = _v0.leave;
	var stack = _v0.stack;
	var spec = _v0.spec;
	var overlay = _v0.overlay;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_Utils_ap(
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['stack-on-table']))
				]),
			_Utils_ap(
				function () {
					if (enter.$ === 'Just') {
						var emsg = enter.a;
						return _List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Events$onMouseEnter(emsg)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				function () {
					if (leave.$ === 'Just') {
						var lmsg = leave.a;
						return _List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Events$onMouseLeave(lmsg)
							]);
					} else {
						return _List_Nil;
					}
				}())),
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Stack$viewRestCardOnTable(vrot),
					$elm$core$List$reverse(
						A2(
							$elm$core$List$range,
							1,
							$author$project$Stack$depthForView(stack.n))))),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$class(
						_List_fromArray(
							['top-card']))
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$g,
						_List_fromArray(
							[
								A2($author$project$Style$style, 'transition', 'transform 0.2s'),
								$elm_community$typed_svg$TypedSvg$Attributes$transform(
								_List_fromArray(
									[
										A3($elm_community$typed_svg$TypedSvg$Types$Rotate, vrot * 90, 0, 0)
									]))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Card$viewOnTable,
								spec,
								$author$project$Stack$top(stack),
								overlay)
							]))
					]))
			]));
};
var $author$project$Pile$viewAnim = function (c) {
	var vrot = c.stack.rot + $author$project$Seat$qturns(c.seat);
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						$author$project$Geometry$translateTo(c.pos)
					])),
				A2($author$project$Style$style, 'pointer-events', 'none')
			]),
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'filter', 'drop-shadow(0 8px 32px #00000060)'),
						A2($author$project$Style$style, 'opacity', '0.4'),
						A2($author$project$Style$style, 'backface-visibility', 'hidden'),
						A2($author$project$Style$style, 'animation', c.animation),
						A2(
						$author$project$Style$style,
						'will-change',
						$author$project$Face$isStatic(
							$author$project$Stack$top(c.stack)) ? 'transform' : '')
					]),
				_List_fromArray(
					[
						$author$project$Pile$selection(
						{isSelected: c.isSelected, ncards: c.stack.n, vrot: vrot}),
						$author$project$Stack$viewOnTable(
						{enter: $elm$core$Maybe$Nothing, leave: $elm$core$Maybe$Nothing, overlay: _List_Nil, spec: c.spec, stack: c.stack, vrot: vrot})
					]))
			]));
};
var $author$project$Game$viewAirOpponents = function (_v0) {
	var postab = _v0.postab;
	var isSelected = _v0.isSelected;
	var spec = _v0.spec;
	var game = _v0.game;
	var pos = F2(
		function (offset, posOnTable) {
			return A2(
				$author$project$Seat$pointToScreenFor,
				game.seat,
				A2($author$project$Pointer$absoluteFrom, posOnTable, offset));
		});
	var viewAir = function (_v4) {
		var id = _v4.a;
		var air = _v4.b.air;
		var _v1 = _Utils_Tuple2(
			air,
			A2($elm$core$Dict$get, id, postab));
		_v1$2:
		while (true) {
			if (_v1.a.$ === 'Just') {
				if (_v1.a.a.$ === 'Stack') {
					if (_v1.b.$ === 'Just') {
						var _v2 = _v1.a.a;
						var stack = _v2.a;
						var offset = _v2.b;
						var wasFlipped = _v2.c;
						var posOnTable = _v1.b.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								stack.faceUp ? ($elm$core$String$fromInt(id) + '-up') : ($elm$core$String$fromInt(id) + '-down'),
								$author$project$Pile$viewAnim(
									{
										animation: wasFlipped ? '200ms both flip-reveal' : 'none',
										isSelected: isSelected(id),
										pos: A2(pos, offset, posOnTable),
										seat: game.seat,
										spec: spec,
										stack: stack
									})));
					} else {
						break _v1$2;
					}
				} else {
					if (_v1.b.$ === 'Just') {
						var _v3 = _v1.a.a;
						var name = _v3.a;
						var offset = _v3.b;
						var posOnTable = _v1.b.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$elm$core$String$fromInt(id),
								$author$project$Token$viewAir(
									{
										isSelected: isSelected(id),
										name: name,
										pos: A2(pos, offset, posOnTable)
									})));
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	return A3(
		$elm$svg$Svg$Keyed$node,
		'g',
		_List_Nil,
		A2(
			$elm$core$List$filterMap,
			viewAir,
			$elm$core$Dict$toList(game.opponents)));
};
var $author$project$Game$viewAirSelf = function (_v0) {
	var pos = _v0.pos;
	var isSelected = _v0.isSelected;
	var spec = _v0.spec;
	var game = _v0.game;
	return A3(
		$elm$svg$Svg$Keyed$node,
		'g',
		_List_Nil,
		function () {
			var _v1 = _Utils_Tuple2(game.air, pos);
			_v1$2:
			while (true) {
				if (_v1.a.$ === 'Just') {
					if (_v1.a.a.$ === 'Stack') {
						if (_v1.b.$ === 'Just') {
							var _v2 = _v1.a.a;
							var stack = _v2.a;
							var wasFlipped = _v2.c;
							var p = _v1.b.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									stack.faceUp ? 'up' : 'down',
									$author$project$Pile$viewAnim(
										{
											animation: wasFlipped ? '200ms both flip-reveal' : 'none',
											isSelected: isSelected,
											pos: p,
											seat: game.seat,
											spec: spec,
											stack: stack
										}))
								]);
						} else {
							break _v1$2;
						}
					} else {
						if (_v1.b.$ === 'Just') {
							var _v3 = _v1.a.a;
							var name = _v3.a;
							var p = _v1.b.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'token',
									$author$project$Token$viewAir(
										{isSelected: isSelected, name: name, pos: p}))
								]);
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _List_Nil;
		}());
};
var $author$project$Shell$RemoveAnimation = function (a) {
	return {$: 'RemoveAnimation', a: a};
};
var $author$project$Seat$isRightOf = F2(
	function (a, b) {
		return _Utils_eq(
			A2(
				$elm$core$Basics$modBy,
				4,
				$author$project$Seat$qturns(a) + 1),
			A2(
				$elm$core$Basics$modBy,
				4,
				$author$project$Seat$qturns(b)));
	});
var $author$project$Seat$isLeftOf = F2(
	function (a, b) {
		return A2($author$project$Seat$isRightOf, b, a);
	});
var $author$project$Animation$onAnimationEnd = function (message) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Events$on,
		'animationend',
		$elm$virtual_dom$VirtualDom$Normal(
			$elm$json$Json$Decode$succeed(message)));
};
var $author$project$Font$NunitoSans = {$: 'NunitoSans'};
var $author$project$Design$colorMenuItemForegroundCss = '#28282E';
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$foreignObject = $elm$svg$Svg$trustedNode('foreignObject');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $author$project$Seat$toString = function (seat) {
	switch (seat.$) {
		case 'A':
			return 'A';
		case 'B':
			return 'B';
		case 'C':
			return 'C';
		default:
			return 'D';
	}
};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Roll$d20icon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 28 32'),
			$elm$svg$Svg$Attributes$width('28'),
			$elm$svg$Svg$Attributes$height('32'),
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			A2($elm$html$Html$Attributes$style, 'transform', 'translateY(2px)')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('\n                  M15.625 1.80422L25.4814 7.49482C26.487 8.07538 27.1064\n                  9.14829 27.1064 10.3094V21.6906C27.1064 22.8517 26.487\n                  23.9246 25.4814 24.5052L15.625 30.1958C14.6194 30.7763\n                  13.3806 30.7763 12.375 30.1958L2.51859 24.5052C1.51304\n                  23.9246 0.893594 22.8517 0.893594\n                  21.6906V10.3094C0.893594 9.14829 1.51304 8.07538 2.51859\n                  7.49482L12.375 1.80422C13.3806 1.22366 14.6194 1.22366\n                  15.625 1.80422Z\n              ')
				]),
			_List_Nil)
		]));
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Bootstrap$icon = function (name) {
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bi-' + name),
				A2($elm$html$Html$Attributes$style, 'width', '1em'),
				A2($elm$html$Html$Attributes$style, 'height', '1em')
			]),
		_List_Nil);
};
var $author$project$Roll$pentagon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 30 29'),
			$elm$svg$Svg$Attributes$width('30'),
			$elm$svg$Svg$Attributes$height('29'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('\n                  M16.9103 2.31497L27.4249 9.95429C28.564 10.7819\n                  29.0406 12.2488 28.6056 13.5879L24.5893 25.9486C24.1542\n                  27.2877 22.9064 28.1943 21.4984 28.1943H8.5016C7.09362\n                  28.1943 5.84576 27.2877 5.41067 25.9486L1.39444\n                  13.5879C0.959352 12.2488 1.43599 10.7819 2.57508\n                  9.95429L13.0897 2.31497C14.2288 1.48737 15.7712 1.48737\n                  16.9103 2.31497Z\n              '),
					$elm$svg$Svg$Attributes$stroke('currentColor'),
					$elm$svg$Svg$Attributes$strokeWidth('1.5')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$Roll$trianglePath = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$d('\n                  M15.9486 1.875L26.3409 19.875C27.2069 21.375 26.1244\n                  23.25 24.3923 23.25H3.60769C1.87564 23.25 0.793111\n                  21.375 1.65914 19.875L12.0514 1.875C12.9175 0.374998\n                  15.0825 0.374998 15.9486 1.875Z\n              ')
		]),
	_List_Nil);
var $author$project$Roll$triangle = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 28 24'),
			$elm$svg$Svg$Attributes$width('28'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5')
		]),
	_List_fromArray(
		[$author$project$Roll$trianglePath]));
var $author$project$Roll$viewButtonNum = F2(
	function (font, n) {
		return A4(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: 14, font: font, leading: 14},
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-weight', '500')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(n))
				]));
	});
var $author$project$Roll$viewBaseIcon = function (_v0) {
	var sides = _v0.sides;
	var value = _v0.value;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'grid'),
				A2($elm$html$Html$Attributes$style, 'place-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'width', '48px'),
				A2($elm$html$Html$Attributes$style, 'height', '48px'),
				A2($elm$html$Html$Attributes$style, 'font-size', '24px'),
				A2($elm$html$Html$Attributes$style, 'line-height', '24px')
			]),
		function () {
			var _v1 = _Utils_Tuple2(sides, value);
			_v1$7:
			while (true) {
				if (_v1.b.$ === 'Just') {
					switch (_v1.a) {
						case 2:
							switch (_v1.b.a) {
								case 1:
									return _List_fromArray(
										[
											$author$project$Bootstrap$icon('emoji-smile')
										]);
								case 2:
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
												]),
											_List_fromArray(
												[
													$author$project$Bootstrap$icon('circle')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'grid-area', '1/1'),
													A2($elm$html$Html$Attributes$style, 'transform', 'translate(-0.8px, 0.4px) scale(62.5%)')
												]),
											_List_fromArray(
												[
													$author$project$Bootstrap$icon('moon-stars-fill')
												]))
										]);
								default:
									break _v1$7;
							}
						case 4:
							var n = _v1.b.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[$author$project$Roll$triangle])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[
											A2($author$project$Roll$viewButtonNum, $author$project$Font$BarlowCondensed, n)
										]))
								]);
						case 6:
							var n = _v1.b.a;
							return _List_fromArray(
								[
									$author$project$Bootstrap$icon(
									'dice-' + $elm$core$String$fromInt(n))
								]);
						case 12:
							var n = _v1.b.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[$author$project$Roll$pentagon])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[
											A2($author$project$Roll$viewButtonNum, $author$project$Font$BarlowCondensed, n)
										]))
								]);
						case 20:
							var n = _v1.b.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[$author$project$Roll$d20icon])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[
											A2($author$project$Roll$viewButtonNum, $author$project$Font$BarlowCondensed, n)
										]))
								]);
						case 100:
							var n = _v1.b.a;
							return _List_fromArray(
								[
									A2(
									$elm$svg$Svg$svg,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
											$elm$svg$Svg$Attributes$width('32'),
											$elm$svg$Svg$Attributes$height('32'),
											$elm$svg$Svg$Attributes$fill('none'),
											$elm$svg$Svg$Attributes$stroke('currentColor'),
											$elm$svg$Svg$Attributes$strokeWidth('1.5'),
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$circle,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$cx('16'),
													$elm$svg$Svg$Attributes$cy('16'),
													$elm$svg$Svg$Attributes$r('15.25')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'grid-area', '1/1')
										]),
									_List_fromArray(
										[
											A2($author$project$Roll$viewButtonNum, $author$project$Font$BarlowCondensed, n)
										]))
								]);
						default:
							break _v1$7;
					}
				} else {
					var _v2 = _v1.b;
					return _List_fromArray(
						[$author$project$Progress$view]);
				}
			}
			var n = _v1.b.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'padding', '1px 0 0'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'gap', '3px')
						]),
					_List_fromArray(
						[
							A2($author$project$Roll$viewButtonNum, $author$project$Font$Barlow, n),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', '24px'),
									A2($elm$html$Html$Attributes$style, 'height', '1px'),
									A2($elm$html$Html$Attributes$style, 'background', 'currentColor'),
									A2($elm$html$Html$Attributes$style, 'opacity', '50%')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'opacity', '50%')
								]),
							_List_fromArray(
								[
									A2($author$project$Roll$viewButtonNum, $author$project$Font$Barlow, sides)
								]))
						]))
				]);
		}());
};
var $author$project$Roll$viewAnim = F3(
	function (seat, name, roll) {
		return A2(
			$elm$svg$Svg$foreignObject,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('208'),
					$elm$svg$Svg$Attributes$height('208')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding', '0 24px'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
							A2($elm$html$Html$Attributes$style, 'gap', '32px'),
							A2($elm$html$Html$Attributes$style, 'animation', '800ms cubic-bezier(0.09, 0.28, 0.85, 0.59) 1200ms both dice-roll-notif'),
							A2($elm$html$Html$Attributes$style, 'width', '208px'),
							A2($elm$html$Html$Attributes$style, 'height', '208px'),
							A2($elm$html$Html$Attributes$style, 'backdrop-filter', 'saturate(120%) blur(30px)'),
							A2(
							$elm$html$Html$Attributes$style,
							'background',
							'var(--seat-color-trans-' + ($author$project$Seat$toString(seat) + ')')),
							A2($elm$html$Html$Attributes$style, 'border-radius', '24px'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
							A2($elm$html$Html$Attributes$style, 'color', $author$project$Design$colorMenuItemForegroundCss)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'flex', '0 0 auto'),
									A2($elm$html$Html$Attributes$style, 'height', '96px'),
									A2($elm$html$Html$Attributes$style, 'display', 'grid'),
									A2($elm$html$Html$Attributes$style, 'place-items', 'center'),
									A2($elm$html$Html$Attributes$style, 'opacity', '66%'),
									A2($elm$html$Html$Attributes$style, 'margin', '4px 0 0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'transform', 'scale(3.33)'),
											A2($elm$html$Html$Attributes$style, 'display', 'grid'),
											A2($elm$html$Html$Attributes$style, 'place-items', 'center')
										]),
									_List_fromArray(
										[
											$author$project$Roll$viewBaseIcon(roll)
										]))
								])),
							A4(
							$author$project$Font$trim,
							$elm$html$Html$div,
							{capHeight: 14, font: $author$project$Font$NunitoSans, leading: 24},
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
									A2($elm$html$Html$Attributes$style, 'font-weight', '700'),
									A2($elm$html$Html$Attributes$style, 'opacity', '66%')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
											A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
											A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]))
								]))
						]))
				]));
	});
var $author$project$Animation$viewRemoveAnimation = A2(
	$elm_community$typed_svg$TypedSvg$g,
	_List_fromArray(
		[
			A2($author$project$Style$style, 'animation', '1ms both empty-anim')
		]),
	_List_Nil);
var $author$project$Pile$viewShuffle = function (_v0) {
	var oldPile = _v0.oldPile;
	var newPile = _v0.newPile;
	var seat = _v0.seat;
	var spec = _v0.spec;
	return _List_fromArray(
		[
			$author$project$Pile$viewAnim(
			{
				animation: '240ms ease-in 3 both shuffle-old-pile',
				isSelected: false,
				pos: A2($author$project$Seat$pointToScreenFor, seat, oldPile.pos),
				seat: seat,
				spec: spec,
				stack: oldPile.stack
			}),
			$author$project$Pile$viewAnim(
			{
				animation: '240ms ease-in 3 both shuffle-new-pile',
				isSelected: false,
				pos: A2($author$project$Seat$pointToScreenFor, seat, newPile.pos),
				seat: seat,
				spec: spec,
				stack: newPile.stack
			})
		]);
};
var $author$project$Animation$view = F2(
	function (c, _v0) {
		var onEnd = c.onEnd;
		var spec = c.spec;
		var seat = c.seat;
		var anims = _v0.a;
		var viewSequential = function (_v7) {
			var id = _v7.a;
			var info = _v7.b;
			var roll = info.a;
			var agentSeat = info.b;
			var name = info.c;
			return _Utils_Tuple2(
				id,
				A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$author$project$Animation$onAnimationEnd(
							onEnd(id)),
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, 256, 416)
								]))
						]),
					_List_fromArray(
						[
							A3($author$project$Roll$viewAnim, agentSeat, name, roll)
						])));
		};
		var viewImmediate = F2(
			function (id, info) {
				switch (info.$) {
					case 'DrawCard':
						var stack = info.a;
						var pos = info.b;
						var dest = info.c;
						return A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_fromArray(
								[
									$author$project$Animation$onAnimationEnd(
									onEnd(id))
								]),
							_List_fromArray(
								[
									$author$project$Pile$viewAnim(
									{
										animation: _Utils_eq(seat, dest) ? '300ms forwards draw-card-self' : (A2($author$project$Seat$isLeftOf, seat, dest) ? '300ms forwards draw-card-left' : (A2($author$project$Seat$isRightOf, seat, dest) ? '300ms forwards draw-card-right' : '300ms forwards draw-card-across')),
										isSelected: false,
										pos: A2($author$project$Seat$pointToScreenFor, seat, pos),
										seat: seat,
										spec: spec,
										stack: stack
									})
								]));
					case 'FlipAwaySelf':
						var air = info.a;
						return A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_fromArray(
								[
									$author$project$Animation$onAnimationEnd(
									onEnd(id))
								]),
							function () {
								var _v2 = _Utils_Tuple2(c.dragPos, air);
								if ((_v2.a.$ === 'Just') && (_v2.b.$ === 'Stack')) {
									var pos = _v2.a.a;
									var _v3 = _v2.b;
									var stack = _v3.a;
									return _List_fromArray(
										[
											$author$project$Pile$viewAnim(
											{
												animation: '200ms both flip-away',
												isSelected: _Utils_eq(
													c.selection,
													$elm$core$Maybe$Just($author$project$Selection$SelfAir)),
												pos: pos,
												seat: seat,
												spec: spec,
												stack: stack
											})
										]);
								} else {
									return _List_fromArray(
										[$author$project$Animation$viewRemoveAnimation]);
								}
							}());
					case 'FlipAwayOppo':
						var oppoId = info.a;
						var air = info.b;
						return A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_fromArray(
								[
									$author$project$Animation$onAnimationEnd(
									onEnd(id))
								]),
							function () {
								var _v4 = _Utils_Tuple2(
									A2($elm$core$Dict$get, oppoId, c.oppoPointers),
									air);
								if ((_v4.a.$ === 'Just') && (_v4.b.$ === 'Stack')) {
									var pos = _v4.a.a;
									var _v5 = _v4.b;
									var stack = _v5.a;
									return _List_fromArray(
										[
											$author$project$Pile$viewAnim(
											{
												animation: '200ms both flip-away',
												isSelected: _Utils_eq(
													c.selection,
													$elm$core$Maybe$Just(
														$author$project$Selection$OpponentAir(oppoId))),
												pos: A2($author$project$Seat$pointToScreenFor, seat, pos),
												seat: seat,
												spec: spec,
												stack: stack
											})
										]);
								} else {
									return _List_fromArray(
										[$author$project$Animation$viewRemoveAnimation]);
								}
							}());
					default:
						var oldPile = info.a;
						var newPile = info.b;
						return A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_fromArray(
								[
									$author$project$Animation$onAnimationEnd(
									onEnd(id))
								]),
							$author$project$Pile$viewShuffle(
								{newPile: newPile, oldPile: oldPile, seat: seat, spec: spec}));
				}
			});
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'pointer-events', 'none')
				]),
			_List_fromArray(
				[
					A3(
					$elm$svg$Svg$Keyed$node,
					'g',
					_List_Nil,
					$elm$core$Dict$toList(
						A2($elm$core$Dict$map, viewImmediate, anims.immediate))),
					A3(
					$elm$svg$Svg$Keyed$node,
					'g',
					_List_Nil,
					A2(
						$elm$core$List$map,
						viewSequential,
						A2($elm$core$List$take, 1, anims.sequential)))
				]));
	});
var $author$project$Shell$viewAnimations = F2(
	function (h, spec) {
		return A2(
			$author$project$Animation$view,
			{
				dragPos: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Shell$drop(h.state.game),
						function ($) {
							return $.pos;
						}),
					h.drag),
				onEnd: $author$project$Shell$RemoveAnimation,
				oppoPointers: h.pointers,
				seat: h.state.game.seat,
				selection: h.state.selection,
				spec: spec
			},
			h.animations);
	});
var $author$project$Shell$viewJoinOverlay = function (playing) {
	return playing ? A2($elm_community$typed_svg$TypedSvg$g, _List_Nil, _List_Nil) : A2(
		$elm_community$typed_svg$TypedSvg$rect,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'pointer-events', 'fill'),
				$elm_community$typed_svg$TypedSvg$Attributes$fill($elm_community$typed_svg$TypedSvg$Types$PaintNone),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(880),
				$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(988)
			]),
		_List_Nil);
};
var $author$project$Seat$isAcross = F2(
	function (a, b) {
		return _Utils_eq(
			A2(
				$elm$core$Basics$modBy,
				2,
				$author$project$Seat$qturns(a)),
			A2(
				$elm$core$Basics$modBy,
				2,
				$author$project$Seat$qturns(b)));
	});
var $author$project$Game$opponentIn = F2(
	function (rel, g) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				rel(g.seat),
				function ($) {
					return $.seat;
				}),
			$elm$core$Dict$values(g.opponents));
	});
var $author$project$Face$DefaultBack = {$: 'DefaultBack'};
var $author$project$Face$defaultBack = $author$project$Face$DefaultBack;
var $author$project$Card$scaleOpponent = $author$project$Card$sizeOpponent.width / $author$project$Face$size.width;
var $author$project$Card$viewOpponent = F2(
	function (spec, face) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
					$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardOpponentClipPath)'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Face$viewScaledTo,
					{scale: $author$project$Card$scaleOpponent, spec: spec},
					face),
					$author$project$Card$viewBorder(
					{color: $author$project$Design$colorCardBorder, shape: '#cardOpponentShape', thickness: 1})
				]));
	});
var $author$project$Opponent$viewCard = function (i) {
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, (i * 8) + 8, 12)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Card$viewOpponent,
				function ($) {
					return $.hint;
				},
				$author$project$Face$defaultBack)
			]));
};
var $author$project$Design$colorNameplateForegroundCss = '#FFFFFF';
var $author$project$Player$viewNameplate = F2(
	function (seat, s) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'width', '80px'),
					A2($author$project$Style$style, 'height', '80px'),
					A2(
					$author$project$Style$style,
					'background',
					'var(--seat-color-' + ($author$project$Seat$toString(seat) + ')')),
					A2($author$project$Style$style, 'padding', '4px 6px'),
					A2($author$project$Style$style, 'display', '-webkit-box'),
					A2($author$project$Style$style, '-webkit-line-clamp', '3'),
					A2($author$project$Style$style, '-webkit-box-orient', 'vertical'),
					A2($author$project$Style$style, 'overflow', 'hidden'),
					A2($author$project$Style$style, 'overflow-wrap', 'break-word'),
					A2($author$project$Style$style, 'font', '700 18px/24px Nunito Sans, sans-serif'),
					A2($author$project$Style$style, 'color', $author$project$Design$colorNameplateForegroundCss),
					A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
					A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(s)
				]));
	});
var $author$project$Player$viewPicture = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($author$project$Style$style, 'width', '80px'),
			A2($author$project$Style$style, 'height', '80px'),
			A2($author$project$Style$style, 'background', 'rgb(0, 0, 0, 5%)')
		]),
	_List_Nil);
var $author$project$Opponent$viewHorizontal = function (_v0) {
	var name = _v0.name;
	var seat = _v0.seat;
	var ncards = _v0.ncards;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 0, 0)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$Core$foreignObject,
						_List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(80),
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(80)
							]),
						_List_fromArray(
							[
								A2($author$project$Player$viewNameplate, seat, name)
							]))
					])),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 80, 0)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$Core$foreignObject,
						_List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(80),
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(80)
							]),
						_List_fromArray(
							[$author$project$Player$viewPicture]))
					])),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 160, 0)
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Opponent$viewCard,
					A2($elm$core$List$range, 0, ncards - 1)))
			]));
};
var $author$project$Opponent$viewVertical = function (_v0) {
	var name = _v0.name;
	var seat = _v0.seat;
	var ncards = _v0.ncards;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 0, 0)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$Core$foreignObject,
						_List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(80),
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(80)
							]),
						_List_fromArray(
							[
								A2($author$project$Player$viewNameplate, seat, name)
							]))
					])),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 0, 80)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$Core$foreignObject,
						_List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(80),
								$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(80)
							]),
						_List_fromArray(
							[$author$project$Player$viewPicture]))
					])),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 80, 160),
								A3($elm_community$typed_svg$TypedSvg$Types$Rotate, 90, 0, 0)
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Opponent$viewCard,
					A2($elm$core$List$range, 0, ncards - 1)))
			]));
};
var $author$project$Game$viewOpponents = function (g) {
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, -80, -80)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 320, 0)
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Opponent$viewHorizontal,
					A2($author$project$Game$opponentIn, $author$project$Seat$isAcross, g))),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 0, 320)
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Opponent$viewVertical,
					A2($author$project$Game$opponentIn, $author$project$Seat$isLeftOf, g))),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 800, 320)
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Opponent$viewVertical,
					A2($author$project$Game$opponentIn, $author$project$Seat$isRightOf, g)))
			]));
};
var $author$project$Pile$modNum = F3(
	function (vrot, lift, clas) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$foreignObject,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						[clas])),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Card$sizeOnTable.width),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Card$sizeOnTable.height),
					A2($author$project$Style$style, 'pointer-events', 'none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'display', 'grid'),
							A2($author$project$Style$style, 'place-items', 'center'),
							A2($author$project$Style$style, 'width', '100%'),
							A2($author$project$Style$style, 'height', '100%')
						]),
					_List_fromArray(
						[
							(lift > 1) ? A4(
							$author$project$Font$trim,
							$elm$html$Html$div,
							{capHeight: 12, font: $author$project$Font$NunitoSans, leading: 12},
							_List_fromArray(
								[
									A2($author$project$Style$style, 'padding', '4px 6px'),
									A2($author$project$Style$style, 'border-radius', '1000px'),
									A2($author$project$Style$style, 'backdrop-filter', 'saturate(120%) blur(20px)'),
									A2($author$project$Style$style, 'background', 'rgba(240 240 240 / 44%)'),
									A2($author$project$Style$style, 'font-weight', 'bold'),
									A2(
									$author$project$Style$style,
									'transform',
									'rotate(' + ($elm$core$String$fromInt((-vrot) * 90) + 'deg)'))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'×' + $elm$core$String$fromInt(lift))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $elm_community$typed_svg$TypedSvg$Events$onDblClick = $elm_community$typed_svg$TypedSvg$Events$simpleOn('dblclick');
var $author$project$Pile$view = function (c) {
	var _do = c._do;
	var drag = c.drag;
	var onSelect = c.onSelect;
	var isSelected = c.isSelected;
	var isTarget = c.isTarget;
	var seat = c.seat;
	var spec = c.spec;
	var pile = c.pile;
	var vrot = pile.stack.rot + $author$project$Seat$qturns(seat);
	var posScreen = A2($author$project$Seat$pointToScreenFor, seat, pile.pos);
	var lift = A2($elm$core$Basics$min, c.lift, pile.stack.n);
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						$author$project$Geometry$translateTo(posScreen)
					])),
				$elm_community$typed_svg$TypedSvg$Attributes$class(
				((lift > 0) && (pile.stack.n > 1)) ? _List_fromArray(
					['lift']) : _List_Nil),
				$elm_community$typed_svg$TypedSvg$Attributes$class(
				((!_Utils_eq(c.peerLift, $elm$core$Maybe$Nothing)) && (pile.stack.n > 1)) ? _List_fromArray(
					['peer-lift']) : _List_Nil)
			]),
		_List_fromArray(
			[
				$author$project$Pile$selection(
				{isSelected: isSelected, ncards: pile.stack.n, vrot: vrot}),
				$author$project$Stack$viewOnTable(
				{
					enter: $elm$core$Maybe$Just(c.enter),
					leave: $elm$core$Maybe$Just(c.leave),
					overlay: _List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$rect,
							_Utils_ap(
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Card$sizeOnTable.width),
										$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Card$sizeOnTable.height),
										onSelect(pile.tid)
									]),
								function () {
									var _v0 = _Utils_Tuple2(
										$author$project$Tid$toId(pile.tid),
										pile.lockedBy);
									if (_v0.a.$ === 'Nothing') {
										var _v1 = _v0.a;
										return _List_fromArray(
											[
												$elm_community$typed_svg$TypedSvg$Attributes$fill(
												$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$Design$colorTable)),
												$elm_community$typed_svg$TypedSvg$Attributes$fillOpacity(
												$elm_community$typed_svg$TypedSvg$Types$Opacity(0.5))
											]);
									} else {
										if (_v0.b.$ === 'Just') {
											return _List_fromArray(
												[
													$elm_community$typed_svg$TypedSvg$Attributes$fillOpacity(
													$elm_community$typed_svg$TypedSvg$Types$Opacity(0))
												]);
										} else {
											var realId = _v0.a.a;
											var _v2 = _v0.b;
											return _List_fromArray(
												[
													$elm$html$Html$Attributes$draggable('true'),
													$author$project$DND$onDragStart(
													(lift > 0) ? drag(
														{
															pos: posScreen,
															revert: $author$project$Action$PutOnPile(realId),
															start: A2($author$project$Action$LiftFromPile, realId, lift)
														}) : drag(
														{
															pos: posScreen,
															revert: A2($author$project$Action$PutOnTable, pile.pos, pile.stack.faceUp),
															start: $author$project$Action$PickUpFromTable(realId)
														})),
													$elm_community$typed_svg$TypedSvg$Events$onDblClick(
													_do(
														$author$project$Action$DrawCards(realId))),
													$elm_community$typed_svg$TypedSvg$Attributes$fill(
													$elm_community$typed_svg$TypedSvg$Types$CSSVariable('--selection-color')),
													$elm_community$typed_svg$TypedSvg$Attributes$fillOpacity(
													isTarget ? $elm_community$typed_svg$TypedSvg$Types$Opacity(0.5) : $elm_community$typed_svg$TypedSvg$Types$Opacity(0))
												]);
										}
									}
								}()),
							_List_Nil),
							A3($author$project$Pile$modNum, vrot, lift, 'mod-num'),
							function () {
							if ((lift > 0) || (pile.stack.n === 1)) {
								return $elm$html$Html$text('');
							} else {
								var _v3 = c.peerLift;
								if (_v3.$ === 'Nothing') {
									return $elm$html$Html$text('');
								} else {
									var _v4 = _v3.a;
									var peer = _v4.a;
									var n = _v4.b;
									return A3(
										$author$project$Pile$modNum,
										vrot,
										A2($elm$core$Basics$min, n, pile.stack.n),
										'peer-mod-num');
								}
							}
						}()
						]),
					spec: spec,
					stack: pile.stack,
					vrot: vrot
				})
			]));
};
var $author$project$Game$viewPiles = function (c) {
	var _do = c._do;
	var drag = c.drag;
	var onSelect = c.onSelect;
	var isSelected = c.isSelected;
	var dragTarget = c.dragTarget;
	var spec = c.spec;
	var game = c.game;
	var viewPile = function (pile) {
		return _Utils_Tuple2(
			$author$project$Tid$toString(pile.tid),
			$author$project$Pile$view(
				{
					_do: _do,
					drag: drag,
					enter: c.enter(pile.tid),
					isSelected: isSelected(pile.tid),
					isTarget: function () {
						var _v0 = $author$project$Tid$toId(pile.tid);
						if (_v0.$ === 'Nothing') {
							return false;
						} else {
							var realId = _v0.a;
							return _Utils_eq(
								dragTarget,
								$elm$core$Maybe$Just(
									$author$project$Action$PutOnPile(realId)));
						}
					}(),
					leave: c.leave(pile.tid),
					lift: c.lift,
					onSelect: onSelect,
					peerLift: A2($elm$core$Dict$get, pile.tid, c.peerLifts),
					pile: pile,
					seat: game.seat,
					spec: spec
				}));
	};
	return A3(
		$elm$svg$Svg$Keyed$node,
		'g',
		_List_Nil,
		A2(
			$elm$core$List$map,
			viewPile,
			$elm$core$Dict$values(game.piles)));
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm_community$typed_svg$TypedSvg$circle = $elm_community$typed_svg$TypedSvg$Core$node('circle');
var $elm_community$typed_svg$TypedSvg$Attributes$cx = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'cx',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$cx = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$cx(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$cy = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'cy',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$cy = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$cy(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$r = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'r',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$r = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$r(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$Peer$viewPointer = F3(
	function (opponents, id, pos) {
		return A2(
			$elm_community$typed_svg$TypedSvg$circle,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$r(10),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$cx(
					$author$project$Point$getX(pos)),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$cy(
					$author$project$Point$getY(pos)),
					A2(
					$author$project$Style$style,
					'stroke',
					A2(
						$elm$core$Maybe$withDefault,
						'rgb(177 177 177)',
						A2(
							$elm$core$Maybe$map,
							function (s) {
								return 'var(--seat-color-' + (s + ')');
							},
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Seat$toString,
									function ($) {
										return $.seat;
									}),
								A2($elm$core$Dict$get, id, opponents))))),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(3),
					$elm_community$typed_svg$TypedSvg$Attributes$fill(
					$elm_community$typed_svg$TypedSvg$Types$Paint(
						A4($avh4$elm_color$Color$rgba, 1, 1, 1, 0.35)))
				]),
			_List_Nil);
	});
var $author$project$Shell$viewPointers = F2(
	function (_v0, pointers) {
		var seat = _v0.seat;
		var opponents = _v0.opponents;
		return A3(
			$elm$svg$Svg$Keyed$node,
			'g',
			_List_fromArray(
				[
					A2($author$project$Style$style, 'pointer-events', 'none')
				]),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($elm$core$String$fromInt),
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$map,
						$author$project$Peer$viewPointer(opponents),
						A2(
							$elm$core$Dict$map,
							function (_v1) {
								return $author$project$Seat$pointToScreenFor(seat);
							},
							pointers)))));
	});
var $author$project$Shell$Join = {$: 'Join'};
var $author$project$Shell$RollBuiltIn = function (a) {
	return {$: 'RollBuiltIn', a: a};
};
var $author$project$Shell$RollCustom = {$: 'RollCustom'};
var $author$project$Shell$RollCustomInput = function (a) {
	return {$: 'RollCustomInput', a: a};
};
var $author$project$Shell$RollMore = function (a) {
	return {$: 'RollMore', a: a};
};
var $author$project$Shell$SetNick = function (a) {
	return {$: 'SetNick', a: a};
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Design$colorChatCss = 'color-mix(in srgb, #FFFFFF 60%, #FFF7E4)';
var $author$project$Design$colorSideBarCss = '#FFE6C6';
var $author$project$Extras$Time$second = 1000;
var $author$project$Extras$Time$minute = 60 * $author$project$Extras$Time$second;
var $author$project$Extras$Time$hour = 60 * $author$project$Extras$Time$minute;
var $author$project$Extras$Time$day = 12 * $author$project$Extras$Time$hour;
var $author$project$Extras$Time$div = F2(
	function (num, den) {
		return $elm$core$Basics$round(num / den);
	});
var $author$project$Extras$Time$week = 7 * $author$project$Extras$Time$day;
var $author$project$Extras$Time$durationString = function (d) {
	return (_Utils_cmp(d, 4 * $author$project$Extras$Time$week) > 0) ? ($elm$core$String$fromInt(
		A2($author$project$Extras$Time$div, d, $author$project$Extras$Time$week)) + ' weeks') : ((_Utils_cmp(d, 2 * $author$project$Extras$Time$day) > 0) ? ($elm$core$String$fromInt(
		A2($author$project$Extras$Time$div, d, $author$project$Extras$Time$day)) + ' days') : ((_Utils_cmp(d, 2 * $author$project$Extras$Time$hour) > 0) ? ($elm$core$String$fromInt(
		A2($author$project$Extras$Time$div, d, $author$project$Extras$Time$hour)) + ' hours') : ((_Utils_cmp(d, 2 * $author$project$Extras$Time$minute) > 0) ? ($elm$core$String$fromInt(
		A2($author$project$Extras$Time$div, d, $author$project$Extras$Time$minute)) + ' min') : ($elm$core$String$fromInt(
		A2($author$project$Extras$Time$div, d, $author$project$Extras$Time$second)) + 's'))));
};
var $author$project$Extras$Time$elapsed = F2(
	function (a, b) {
		return $elm$time$Time$posixToMillis(b) - $elm$time$Time$posixToMillis(a);
	});
var $author$project$Extras$Time$monthName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$pad = F3(
	function (n, _char, string) {
		var half = (n - $elm$core$String$length(string)) / 2;
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				$elm$core$Basics$ceiling(half),
				$elm$core$String$fromChar(_char)),
			_Utils_ap(
				string,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$floor(half),
					$elm$core$String$fromChar(_char))));
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.start, posixMinutes) < 0) {
					return posixMinutes + era.offset;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		month: month,
		year: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).day;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = {$: 'Apr'};
var $elm$time$Time$Aug = {$: 'Aug'};
var $elm$time$Time$Dec = {$: 'Dec'};
var $elm$time$Time$Feb = {$: 'Feb'};
var $elm$time$Time$Jan = {$: 'Jan'};
var $elm$time$Time$Jul = {$: 'Jul'};
var $elm$time$Time$Jun = {$: 'Jun'};
var $elm$time$Time$Mar = {$: 'Mar'};
var $elm$time$Time$May = {$: 'May'};
var $elm$time$Time$Nov = {$: 'Nov'};
var $elm$time$Time$Oct = {$: 'Oct'};
var $elm$time$Time$Sep = {$: 'Sep'};
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).month;
		switch (_v0) {
			case 1:
				return $elm$time$Time$Jan;
			case 2:
				return $elm$time$Time$Feb;
			case 3:
				return $elm$time$Time$Mar;
			case 4:
				return $elm$time$Time$Apr;
			case 5:
				return $elm$time$Time$May;
			case 6:
				return $elm$time$Time$Jun;
			case 7:
				return $elm$time$Time$Jul;
			case 8:
				return $elm$time$Time$Aug;
			case 9:
				return $elm$time$Time$Sep;
			case 10:
				return $elm$time$Time$Oct;
			case 11:
				return $elm$time$Time$Nov;
			default:
				return $elm$time$Time$Dec;
		}
	});
var $elm$time$Time$Fri = {$: 'Fri'};
var $elm$time$Time$Mon = {$: 'Mon'};
var $elm$time$Time$Sat = {$: 'Sat'};
var $elm$time$Time$Sun = {$: 'Sun'};
var $elm$time$Time$Thu = {$: 'Thu'};
var $elm$time$Time$Tue = {$: 'Tue'};
var $elm$time$Time$Wed = {$: 'Wed'};
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return $elm$time$Time$Thu;
			case 1:
				return $elm$time$Time$Fri;
			case 2:
				return $elm$time$Time$Sat;
			case 3:
				return $elm$time$Time$Sun;
			case 4:
				return $elm$time$Time$Mon;
			case 5:
				return $elm$time$Time$Tue;
			default:
				return $elm$time$Time$Wed;
		}
	});
var $author$project$Extras$Time$weekdayName = function (w) {
	switch (w.$) {
		case 'Sun':
			return 'Sun';
		case 'Mon':
			return 'Mon';
		case 'Tue':
			return 'Tue';
		case 'Wed':
			return 'Wed';
		case 'Thu':
			return 'Thu';
		case 'Fri':
			return 'Fri';
		default:
			return 'Sat';
	}
};
var $author$project$Extras$Time$toString = F2(
	function (z, t) {
		var min = A2($elm$time$Time$toMinute, z, t);
		var hour24 = A2($elm$time$Time$toHour, z, t);
		var _v0 = ((!hour24) && (!min)) ? _Utils_Tuple2(12, ' midnight') : (((hour24 === 12) && (!min)) ? _Utils_Tuple2(12, ' noon') : ((!hour24) ? _Utils_Tuple2(12, 'am') : ((hour24 < 12) ? _Utils_Tuple2(hour24, 'am') : _Utils_Tuple2(hour24 - 12, 'pm'))));
		var hour12 = _v0.a;
		var ampm = _v0.b;
		return $author$project$Extras$Time$weekdayName(
			A2($elm$time$Time$toWeekday, z, t)) + (', ' + ($author$project$Extras$Time$monthName(
			A2($elm$time$Time$toMonth, z, t)) + (' ' + ($elm$core$String$fromInt(
			A2($elm$time$Time$toDay, z, t)) + (', ' + ($elm$core$String$fromInt(hour12) + (':' + (A3(
			$elm$core$String$pad,
			2,
			_Utils_chr('0'),
			$elm$core$String$fromInt(min)) + ampm))))))));
	});
var $author$project$Announcement$eta = F3(
	function (tz, now, time) {
		var d = A2($author$project$Extras$Time$elapsed, now, time);
		var ds = (d > 0) ? ('in ' + $author$project$Extras$Time$durationString(d)) : 'now';
		return A2($author$project$Extras$Time$toString, tz, time) + (' (' + (ds + ')'));
	});
var $author$project$Menu$input = function (c) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'margin', '0 auto 8px'),
				A2($author$project$Style$style, 'width', '224px'),
				A2($author$project$Style$style, 'height', '32px')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Font$trim,
				$elm$html$Html$input,
				{capHeight: 10, font: $author$project$Font$NunitoSans, leading: 16},
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$value(c.value),
						$elm$html$Html$Events$onInput(c.onInput),
						$elm$html$Html$Attributes$placeholder(c.placeholder),
						A2($author$project$Style$style, 'width', '100%'),
						A2($author$project$Style$style, 'height', '100%'),
						A2($author$project$Style$style, 'padding', '11px 8px'),
						A2($author$project$Style$style, 'border', 'none'),
						A2($author$project$Style$style, 'border-radius', '8px'),
						A2($author$project$Style$style, 'font-weight', '600'),
						A2($author$project$Style$style, '-webkit-appearance', 'none'),
						A2($author$project$Style$style, 'appearance', 'none')
					]),
				_List_Nil)
			]));
};
var $author$project$Menu$Item = function (a) {
	return {$: 'Item', a: a};
};
var $author$project$Menu$itemHtml = F2(
	function (action, label) {
		return $author$project$Menu$Item(
			{caption: $elm$core$Maybe$Nothing, icon: $elm$core$Maybe$Nothing, isEnabled: true, isSelected: false, label: label, onclick: action});
	});
var $author$project$Menu$item = F2(
	function (action, label) {
		return A2(
			$author$project$Menu$itemHtml,
			action,
			$elm$html$Html$text(label));
	});
var $author$project$Design$colorMenuItemHighlight = A3($avh4$elm_color$Color$rgb255, 222, 163, 139);
var $author$project$Menu$itemDiv = A2(
	$author$project$Font$trim,
	$elm$html$Html$div,
	{capHeight: 10, font: $author$project$Font$NunitoSans, leading: 18});
var $author$project$Style$on = F3(
	function (name, toString, v) {
		return _List_fromArray(
			[
				A2($elm$virtual_dom$VirtualDom$attribute, 'data-' + name, ''),
				A2(
				$elm$virtual_dom$VirtualDom$style,
				'--' + name,
				toString(v))
			]);
	});
var $author$project$Style$onActiveOpacity = A2($author$project$Style$on, 'active-opacity', $elm$core$String$fromFloat);
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Style$onHoverBackgroundColor = A2($author$project$Style$on, 'hover-background-color', $author$project$ColorExtras$toCss);
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $avh4$elm_color$Color$toHsla = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var minColor = A2(
		$elm$core$Basics$min,
		r,
		A2($elm$core$Basics$min, g, b));
	var maxColor = A2(
		$elm$core$Basics$max,
		r,
		A2($elm$core$Basics$max, g, b));
	var l = (minColor + maxColor) / 2;
	var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
	var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
	var h2 = h1 * (1 / 6);
	var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
	return {alpha: a, hue: h3, lightness: l, saturation: s};
};
var $author$project$ColorExtras$opacity = F2(
	function (o, c) {
		var hsla = $avh4$elm_color$Color$toHsla(c);
		return $avh4$elm_color$Color$fromHsla(
			_Utils_update(
				hsla,
				{alpha: o}));
	});
var $author$project$Menu$viewItemCaption = function (caption) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'grid-area', '2/1'),
				A2($author$project$Style$style, 'padding', '0 40px 7px')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Font$trim,
				$elm$html$Html$div,
				{capHeight: 9, font: $author$project$Font$NunitoSans, leading: 16},
				_List_fromArray(
					[
						A2($author$project$Style$style, 'display', '-webkit-box'),
						A2($author$project$Style$style, '-webkit-line-clamp', '2'),
						A2($author$project$Style$style, '-webkit-box-orient', 'vertical'),
						A2($author$project$Style$style, 'overflow', 'hidden'),
						A2($author$project$Style$style, 'padding', '0 0 1px'),
						A2($author$project$Style$style, 'overflow-wrap', 'break-word'),
						A2($author$project$Style$style, 'font-weight', '600'),
						A2($author$project$Style$style, 'color', $author$project$Design$colorMenuItemForegroundCss),
						A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
						A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale')
					]),
				_List_fromArray(
					[caption]))
			]));
};
var $author$project$Menu$viewItemIcon = function (icon) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'flex', '0 0 24px'),
				A2($author$project$Style$style, 'align-self', 'unsafe center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'height', '0'),
						A2($author$project$Style$style, 'width', '24px'),
						A2($author$project$Style$style, 'margin-left', '-2px'),
						A2($author$project$Style$style, 'display', 'grid'),
						A2($author$project$Style$style, 'place-items', 'unsafe center'),
						A2($author$project$Style$style, 'place-content', 'unsafe center')
					]),
				_List_fromArray(
					[icon]))
			]));
};
var $author$project$Menu$viewItemLabel = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'padding', '9px 0')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Menu$itemDiv,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'flex', '1 0 0'),
						A2($author$project$Style$style, 'align-self', 'stretch'),
						A2($author$project$Style$style, 'display', '-webkit-box'),
						A2($author$project$Style$style, '-webkit-line-clamp', '3'),
						A2($author$project$Style$style, '-webkit-box-orient', 'vertical'),
						A2($author$project$Style$style, 'overflow', 'hidden'),
						A2($author$project$Style$style, 'padding', '3px 0'),
						A2($author$project$Style$style, 'overflow-wrap', 'break-word'),
						A2($author$project$Style$style, 'font-weight', '600'),
						A2($author$project$Style$style, 'color', $author$project$Design$colorMenuItemForegroundCss),
						A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
						A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale')
					]),
				_List_fromArray(
					[label]))
			]));
};
var $author$project$Menu$viewItemHead = F2(
	function (label, icon) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'grid-area', '1/1'),
					A2($author$project$Style$style, 'display', 'flex'),
					A2($author$project$Style$style, 'align-items', 'top'),
					A2($author$project$Style$style, 'gap', '4px'),
					A2($author$project$Style$style, 'padding', '0 40px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2($elm$core$Maybe$map, $author$project$Menu$viewItemIcon, icon)),
					$author$project$Menu$viewItemLabel(label)
				]));
	});
var $author$project$Menu$viewItem = function (it) {
	if (it.$ === 'Item') {
		var onclick = it.a.onclick;
		var label = it.a.label;
		var icon = it.a.icon;
		var caption = it.a.caption;
		var isEnabled = it.a.isEnabled;
		var isSelected = it.a.isSelected;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Style$style, 'display', 'grid')
					]),
				isEnabled ? _Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(onclick)
						]),
					_Utils_ap(
						$author$project$Style$onHoverBackgroundColor($author$project$Design$colorMenuItemHighlight),
						$author$project$Style$onActiveOpacity(0.25))) : _List_fromArray(
					[
						A2($author$project$Style$style, 'opacity', '50%')
					])),
			_List_fromArray(
				[
					isSelected ? A2(
					$author$project$Menu$itemDiv,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'grid-area', '1/1/3'),
							A2($author$project$Style$style, 'padding', '12px 40px'),
							A2($author$project$Style$style, 'text-align', 'right'),
							A2(
							$author$project$Style$style,
							'background',
							$author$project$ColorExtras$toCss(
								A2($author$project$ColorExtras$opacity, 0.5, $author$project$Design$colorMenuItemHighlight)))
						]),
					_List_fromArray(
						[
							$author$project$Bootstrap$icon('arrow-return-left')
						])) : $elm$html$Html$text(''),
					A2($author$project$Menu$viewItemHead, label, icon),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2($elm$core$Maybe$map, $author$project$Menu$viewItemCaption, caption))
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'margin', '7.5px auto'),
					A2($author$project$Style$style, 'width', '206px'),
					A2($author$project$Style$style, 'height', '1px'),
					A2($author$project$Style$style, 'background', $author$project$Design$colorMenuItemForegroundCss),
					A2($author$project$Style$style, 'opacity', '25%')
				]),
			_List_Nil);
	}
};
var $author$project$Menu$view = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'margin-bottom', '32px')
			]),
		A2($elm$core$List$map, $author$project$Menu$viewItem, children));
};
var $author$project$Card$viewFull = F2(
	function (spec, face) {
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
					$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardFullClipPath)'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Face$viewScaledTo,
					{scale: 1, spec: spec},
					face),
					$author$project$Card$viewBorder(
					{color: $author$project$Design$colorCardBorder, shape: '#cardFullShape', thickness: 3})
				]));
	});
var $author$project$Stack$viewRestCardFull = function (i) {
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_fromArray(
			[
				$elm_community$typed_svg$TypedSvg$Attributes$transform(
				_List_fromArray(
					[
						A2($elm_community$typed_svg$TypedSvg$Types$Translate, 0, 8 * i)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Card$viewFull,
				function ($) {
					return $.hint;
				},
				$author$project$Face$blank)
			]));
};
var $author$project$Stack$viewDetail = F2(
	function (spec, stack) {
		var n = stack.n;
		return A2(
			$elm_community$typed_svg$TypedSvg$svg,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'display', 'block'),
					A2($author$project$Style$style, 'margin', '0 auto 16px'),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Face$size.width),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(
					$author$project$Face$size.height + (8 * $author$project$Stack$depthForView(n)))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Stack$viewRestCardFull,
						$elm$core$List$reverse(
							A2(
								$elm$core$List$range,
								1,
								$author$project$Stack$depthForView(n))))),
					A2(
					$author$project$Card$viewFull,
					spec,
					$author$project$Stack$top(stack))
				]));
	});
var $author$project$Token$radiusDetail = 60;
var $author$project$Token$widthDetail = 2 * $author$project$Token$radiusDetail;
var $author$project$Token$viewDetail = function (name) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'display', 'grid'),
				A2($author$project$Style$style, 'place-items', 'center'),
				A2($author$project$Style$style, 'margin', '0 auto 16px'),
				A2($author$project$Style$style, 'width', '224px'),
				A2(
				$author$project$Style$style,
				'height',
				$elm$core$String$fromInt($author$project$Token$widthDetail + $author$project$Token$radiusDetail) + 'px'),
				A2($author$project$Style$style, 'border-radius', '8px'),
				A2(
				$author$project$Style$style,
				'background',
				$author$project$ColorExtras$toCss($author$project$Design$colorTable))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_Utils_ap(
					_List_fromArray(
						[
							A2($author$project$Style$style, 'display', 'grid'),
							A2($author$project$Style$style, 'grid', '100% / 100%'),
							A2($author$project$Style$style, 'place-items', 'center'),
							A2(
							$author$project$Style$style,
							'width',
							$elm$core$String$fromInt($author$project$Token$widthDetail) + 'px'),
							A2(
							$author$project$Style$style,
							'height',
							$elm$core$String$fromInt($author$project$Token$widthDetail) + 'px'),
							A2($author$project$Style$style, 'padding', '4px'),
							A2($author$project$Style$style, 'border-radius', '1000px'),
							A2(
							$author$project$Style$style,
							'box-shadow',
							A2(
								$elm$core$String$join,
								', ',
								_List_fromArray(
									[
										' 0 0 0 2px ' + $author$project$ColorExtras$toCss($author$project$Design$colorTokenEdge),
										' 0 3px 0 2px ' + $author$project$ColorExtras$toCss($author$project$Design$colorTokenEdge)
									])))
						]),
					$author$project$Token$colorsForName(name)),
				_List_fromArray(
					[
						A4(
						$author$project$Font$trim,
						$elm$html$Html$div,
						{capHeight: 22, font: $author$project$Font$BarlowSemiCondensed, leading: 24},
						_List_fromArray(
							[
								A2($author$project$Style$style, 'margin', 'auto'),
								A2($author$project$Style$style, 'font-weight', '600'),
								A2($author$project$Style$style, 'text-align', 'center'),
								A2($author$project$Style$style, '-webkit-hyphens', 'auto'),
								A2($author$project$Style$style, '-ms-hyphens', 'auto'),
								A2($author$project$Style$style, 'hyphens', 'auto'),
								A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
								A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale'),
								A2($author$project$Style$style, 'overflow-wrap', 'break-word'),
								A2($author$project$Style$style, 'max-width', '100%')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]))
			]));
};
var $author$project$Token$viewDetailAir = $author$project$Token$viewDetail;
var $author$project$Air$viewDetail = F2(
	function (spec, air) {
		if (air.$ === 'Stack') {
			var stack = air.a;
			return A2($author$project$Stack$viewDetail, spec, stack);
		} else {
			var name = air.a;
			return $author$project$Token$viewDetailAir(name);
		}
	});
var $author$project$Stack$single = F2(
	function (face, rot) {
		return A3($author$project$Stack$from, face, 1, rot);
	});
var $author$project$Hand$viewDetail = F2(
	function (spec, face) {
		return A2(
			$author$project$Stack$viewDetail,
			spec,
			A2($author$project$Stack$single, face, 0));
	});
var $author$project$Menu$Divider = {$: 'Divider'};
var $author$project$Menu$divider = $author$project$Menu$Divider;
var $author$project$Menu$enabled = F2(
	function (b, it) {
		if (it.$ === 'Item') {
			var v = it.a;
			return $author$project$Menu$Item(
				_Utils_update(
					v,
					{isEnabled: b}));
		} else {
			return it;
		}
	});
var $author$project$Menu$viewCaption = function (s) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'margin-bottom', '32px')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Font$trim,
				$elm$html$Html$div,
				{capHeight: 10, font: $author$project$Font$NunitoSans, leading: 16},
				_List_fromArray(
					[
						A2($author$project$Style$style, 'padding', '12px 40px'),
						A2($author$project$Style$style, 'display', '-webkit-box'),
						A2($author$project$Style$style, '-webkit-line-clamp', '3'),
						A2($author$project$Style$style, '-webkit-box-orient', 'vertical'),
						A2($author$project$Style$style, 'overflow', 'hidden'),
						A2($author$project$Style$style, 'overflow-wrap', 'break-word'),
						A2($author$project$Style$style, 'font-weight', '600'),
						A2($author$project$Style$style, 'color', $author$project$Design$colorMenuItemForegroundCss),
						A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
						A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(s)
					]))
			]));
};
var $author$project$Pile$viewDetail = F3(
	function (_do, spec, p) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Stack$viewDetail, spec, p.stack),
					function () {
					var _v0 = _Utils_Tuple2(
						$author$project$Tid$toId(p.tid),
						p.lockedBy);
					if (_v0.a.$ === 'Nothing') {
						var _v1 = _v0.a;
						return $author$project$Menu$viewCaption('Waiting for server...');
					} else {
						if (_v0.b.$ === 'Just') {
							return $author$project$Menu$viewCaption('Currently Being Edited...');
						} else {
							var realId = _v0.a.a;
							var _v2 = _v0.b;
							return $author$project$Menu$view(
								_List_fromArray(
									[
										A2(
										$author$project$Menu$item,
										_do(
											$author$project$Action$ShufflePile(realId)),
										'Shuffle'),
										A2(
										$author$project$Menu$item,
										_do(
											$author$project$Action$FlipPile(realId)),
										'Flip'),
										A2(
										$author$project$Menu$item,
										_do(
											$author$project$Action$RotatePile(realId)),
										'Rotate'),
										A2(
										$author$project$Menu$enabled,
										p.stack.n === 1,
										A2(
											$author$project$Menu$item,
											_do(
												$author$project$Action$DuplicatePile(realId)),
											'Duplicate')),
										$author$project$Menu$divider,
										A2(
										$author$project$Menu$item,
										_do(
											$author$project$Action$RemovePile(realId)),
										'Remove')
									]));
						}
					}
				}()
				]));
	});
var $author$project$Token$viewDetailTable = F2(
	function (_do, _v0) {
		var tid = _v0.tid;
		var name = _v0.name;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Token$viewDetail(name),
					function () {
					var _v1 = $author$project$Tid$toId(tid);
					if (_v1.$ === 'Nothing') {
						return $author$project$Menu$viewCaption('Waiting for server...');
					} else {
						var realId = _v1.a;
						return $author$project$Menu$view(
							_List_fromArray(
								[
									A2(
									$author$project$Menu$item,
									_do(
										$author$project$Action$RemoveToken(realId)),
									'Remove')
								]));
					}
				}()
				]));
	});
var $author$project$Game$viewDetail = F2(
	function (_v0, selection) {
		var _do = _v0._do;
		var spec = _v0.spec;
		var game = _v0.game;
		switch (selection.$) {
			case 'Pile':
				var tid = selection.a;
				return A2(
					$elm$core$Maybe$map,
					A2($author$project$Pile$viewDetail, _do, spec),
					A2($elm$core$Dict$get, tid, game.piles));
			case 'Token':
				var tid = selection.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Token$viewDetailTable(_do),
					A2($elm$core$Dict$get, tid, game.tokens));
			case 'Hand':
				var tid = selection.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Hand$viewDetail(spec),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.face;
						},
						A2($author$project$Hand$get1, tid, game.hand)));
			case 'SelfAir':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Air$viewDetail(spec),
					game.air);
			case 'OpponentAir':
				var id = selection.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Air$viewDetail(spec),
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.air;
						},
						A2($elm$core$Dict$get, id, game.opponents)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Design$colorMenuGroupLabelForegroundCss = 'rgba(40, 40, 46, 0.3)';
var $author$project$Menu$viewGroupLabel = function (label) {
	return A4(
		$author$project$Font$trim,
		$elm$html$Html$div,
		{capHeight: 8, font: $author$project$Font$NunitoSans, leading: 16},
		_List_fromArray(
			[
				A2($author$project$Style$style, 'padding', '0 40px 8px'),
				A2($author$project$Style$style, 'font-weight', '900'),
				A2($author$project$Style$style, 'color', $author$project$Design$colorMenuGroupLabelForegroundCss),
				A2($author$project$Style$style, '-webkit-font-smoothing', 'antialiased'),
				A2($author$project$Style$style, '-moz-osx-font-smoothing', 'grayscale'),
				A2($author$project$Style$style, 'text-transform', 'uppercase'),
				A2($author$project$Style$style, 'letter-spacing', '0.08em')
			]),
		label);
};
var $author$project$Button$capsule = F2(
	function (action, capHeight) {
		var cs = $elm$core$String$fromFloat(capHeight);
		return A3(
			$author$project$Font$trim,
			$elm$html$Html$div,
			{capHeight: capHeight, font: $author$project$Font$NunitoSans, leading: capHeight},
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(action),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
						A2($elm$html$Html$Attributes$style, 'background', 'rgb(255 255 255 / 40%)'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '9000px'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'padding', '9px 16px 8px'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
						A2($elm$html$Html$Attributes$style, 'max-width', '100%')
					]),
				$author$project$Style$onActiveOpacity(0.4)));
	});
var $author$project$Button$capsuleText = F3(
	function (action, capHeight, s) {
		return A3(
			$author$project$Button$capsule,
			action,
			capHeight,
			_List_fromArray(
				[
					$elm$html$Html$text(s)
				]));
	});
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$Button$icon = function (action) {
	return $elm$html$Html$div(
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(action),
					A2($elm$html$Html$Attributes$style, 'width', '48px'),
					A2($elm$html$Html$Attributes$style, 'height', '48px'),
					A2($elm$html$Html$Attributes$style, 'background', 'rgb(255 255 255 / 40%)'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '24px'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2($elm$html$Html$Attributes$style, 'display', 'grid'),
					A2($elm$html$Html$Attributes$style, 'place-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'font-size', '24px'),
					A2($elm$html$Html$Attributes$style, 'line-height', '24px')
				]),
			$author$project$Style$onActiveOpacity(0.4)));
};
var $author$project$Button$iconByName = F2(
	function (action, name) {
		return A2(
			$author$project$Button$icon,
			action,
			_List_fromArray(
				[
					$author$project$Bootstrap$icon(name)
				]));
	});
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$pattern = $elm$html$Html$Attributes$stringProperty('pattern');
var $author$project$Floating$view = $elm$html$Html$div(
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'width', 'fit-content'),
			A2($elm$html$Html$Attributes$style, 'height', 'fit-content'),
			A2($elm$html$Html$Attributes$style, 'backdrop-filter', 'saturate(120%) blur(20px)'),
			A2($elm$html$Html$Attributes$style, 'background', 'rgba(240 240 240 / 44%)'),
			A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
			A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
			A2($elm$html$Html$Attributes$style, 'display', 'grid'),
			A2($elm$html$Html$Attributes$style, 'place-items', 'center'),
			A2(
			$elm$html$Html$Attributes$style,
			'box-shadow',
			A2(
				$elm$core$String$join,
				', ',
				_List_fromArray(
					['inset 0 0 0 0.5px rgb(0 0 0 / 12.5%)', 'inset 0 0 0 1px rgb(255 255 255 / 12.5%)', '0 4px 16px 0 rgb(0 0 0 / 6.25%)'])))
		]));
var $author$project$Roll$viewMoreRow = $elm$html$Html$div(
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'display', 'flex'),
			A2($elm$html$Html$Attributes$style, 'padding', '0 28px'),
			A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between')
		]));
var $author$project$Roll$viewRoll = F2(
	function (onRoll, roll) {
		return A2(
			$author$project$Button$icon,
			onRoll(roll.sides),
			_List_fromArray(
				[
					$author$project$Roll$viewBaseIcon(roll)
				]));
	});
var $author$project$Roll$viewMenu = F2(
	function (c, model) {
		var onRoll = c.onRoll;
		var onMore = c.onMore;
		var more = c.more;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2($elm$html$Html$Attributes$style, 'padding', '24px 44px'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
					A2($elm$html$Html$Attributes$style, 'color', $author$project$Design$colorMenuItemForegroundCss),
					A2(
					$elm$html$Html$Attributes$style,
					'pointer-events',
					c.enabled ? 'auto' : 'none'),
					A2(
					$elm$html$Html$Attributes$style,
					'opacity',
					c.enabled ? '100%' : '60%')
				]),
			_List_fromArray(
				[
					A2($author$project$Roll$viewRoll, onRoll, model.left),
					A2($author$project$Roll$viewRoll, onRoll, model.right),
					A2(
					$author$project$Button$iconByName,
					onMore(!more),
					more ? 'chevron-down' : 'chevron-up'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2($elm$html$Html$Attributes$style, 'bottom', '100%'),
							A2($elm$html$Html$Attributes$style, 'left', '16px'),
							A2($elm$html$Html$Attributes$style, 'transition', 'opacity 40ms, transform 250ms'),
							$elm$html$Html$Attributes$class(
							more ? 'roll-more-show' : 'roll-more-hide')
						]),
					_List_fromArray(
						[
							$author$project$Floating$view(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'flex'),
											A2($elm$html$Html$Attributes$style, 'width', '256px'),
											A2($elm$html$Html$Attributes$style, 'padding', '24px 0'),
											A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
											A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
											A2($elm$html$Html$Attributes$style, 'gap', '16px')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'display', 'flex'),
													A2($elm$html$Html$Attributes$style, 'padding', '0 20px 16px'),
													A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-start'),
													A2($elm$html$Html$Attributes$style, 'align-items', 'flex-end'),
													A2($elm$html$Html$Attributes$style, 'gap', '16px'),
													A2($elm$html$Html$Attributes$style, 'height', '64px')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'flex'),
															A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
															A2($elm$html$Html$Attributes$style, 'gap', '8px')
														]),
													_List_fromArray(
														[
															A4(
															$author$project$Font$trim,
															$elm$html$Html$div,
															{capHeight: 8, font: $author$project$Font$NunitoSans, leading: 16},
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$style, 'font-weight', '900'),
																	A2($elm$html$Html$Attributes$style, 'color', $author$project$Design$colorMenuGroupLabelForegroundCss),
																	A2($elm$html$Html$Attributes$style, '-webkit-font-smoothing', 'antialiased'),
																	A2($elm$html$Html$Attributes$style, '-moz-osx-font-smoothing', 'grayscale'),
																	A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
																	A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.08em'),
																	A2($elm$html$Html$Attributes$style, 'text-align', 'center')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Custom')
																])),
															A2(
															$elm$html$Html$form,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onSubmit(c.onRollCustom)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('text'),
																			$elm$html$Html$Attributes$id(c.customInputId),
																			$elm$html$Html$Attributes$pattern('[2-9]|[1-9]\\d{1,2}'),
																			$elm$html$Html$Attributes$placeholder('10'),
																			$elm$html$Html$Attributes$value(c.customInput),
																			$elm$html$Html$Attributes$disabled(!more),
																			$elm$html$Html$Events$onInput(c.onCustomInput),
																			A2($elm$html$Html$Attributes$style, 'width', '64px'),
																			A2($elm$html$Html$Attributes$style, 'height', '32px'),
																			A2($elm$html$Html$Attributes$style, 'padding', '9px 8px'),
																			A2($elm$html$Html$Attributes$style, 'border', 'none'),
																			A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
																			A2($elm$html$Html$Attributes$style, 'font', '600 14px/16px \'Nunito Sans\', sans-serif'),
																			A2($elm$html$Html$Attributes$style, '-webkit-appearance', 'none'),
																			A2($elm$html$Html$Attributes$style, 'appearance', 'none'),
																			A2($elm$html$Html$Attributes$style, 'text-align', 'center')
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'flex', '0 0 56px'),
															A2($elm$html$Html$Attributes$style, 'height', '32px'),
															A2($elm$html$Html$Attributes$style, 'width', '56px'),
															A2($elm$html$Html$Attributes$style, 'display', 'grid'),
															A2($elm$html$Html$Attributes$style, 'place-items', 'center')
														]),
													_List_fromArray(
														[
															A3($author$project$Button$capsuleText, c.onRollCustom, 10, 'Roll')
														]))
												])),
											$author$project$Roll$viewMoreRow(
											_List_fromArray(
												[
													A2(
													$author$project$Roll$viewRoll,
													onRoll,
													A2(
														$author$project$Roll$Roll,
														2,
														$elm$core$Maybe$Just(1))),
													A2(
													$author$project$Roll$viewRoll,
													onRoll,
													A2(
														$author$project$Roll$Roll,
														4,
														$elm$core$Maybe$Just(4))),
													A2(
													$author$project$Roll$viewRoll,
													onRoll,
													A2(
														$author$project$Roll$Roll,
														6,
														$elm$core$Maybe$Just(6)))
												])),
											$author$project$Roll$viewMoreRow(
											_List_fromArray(
												[
													A2(
													$author$project$Roll$viewRoll,
													onRoll,
													A2(
														$author$project$Roll$Roll,
														12,
														$elm$core$Maybe$Just(12))),
													A2(
													$author$project$Roll$viewRoll,
													onRoll,
													A2(
														$author$project$Roll$Roll,
														20,
														$elm$core$Maybe$Just(20))),
													A2(
													$author$project$Roll$viewRoll,
													onRoll,
													A2(
														$author$project$Roll$Roll,
														100,
														$elm$core$Maybe$Just(100)))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Design$bgColor = function (c) {
	return 'linear-gradient(' + (c + (', ' + (c + ')')));
};
var $author$project$Game$viewSelf = function (_v0) {
	var self = _v0.self;
	var seat = _v0.seat;
	if (self.$ === 'Nothing') {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var id = self.a.id;
		var nickname = self.a.nickname;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'display', 'flex'),
					A2(
					$author$project$Style$style,
					'background',
					A2(
						$elm$core$String$join,
						', ',
						_List_fromArray(
							[
								$author$project$Design$bgColor('hsl(0, 0%, 100%, 50%)'),
								$author$project$Design$bgColor('var(--self-color)')
							]))),
					A2($author$project$Style$style, 'padding', '16px 24px')
				]),
			_List_fromArray(
				[
					$author$project$Player$viewPicture,
					A2($author$project$Player$viewNameplate, seat, nickname)
				]));
	}
};
var $author$project$Shell$DoSearchResult = function (a) {
	return {$: 'DoSearchResult', a: a};
};
var $author$project$Shell$FormSearchBlur = {$: 'FormSearchBlur'};
var $author$project$Shell$FormSearchChanged = function (a) {
	return {$: 'FormSearchChanged', a: a};
};
var $author$project$Shell$FormSearchSummon = {$: 'FormSearchSummon'};
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $author$project$Shell$helpDef = F2(
	function (term, def) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$dt,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'float', 'left'),
						A2($author$project$Style$style, 'font-weight', '700')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(term)
					])),
				A2(
				$elm$html$Html$dd,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'padding', '0 0 0 64px'),
						A2($author$project$Style$style, 'margin', '0 0 12px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(def)
					]))
			]);
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Shell$summonHelp = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($author$project$Style$style, 'padding', '0 40px'),
			A2($author$project$Style$style, 'color', $author$project$Design$colorMenuItemForegroundCss)
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'margin', '4px 0 12px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Search notation:')
				])),
			A2(
			$elm$html$Html$dl,
			_List_Nil,
			_Utils_ap(
				A2($author$project$Shell$helpDef, 'pop tar', 'Find words starting with ‘pop’ and ‘tar’'),
				_Utils_ap(
					A2($author$project$Shell$helpDef, '#1234', 'Card number 1234 from the Infinite Deck'),
					_Utils_ap(
						A2($author$project$Shell$helpDef, '$Mana', 'Make a Mana token'),
						A2($author$project$Shell$helpDef, 'd8', 'Roll an 8-sided die')))))
		]));
var $author$project$Selection$toSearchResult = function (sel) {
	if (sel.$ === 'SearchResult') {
		var res = sel.a;
		return $elm$core$Maybe$Just(res);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Menu$selected = F2(
	function (b, it) {
		if (it.$ === 'Item') {
			var v = it.a;
			return $author$project$Menu$Item(
				_Utils_update(
					v,
					{isSelected: b}));
		} else {
			return it;
		}
	});
var $author$project$Card$viewIcon = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($author$project$Style$style, 'display', 'grid'),
			A2($author$project$Style$style, 'place-items', 'center'),
			A2($author$project$Style$style, 'width', '48px'),
			A2($author$project$Style$style, 'height', '48px'),
			A2($author$project$Style$style, 'font-size', '24px'),
			A2($author$project$Style$style, 'line-height', '24px')
		]),
	_List_fromArray(
		[
			$author$project$Bootstrap$icon('file-text')
		]));
var $author$project$Deck$viewIcon = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($author$project$Style$style, 'display', 'grid'),
			A2($author$project$Style$style, 'place-items', 'center'),
			A2($author$project$Style$style, 'width', '48px'),
			A2($author$project$Style$style, 'height', '48px'),
			A2($author$project$Style$style, 'font-size', '24px'),
			A2($author$project$Style$style, 'line-height', '24px')
		]),
	_List_fromArray(
		[
			$author$project$Bootstrap$icon('files')
		]));
var $author$project$Roll$viewIcon = function (n) {
	return $author$project$Roll$viewBaseIcon(
		A2(
			$author$project$Roll$Roll,
			n,
			$elm$core$Maybe$Just(n)));
};
var $author$project$Token$viewIcon = function (name) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2(
				$author$project$Style$style,
				'width',
				$elm$core$String$fromInt($author$project$Token$widthSmall) + 'px'),
				A2(
				$author$project$Style$style,
				'height',
				$elm$core$String$fromInt($author$project$Token$widthSmall) + 'px'),
				A2($author$project$Style$style, 'border-radius', '1000px'),
				A2(
				$author$project$Style$style,
				'background',
				$author$project$ColorExtras$toCss($author$project$Design$colorTokenEdge)),
				A2($author$project$Style$style, 'padding', '1px')
			]),
		_List_fromArray(
			[
				A2($author$project$Token$viewIconBase, false, name)
			]));
};
var $author$project$SearchResult$viewIcon = function (result) {
	switch (result.$) {
		case 'CardResult':
			var item = result.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'transform', 'scale(0.75)')
					]),
				_List_fromArray(
					[$author$project$Card$viewIcon]));
		case 'DeckResult':
			var name = result.a.name;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'transform', 'scale(0.75)')
					]),
				_List_fromArray(
					[$author$project$Deck$viewIcon]));
		case 'Roll':
			var n = result.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'transform', 'scale(0.75)')
					]),
				_List_fromArray(
					[
						$author$project$Roll$viewIcon(n)
					]));
		default:
			var s = result.a;
			return $author$project$Token$viewIcon(s);
	}
};
var $author$project$SearchResult$viewLabel = function (result) {
	switch (result.$) {
		case 'CardResult':
			var item = result.a;
			return $elm$html$Html$text(item.title);
		case 'DeckResult':
			var name = result.a.name;
			return $elm$html$Html$text(name);
		case 'Roll':
			var n = result.a;
			return $elm$html$Html$text(
				'd' + $elm$core$String$fromInt(n));
		default:
			var s = result.a;
			return $elm$html$Html$text(s);
	}
};
var $author$project$SearchResult$viewCaption = function (card) {
	return $elm$html$Html$text(card.body);
};
var $author$project$Menu$withCaption = F2(
	function (h, it) {
		if (it.$ === 'Item') {
			var v = it.a;
			return $author$project$Menu$Item(
				_Utils_update(
					v,
					{
						caption: $elm$core$Maybe$Just(h)
					}));
		} else {
			return it;
		}
	});
var $author$project$SearchResult$withCaption = F2(
	function (result, item) {
		if (result.$ === 'CardResult') {
			var card = result.a;
			return A2(
				$author$project$Menu$withCaption,
				$author$project$SearchResult$viewCaption(card),
				item);
		} else {
			return item;
		}
	});
var $author$project$Menu$withIcon = F2(
	function (h, it) {
		if (it.$ === 'Item') {
			var v = it.a;
			return $author$project$Menu$Item(
				_Utils_update(
					v,
					{
						icon: $elm$core$Maybe$Just(h)
					}));
		} else {
			return it;
		}
	});
var $author$project$SearchResult$view = F3(
	function (summon, sel, result) {
		return A2(
			$author$project$Menu$selected,
			_Utils_eq(
				sel,
				$elm$core$Maybe$Just(result)),
			A2(
				$author$project$SearchResult$withCaption,
				result,
				A2(
					$author$project$Menu$withIcon,
					$author$project$SearchResult$viewIcon(result),
					A2(
						$author$project$Menu$itemHtml,
						summon(result),
						$author$project$SearchResult$viewLabel(result)))));
	});
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Shell$viewInput = function (c) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Events$onSubmit(c.onSubmit),
				A2($author$project$Style$style, 'width', '224px'),
				A2($author$project$Style$style, 'height', '32px'),
				A2($author$project$Style$style, 'margin', '0 auto 8px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$value(c.value),
						$elm$html$Html$Events$onInput(c.onInput),
						$elm$html$Html$Events$onBlur(c.onBlur),
						$elm$html$Html$Attributes$placeholder(c.placeholder),
						A2($author$project$Style$style, 'width', '100%'),
						A2($author$project$Style$style, 'height', '100%'),
						A2($author$project$Style$style, 'padding', 'calc(11px - 0.2023em) 8px calc(5px + 0.2023em)'),
						A2($author$project$Style$style, 'border', 'none'),
						A2($author$project$Style$style, 'border-radius', '8px'),
						A2($author$project$Style$style, 'font', '600 14px/16px \'Nunito Sans\', sans-serif'),
						A2($author$project$Style$style, '-webkit-appearance', 'none'),
						A2($author$project$Style$style, 'appearance', 'none')
					]),
				_List_Nil)
			]));
};
var $author$project$Shell$viewSideBarDefault = function (h) {
	var sel = A2($elm$core$Maybe$andThen, $author$project$Selection$toSearchResult, h.state.selection);
	var progress = function () {
		var _v1 = _Utils_Tuple2(h.indexCards, h.indexDecks);
		if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'display', 'inline-block'),
							A2($author$project$Style$style, 'width', '14px'),
							A2($author$project$Style$style, 'height', '14px'),
							A2($author$project$Style$style, 'position', 'relative'),
							A2($author$project$Style$style, 'vertical-align', 'top'),
							A2($author$project$Style$style, 'color', $author$project$Design$colorMenuItemForegroundCss),
							A2($author$project$Style$style, 'margin-left', '0.5em')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($author$project$Style$style, 'position', 'absolute'),
									A2($author$project$Style$style, 'transform', 'scale(0.5)'),
									A2($author$project$Style$style, 'top', '-7px'),
									A2($author$project$Style$style, 'left', '-7px'),
									A2($author$project$Style$style, 'width', '28px'),
									A2($author$project$Style$style, 'height', '28px')
								]),
							_List_fromArray(
								[$author$project$Progress$view]))
						]))
				]);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Style$style, 'display', 'flex'),
				A2($author$project$Style$style, 'flex-direction', 'column'),
				A2($author$project$Style$style, 'height', '100%')
			]),
		_List_fromArray(
			[
				$author$project$Menu$viewGroupLabel(
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$text('Summon')
						]),
					progress)),
				$author$project$Shell$viewInput(
				{onBlur: $author$project$Shell$FormSearchBlur, onInput: $author$project$Shell$FormSearchChanged, onSubmit: $author$project$Shell$FormSearchSummon, placeholder: 'e.g. \'Glue\', \'d8\'', value: h.formSearch}),
				function () {
				if ($author$project$Shell$showRecentlySummoned(h)) {
					return _Utils_eq(h.recentlySummoned, _List_Nil) ? $author$project$Shell$summonHelp : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($author$project$Style$style, 'flex', '1 0 auto'),
								A2($author$project$Style$style, 'display', 'flex'),
								A2($author$project$Style$style, 'flex-direction', 'column'),
								A2($author$project$Style$style, 'padding-top', '32px')
							]),
						_List_fromArray(
							[
								$author$project$Menu$viewGroupLabel(
								_List_fromArray(
									[
										$elm$html$Html$text('Recent')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($author$project$Style$style, 'flex', '1 0 0'),
										A2($author$project$Style$style, 'align-self', 'stretch'),
										A2($author$project$Style$style, 'overflow-y', 'auto')
									]),
								_List_fromArray(
									[
										$author$project$Menu$view(
										A2(
											$elm$core$List$map,
											A2($author$project$SearchResult$view, $author$project$Shell$DoSearchResult, sel),
											h.recentlySummoned))
									]))
							]));
				} else {
					if (_Utils_eq(h.searchResults, _List_Nil)) {
						var _v0 = _Utils_Tuple2(h.indexCards, h.indexDecks);
						if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
							return $author$project$Menu$viewCaption('No results.');
						} else {
							return $author$project$Menu$viewCaption('Loading index…');
						}
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$id('search-results'),
									A2($author$project$Style$style, 'flex', '1 0 0'),
									A2($author$project$Style$style, 'align-self', 'stretch'),
									A2($author$project$Style$style, 'overflow-y', 'auto')
								]),
							_List_fromArray(
								[
									$author$project$Menu$view(
									A2(
										$elm$core$List$map,
										A2($author$project$SearchResult$view, $author$project$Shell$DoSearchResult, sel),
										h.searchResults))
								]));
					}
				}
			}()
			]));
};
var $author$project$Shell$viewSideBar = F2(
	function (_v0, h) {
		var spec = _v0.spec;
		var announcement = _v0.announcement;
		var tz = _v0.tz;
		var now = _v0.now;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Style$style, 'display', 'flex'),
					A2($author$project$Style$style, 'width', '100%'),
					A2($author$project$Style$style, 'height', '100%'),
					A2($author$project$Style$style, 'flex-direction', 'column'),
					A2($author$project$Style$style, 'background', $author$project$Design$colorSideBarCss),
					$elm$html$Html$Attributes$class('sidebar')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'flex', '0 0 80px')
						]),
					_List_fromArray(
						[$author$project$Design$logoHtml])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'flex', '1 0 auto')
						]),
					_List_fromArray(
						[
							_Utils_eq(h.state.game.self, $elm$core$Maybe$Nothing) ? A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Menu$viewGroupLabel(
									_List_fromArray(
										[
											$elm$html$Html$text('Name Yourself')
										])),
									$author$project$Menu$input(
									{onInput: $author$project$Shell$SetNick, placeholder: h.nickPlaceholder, value: h.nick}),
									$author$project$Menu$view(
									_List_fromArray(
										[
											A2($author$project$Menu$item, $author$project$Shell$Join, 'Join the Game')
										]))
								])) : A2(
							$elm$core$Maybe$withDefault,
							$author$project$Shell$viewSideBarDefault(h),
							A2(
								$elm$core$Maybe$map,
								function (d) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($author$project$Style$style, 'display', 'flex'),
												A2($author$project$Style$style, 'flex-direction', 'column'),
												A2($author$project$Style$style, 'height', '100%')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($author$project$Style$style, 'flex', '1 0 0px'),
														A2($author$project$Style$style, 'overflow-y', 'auto')
													]),
												_List_fromArray(
													[d]))
											]));
								},
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Game$viewDetail(
										{_do: $author$project$Shell$Do, game: h.state.game, spec: spec}),
									h.state.selection)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'flex', '0 0 96px')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Roll$viewMenu,
							{
								customInput: h.rollCustomInput,
								customInputId: $author$project$Shell$elementId.rollCustomInput,
								enabled: !_Utils_eq(h.state.game.self, $elm$core$Maybe$Nothing),
								more: h.rollMore,
								onCustomInput: $author$project$Shell$RollCustomInput,
								onMore: $author$project$Shell$RollMore,
								onRoll: $author$project$Shell$RollBuiltIn,
								onRollCustom: $author$project$Shell$RollCustom
							},
							h.state.game.dice)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'flex', '0 0 auto'),
							A2($author$project$Style$style, 'background', $author$project$Design$colorChatCss)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($author$project$Style$style, 'padding', '16px 40px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('\n                    Drag the top card from a pile of cards,\n                    or double-click to draw.\n                    Hold a number key to take multiple cards;\n                    hold Alt/Option to take the whole pile.\n                  '),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('\n                    Tap Shift while dragging to turn the cards face down.\n                    Hold Shift to turn them face up.\n                  ')
								]))
						])),
					function () {
					if (announcement.$ === 'Nothing') {
						return $elm$html$Html$text('');
					} else {
						var message = announcement.a.message;
						var time = announcement.a.time;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($author$project$Style$style, 'flex', '0 0 auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($author$project$Style$style, 'margin', '0 16px 16px'),
											A2($author$project$Style$style, 'border', '2px solid var(--self-color)'),
											A2($author$project$Style$style, 'padding', '16px')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($author$project$Style$style, 'margin', '0 0 16px')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3($author$project$Announcement$eta, tz, now, time))
												])),
											$elm$html$Html$text(message)
										]))
								]));
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'flex', '0 0 112px')
						]),
					_List_fromArray(
						[
							$author$project$Game$viewSelf(h.state.game)
						]))
				]));
	});
var $author$project$Token$viewTable = F2(
	function (_v0, _v1) {
		var drag = _v0.drag;
		var onSelect = _v0.onSelect;
		var isSelected = _v0.isSelected;
		var seat = _v0.seat;
		var tid = _v1.tid;
		var name = _v1.name;
		var pos = _v1.pos;
		var posScreen = A2($author$project$Seat$pointToScreenFor, seat, pos);
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_Utils_ap(
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								$author$project$Geometry$translateTo(posScreen)
							])),
						onSelect(tid)
					]),
				function () {
					var _v2 = $author$project$Tid$toId(tid);
					if (_v2.$ === 'Nothing') {
						return _List_Nil;
					} else {
						var realId = _v2.a;
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$draggable('true'),
								$author$project$DND$onDragStart(
								drag(
									{
										pos: posScreen,
										revert: A2($author$project$Action$PutOnTable, pos, true),
										start: $author$project$Action$PickUpToken(realId)
									}))
							]);
					}
				}()),
			_List_fromArray(
				[
					$author$project$Token$viewBaseSmall(
					{
						isSelected: isSelected(tid),
						isVirtual: _Utils_eq(
							$author$project$Tid$toId(tid),
							$elm$core$Maybe$Nothing),
						name: name
					})
				]));
	});
var $author$project$Game$viewTokens = function (_v0) {
	var drag = _v0.drag;
	var onSelect = _v0.onSelect;
	var isSelected = _v0.isSelected;
	var game = _v0.game;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Token$viewTable(
				{drag: drag, isSelected: isSelected, onSelect: onSelect, seat: game.seat}),
			$elm$core$Dict$values(game.tokens)));
};
var $author$project$Shell$view = F2(
	function (config, h) {
		var spec = config.spec;
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$author$project$Pointer$onDown($author$project$Shell$PointerDown),
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					$author$project$Shell$seatClass(h.state.game))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$fill(
							$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$Design$colorPlayArea)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(1168),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(988)
						]),
					_List_Nil),
					A2(
					$elm_community$typed_svg$TypedSvg$Core$foreignObject,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, 880, 0)
								])),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(288),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(988)
						]),
					_List_fromArray(
						[
							A2($author$project$Shell$viewSideBar, config, h)
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$id('dragarea'),
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, 80, 80)
								])),
							$author$project$Pointer$onMove($author$project$Shell$PointerMove),
							$elm_community$typed_svg$TypedSvg$Events$onMouseUp($author$project$Shell$MouseUp),
							$author$project$Pointer$onLeave($author$project$Shell$PointerLeave),
							$author$project$Pointer$onLostCapture($author$project$Shell$LostPointerCapture)
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$rect,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$fill(
									$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$Design$colorTable)),
									A2(
									$author$project$Style$style,
									'filter',
									'drop-shadow(0 8px 16px ' + ($author$project$ColorExtras$toCss($author$project$Design$colorTableShadow) + ')')),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$width($author$project$Table$size),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$height($author$project$Table$size),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$rx(8),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$ry(8),
									$elm_community$typed_svg$TypedSvg$Events$onClick(
									$author$project$Shell$Select($elm$core$Maybe$Nothing))
								]),
							_List_Nil),
							$author$project$Game$viewOpponents(h.state.game),
							$author$project$Hand$view(
							{
								drag: $author$project$Shell$DragStart($author$project$Table$scale / $author$project$Card$scaleInHand),
								hand: h.state.game.hand,
								hover: A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Shell$drop(h.state.game),
										function ($) {
											return $.pos;
										}),
									h.drag),
								isSelected: function (tid) {
									return _Utils_eq(
										h.state.selection,
										$elm$core$Maybe$Just(
											$author$project$Selection$Hand(tid)));
								},
								liftAll: !h.liftNum,
								onSelect: A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, h.onSelect, $author$project$Shell$Select),
										$elm$core$Maybe$Just),
									$author$project$Selection$Hand),
								spec: spec
							}),
							$author$project$Game$viewPiles(
							{
								_do: $author$project$Shell$Do,
								drag: $author$project$Shell$DragStart(1),
								dragTarget: A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Shell$drop(h.state.game),
										function ($) {
											return $.action;
										}),
									h.drag),
								enter: $author$project$Shell$EnterPile,
								game: h.state.game,
								isSelected: function (tid) {
									return _Utils_eq(
										h.state.selection,
										$elm$core$Maybe$Just(
											$author$project$Selection$Pile(tid)));
								},
								leave: $author$project$Shell$LeavePile,
								lift: $author$project$Shell$inLift(h.drag) ? h.liftNum : 0,
								onSelect: A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, h.onSelect, $author$project$Shell$Select),
										$elm$core$Maybe$Just),
									$author$project$Selection$Pile),
								peerLifts: $author$project$Peer$invertLifts(h.peerLifts),
								spec: spec
							}),
							$author$project$Game$viewTokens(
							{
								drag: $author$project$Shell$DragStart(1),
								game: h.state.game,
								isSelected: function (tid) {
									return _Utils_eq(
										h.state.selection,
										$elm$core$Maybe$Just(
											$author$project$Selection$Token(tid)));
								},
								onSelect: A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, h.onSelect, $author$project$Shell$Select),
										$elm$core$Maybe$Just),
									$author$project$Selection$Token)
							}),
							$author$project$Game$viewAirOpponents(
							{
								game: h.state.game,
								isSelected: function (id) {
									return _Utils_eq(
										h.state.selection,
										$elm$core$Maybe$Just(
											$author$project$Selection$OpponentAir(id)));
								},
								postab: h.pointers,
								spec: spec
							}),
							$author$project$Game$viewAirSelf(
							{
								game: h.state.game,
								isSelected: _Utils_eq(
									h.state.selection,
									$elm$core$Maybe$Just($author$project$Selection$SelfAir)),
								pos: A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Shell$drop(h.state.game),
										function ($) {
											return $.pos;
										}),
									h.drag),
								spec: spec
							}),
							A2($author$project$Shell$viewAnimations, h, spec),
							A2($author$project$Shell$viewPointers, h.state.game, h.pointers)
						])),
					$author$project$Shell$viewJoinOverlay(
					!_Utils_eq(h.state.game.self, $elm$core$Maybe$Nothing))
				]));
	});
var $author$project$Main$viewAnnouncement = F3(
	function (tz, now, ann) {
		if (ann.$ === 'Nothing') {
			return $elm$html$Html$text('');
		} else {
			var message = ann.a.message;
			var time = ann.a.time;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($author$project$Style$style, 'margin', '0 auto 40px'),
						A2($author$project$Style$style, 'width', '403px'),
						A2($author$project$Style$style, 'border', '2px solid var(--self-color)'),
						A2($author$project$Style$style, 'padding', '16px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($author$project$Style$style, 'margin', '0 0 16px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Announcement$eta, tz, now, time))
							])),
						$elm$html$Html$text(message)
					]));
		}
	});
var $elm$core$Debug$toString = _Debug_toString;
var $author$project$Main$StartGame = function (a) {
	return {$: 'StartGame', a: a};
};
var $author$project$Card$viewPreview = function (_v0) {
	var spec = _v0.spec;
	var back = _v0.back;
	var front = _v0.front;
	return A2(
		$elm_community$typed_svg$TypedSvg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
						$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardInHandClipPath)'))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Face$viewScaledTo,
						{scale: $author$project$Card$scaleInHand, spec: spec},
						back),
						$author$project$Card$viewBorder(
						{color: $author$project$Design$colorCardBorder, shape: '#cardInHandShape', thickness: 2})
					])),
				A2(
				$elm_community$typed_svg$TypedSvg$g,
				_List_fromArray(
					[
						$elm_community$typed_svg$TypedSvg$Attributes$transform(
						_List_fromArray(
							[
								A2($elm_community$typed_svg$TypedSvg$Types$Translate, 40, 0)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$g,
						_List_fromArray(
							[
								$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
								$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardInHandShadowClipPath)')),
								A2($author$project$Style$style, 'filter', 'drop-shadow(0 0 3px #0000001F)')
							]),
						_List_fromArray(
							[
								A2(
								$elm_community$typed_svg$TypedSvg$g,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$clipPath(
										$elm_community$typed_svg$TypedSvg$Types$ClipPathFunc('url(#cardInHandClipPath)'))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Face$viewScaledTo,
										{scale: $author$project$Card$scaleInHand, spec: spec},
										front),
										$author$project$Card$viewBorder(
										{color: $author$project$Design$colorCardBorder, shape: '#cardInHandShape', thickness: 2})
									]))
							]))
					]))
			]));
};
var $author$project$Main$viewDeckPickerItem = F2(
	function (sp, deck) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Main$StartGame(deck.id)),
						A2($author$project$Style$style, 'display', 'flex'),
						A2($author$project$Style$style, 'flex-direction', 'column'),
						A2($author$project$Style$style, 'justify-content', 'flex-start'),
						A2($author$project$Style$style, 'align-items', 'center'),
						A2($author$project$Style$style, 'gap', '20px'),
						A2($author$project$Style$style, 'border-radius', '8px'),
						A2($author$project$Style$style, 'padding', '24px'),
						A2($author$project$Style$style, 'color', '#28282E')
					]),
				$author$project$Style$onHoverBackgroundColor($author$project$Design$colorMenuItemHighlight)),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$svg,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'display', 'block'),
							A2($author$project$Style$style, 'margin', '0 auto'),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(140),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(140),
							A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, 140, 140)
						]),
					_List_fromArray(
						[
							$author$project$Card$viewPreview(
							{back: deck.backSample, front: deck.frontSample, spec: sp}),
							$author$project$Defs$view
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'text-align', 'center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(deck.name)
						]))
				]));
	});
var $author$project$Main$viewDeckPicker = function (m) {
	var _v0 = m.availableDecks;
	if (_v0.$ === 'Nothing') {
		return $elm$html$Html$text('Loading available decks…');
	} else {
		if (_v0.a.$ === 'Err') {
			var err = _v0.a.a;
			return $elm$html$Html$text(
				$elm$core$Debug$toString(err));
		} else {
			if (!_v0.a.a.b) {
				return $elm$html$Html$text('No decks are available.');
			} else {
				var decks = _v0.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Style$style, 'overflow-y', 'auto'),
							A2($author$project$Style$style, 'justify-self', 'stretch'),
							A2($author$project$Style$style, 'padding-bottom', '32px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($author$project$Style$style, 'display', 'grid'),
									A2($author$project$Style$style, 'width', '704px'),
									A2($author$project$Style$style, 'grid', '224px / repeat(auto-fit, 224px)'),
									A2($author$project$Style$style, 'gap', '16px'),
									A2($author$project$Style$style, 'justify-content', 'center')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Main$viewDeckPickerItem(
									$author$project$Main$spec(m.measures)),
								decks))
						]));
			}
		}
	}
};
var $author$project$Main$view = function (m) {
	return {
		body: _List_fromArray(
			[
				function () {
				var _v0 = m.state;
				switch (_v0.$) {
					case 'Welcome':
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($author$project$Style$style, 'display', 'flex'),
									A2($author$project$Style$style, 'flex-direction', 'column'),
									A2($author$project$Style$style, 'height', '100%'),
									A2($author$project$Style$style, 'min-height', '100%')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($author$project$Style$style, 'margin', '0 auto 20px'),
											A2($author$project$Style$style, 'width', '203px')
										]),
									_List_fromArray(
										[$author$project$Design$logoHtml])),
									A3($author$project$Main$viewAnnouncement, m.tz, m.now, m.announcement),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($author$project$Style$style, 'margin', '0 auto 40px'),
											A2($author$project$Style$style, 'width', '203px'),
											A2($author$project$Style$style, 'text-align', 'center')
										]),
									_List_fromArray(
										[
											$author$project$Menu$viewGroupLabel(
											_List_fromArray(
												[
													$elm$html$Html$text('Name Yourself')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(m.nick),
													$elm$html$Html$Events$onInput($author$project$Main$SetNick),
													$elm$html$Html$Attributes$placeholder(m.nickPlaceholder),
													A2($author$project$Style$style, 'width', '100%'),
													A2($author$project$Style$style, 'padding', 'calc(11px - 0.2023em) 8px calc(5px + 0.2023em)'),
													A2($author$project$Style$style, 'border', 'none'),
													A2($author$project$Style$style, 'border-radius', '8px'),
													A2($author$project$Style$style, 'font', '600 14px/16px \'Nunito Sans\', sans-serif'),
													A2($author$project$Style$style, '-webkit-appearance', 'none'),
													A2($author$project$Style$style, 'appearance', 'none'),
													A2($author$project$Style$style, 'color', '#28282E'),
													A2($author$project$Style$style, 'text-align', 'center')
												]),
											_List_Nil)
										])),
									$author$project$Main$viewDeckPicker(m)
								]));
					case 'StartingGame':
						return $elm$html$Html$text('Starting game...');
					case 'LoadingGame':
						return $elm$html$Html$text('Loading game...');
					default:
						var shell = _v0.a;
						return A2(
							$elm_community$typed_svg$TypedSvg$svg,
							_List_fromArray(
								[
									A2($author$project$Style$style, 'display', 'block'),
									A2($author$project$Style$style, 'margin', '0 auto'),
									A2($author$project$Style$style, 'max-width', '100vw'),
									A2($author$project$Style$style, 'max-height', '100vh'),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(1168),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(988),
									A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, 1168, 988)
								]),
							_List_fromArray(
								[
									A2(
									$elm_community$typed_svg$TypedSvg$Core$map,
									$author$project$Main$Shell,
									A2(
										$author$project$Shell$view,
										{
											announcement: m.announcement,
											now: m.now,
											spec: $author$project$Main$spec(m.measures),
											tz: m.tz
										},
										shell)),
									$author$project$Defs$view
								]));
				}
			}(),
				$author$project$Measure$view(m.measures)
			]),
		title: 'Spelbord'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{init: $author$project$Main$init, onUrlChange: $author$project$Main$OnUrlChange, onUrlRequest: $author$project$Main$OnUrlRequest, subscriptions: $author$project$Main$subscriptions, update: $author$project$Main$update, view: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (userAgent) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (nickname) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (clientId) {
							return $elm$json$Json$Decode$succeed(
								{clientId: clientId, nickname: nickname, userAgent: userAgent});
						},
						A2($elm$json$Json$Decode$field, 'clientId', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'nickname', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'userAgent', $elm$json$Json$Decode$string)))(0)}});}(this));